/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import ApiClientBase from "@/services/api-client.base";

export class AiAssistantConfigurationClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    aiAssistantConfiguration(  cancelToken?: CancelToken | undefined): Promise<AiAssistantConfigurationDtoOperationResult> {
        let url_ = this.baseUrl + "/AiAssistantConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAiAssistantConfiguration(_response);
        });
    }

    protected processAiAssistantConfiguration(response: AxiosResponse): Promise<AiAssistantConfigurationDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiAssistantConfigurationDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateConfiguration(body: UpdateConfigurationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/AiAssistantConfiguration/UpdateConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateConfiguration(_response);
        });
    }

    protected processUpdateConfiguration(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class AiKnowledgeArticlesClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getArticles(  cancelToken?: CancelToken | undefined): Promise<AiKnowledgeArticleListItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/GetArticles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: AxiosResponse): Promise<AiKnowledgeArticleListItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeArticleListItemDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getArticleDetails(articleId: number , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeArticleDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/GetArticleDetails/{articleId}";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticleDetails(_response);
        });
    }

    protected processGetArticleDetails(response: AxiosResponse): Promise<AiKnowledgeArticleDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeArticleDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getArticleModificationDate(articleId: number , cancelToken?: CancelToken | undefined): Promise<DateTimeOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/GetArticleModificationDate/{articleId}";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticleModificationDate(_response);
        });
    }

    protected processGetArticleModificationDate(response: AxiosResponse): Promise<DateTimeOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateTimeOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getDistinctKnowledgeCategories(  cancelToken?: CancelToken | undefined): Promise<StringListOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/GetDistinctKnowledgeCategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDistinctKnowledgeCategories(_response);
        });
    }

    protected processGetDistinctKnowledgeCategories(response: AxiosResponse): Promise<StringListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StringListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createArticle(body: CreateArticleCommand | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/CreateArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateArticle(_response);
        });
    }

    protected processCreateArticle(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateArticle(body: UpdateArticleCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/UpdateArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateArticle(_response);
        });
    }

    protected processUpdateArticle(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    generateArticleMetadata(body: GenerateArticleMetadataQuery | undefined , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeArticleValuesDtoOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/GenerateArticleMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateArticleMetadata(_response);
        });
    }

    protected processGenerateArticleMetadata(response: AxiosResponse): Promise<AiKnowledgeArticleValuesDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeArticleValuesDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(articleId: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeArticles/Delete/{articleId}";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class AiKnowledgeProposalsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getObservations(body: GetKnowledgeObservationsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeObservationListItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/GetObservations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetObservations(_response);
        });
    }

    protected processGetObservations(response: AxiosResponse): Promise<AiKnowledgeObservationListItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeObservationListItemDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getProposalDetails(proposalId: number , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeProposalDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/GetProposalDetails/{proposalId}";
        if (proposalId === undefined || proposalId === null)
            throw new Error("The parameter 'proposalId' must be defined.");
        url_ = url_.replace("{proposalId}", encodeURIComponent("" + proposalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProposalDetails(_response);
        });
    }

    protected processGetProposalDetails(response: AxiosResponse): Promise<AiKnowledgeProposalDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeProposalDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getArticleReview(articleId: number , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeArticleReviewDtoOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/GetArticleReview/{articleId}";
        if (articleId === undefined || articleId === null)
            throw new Error("The parameter 'articleId' must be defined.");
        url_ = url_.replace("{articleId}", encodeURIComponent("" + articleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArticleReview(_response);
        });
    }

    protected processGetArticleReview(response: AxiosResponse): Promise<AiKnowledgeArticleReviewDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeArticleReviewDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getFragmentForEdit(proposalId: number , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeFragmentEditDtoOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/GetFragmentForEdit/{proposalId}";
        if (proposalId === undefined || proposalId === null)
            throw new Error("The parameter 'proposalId' must be defined.");
        url_ = url_.replace("{proposalId}", encodeURIComponent("" + proposalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFragmentForEdit(_response);
        });
    }

    protected processGetFragmentForEdit(response: AxiosResponse): Promise<AiKnowledgeFragmentEditDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeFragmentEditDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    approveProposal(body: ApproveKnowledgeProposalCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/ApproveProposal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveProposal(_response);
        });
    }

    protected processApproveProposal(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    rejectProposal(body: RejectKnowledgeProposalCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/RejectProposal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRejectProposal(_response);
        });
    }

    protected processRejectProposal(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    prepareFragmentAgain(proposalId: number , cancelToken?: CancelToken | undefined): Promise<AiKnowledgeFragmentPreparedDtoOperationResult> {
        let url_ = this.baseUrl + "/AiKnowledgeProposals/PrepareFragmentAgain/{proposalId}";
        if (proposalId === undefined || proposalId === null)
            throw new Error("The parameter 'proposalId' must be defined.");
        url_ = url_.replace("{proposalId}", encodeURIComponent("" + proposalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrepareFragmentAgain(_response);
        });
    }

    protected processPrepareFragmentAgain(response: AxiosResponse): Promise<AiKnowledgeFragmentPreparedDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AiKnowledgeFragmentPreparedDtoOperationResult>(null as any);
    }
}

export class ApplicationAccountsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: ApplicationAccountsGetAllQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountsGetAllQueryResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ApplicationAccountsGetAllQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountsGetAllQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @param organisationId (optional) 
     * @param driverId (optional) 
     * @return Success
     */
    getIdsAndNames(id: number | undefined, organisationId: number | undefined, driverId: number | undefined , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountsGetIdsAndNamesQueryResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/GetIdsAndNames?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (organisationId === null)
            throw new Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdsAndNames(_response);
        });
    }

    protected processGetIdsAndNames(response: AxiosResponse): Promise<ApplicationAccountsGetIdsAndNamesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountsGetIdsAndNamesQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountsGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ApplicationAccountsGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountsGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getDriversHistory(id: number , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountsGetDriverHistoryQueryResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/GetDriversHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriversHistory(_response);
        });
    }

    protected processGetDriversHistory(response: AxiosResponse): Promise<ApplicationAccountsGetDriverHistoryQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountsGetDriverHistoryQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: ApplicationAccountCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountCreateCommandResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ApplicationAccountCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: ApplicationAccountUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountUpdateCommandResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ApplicationAccountUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<ApplicationAccountsDeleteCommandResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ApplicationAccountsDeleteCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationAccountsDeleteCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/ApplicationAccounts/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class ArticlesClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAllByGroup(body: ArticlesGetAllByGroupQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ArticlesGetAllByGroupQueryResult> {
        let url_ = this.baseUrl + "/Articles/GetAllByGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllByGroup(_response);
        });
    }

    protected processGetAllByGroup(response: AxiosResponse): Promise<ArticlesGetAllByGroupQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticlesGetAllByGroupQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getDetails(body: ArticlesGetDetailsQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ArticlesGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Articles/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<ArticlesGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticlesGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getAllGroups(  cancelToken?: CancelToken | undefined): Promise<ArticlesGetAllGroupsQueryResult> {
        let url_ = this.baseUrl + "/Articles/GetAllGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllGroups(_response);
        });
    }

    protected processGetAllGroups(response: AxiosResponse): Promise<ArticlesGetAllGroupsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ArticlesGetAllGroupsQueryResult>(null as any);
    }
}

export class AuditClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: GetAuditEntriesQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetAuditEntriesQueryResult> {
        let url_ = this.baseUrl + "/Audit/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<GetAuditEntriesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAuditEntriesQueryResult>(null as any);
    }
}

export class AuthsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginDto | undefined , cancelToken?: CancelToken | undefined): Promise<TokenDtoOperationResult> {
        let url_ = this.baseUrl + "/Auths/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<TokenDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDtoOperationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: string | undefined , cancelToken?: CancelToken | undefined): Promise<TokenDtoOperationResult> {
        let url_ = this.baseUrl + "/Auths/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<TokenDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDtoOperationResult>(null as any);
    }
}

export class BonusCampaignsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: BonusCampaignListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<BonusCampaignListQueryResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<BonusCampaignListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BonusCampaignListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: BonusCampaignDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: BonusCampaignDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    details(id: number , cancelToken?: CancelToken | undefined): Promise<BonusCampaignDtoOperationResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/Details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<BonusCampaignDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BonusCampaignDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getForDigitalDocuments(body: GetCampaignsForDigitalDocumentsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<BonusCampaignDtoListOperationResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/GetForDigitalDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForDigitalDocuments(_response);
        });
    }

    protected processGetForDigitalDocuments(response: AxiosResponse): Promise<BonusCampaignDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BonusCampaignDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @param body (optional) 
     * @return Success
     */
    getForSignature(body: GetCampaignsForDigitalDocumentsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<BonusCampaignDtoListOperationResult> {
        let url_ = this.baseUrl + "/BonusCampaigns/GetForSignature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForSignature(_response);
        });
    }

    protected processGetForSignature(response: AxiosResponse): Promise<BonusCampaignDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BonusCampaignDtoListOperationResult>(null as any);
    }
}

export class CashFlowClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: CashFlowListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<CashFlowListQueryResult> {
        let url_ = this.baseUrl + "/CashFlow/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<CashFlowListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashFlowListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<CashFlowDtoOperationResult> {
        let url_ = this.baseUrl + "/CashFlow/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CashFlowDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashFlowDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: CashFlowDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/CashFlow/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(id: number, body: CashFlowDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/CashFlow/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/CashFlow/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    organisationBalance(id: number , cancelToken?: CancelToken | undefined): Promise<OrganisationBalanceDtoOperationResult> {
        let url_ = this.baseUrl + "/CashFlow/OrganisationBalance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOrganisationBalance(_response);
        });
    }

    protected processOrganisationBalance(response: AxiosResponse): Promise<OrganisationBalanceDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationBalanceDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/CashFlow/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param organisationId (optional) 
     * @param sourcePaymentType (optional) 
     * @param targetPaymentType (optional) 
     * @param amount (optional) 
     * @return Success
     */
    transferCash(organisationId: number | undefined, sourcePaymentType: CashFlowPaymentTypeEnum | undefined, targetPaymentType: CashFlowPaymentTypeEnum | undefined, amount: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/CashFlow/TransferCash?";
        if (organisationId === null)
            throw new Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (sourcePaymentType === null)
            throw new Error("The parameter 'sourcePaymentType' cannot be null.");
        else if (sourcePaymentType !== undefined)
            url_ += "sourcePaymentType=" + encodeURIComponent("" + sourcePaymentType) + "&";
        if (targetPaymentType === null)
            throw new Error("The parameter 'targetPaymentType' cannot be null.");
        else if (targetPaymentType !== undefined)
            url_ += "targetPaymentType=" + encodeURIComponent("" + targetPaymentType) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferCash(_response);
        });
    }

    protected processTransferCash(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class CashFlowReportClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAllReports(body: CashFlowReportListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<CashFlowReportListQueryResult> {
        let url_ = this.baseUrl + "/CashFlowReport/GetAllReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllReports(_response);
        });
    }

    protected processGetAllReports(response: AxiosResponse): Promise<CashFlowReportListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashFlowReportListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param cash (optional) 
     * @param depositCash (optional) 
     * @return Success
     */
    updateReport(id: number, cash: number | undefined, depositCash: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/CashFlowReport/UpdateReport/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (cash === null)
            throw new Error("The parameter 'cash' cannot be null.");
        else if (cash !== undefined)
            url_ += "cash=" + encodeURIComponent("" + cash) + "&";
        if (depositCash === null)
            throw new Error("The parameter 'depositCash' cannot be null.");
        else if (depositCash !== undefined)
            url_ += "depositCash=" + encodeURIComponent("" + depositCash) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReport(_response);
        });
    }

    protected processUpdateReport(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    checkOverdueCashFlowReports(  cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/CashFlowReport/CheckOverdueCashFlowReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOverdueCashFlowReports(_response);
        });
    }

    protected processCheckOverdueCashFlowReports(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }
}

export class CountriesClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getCountries(  cancelToken?: CancelToken | undefined): Promise<CountryDtoListOperationResult> {
        let url_ = this.baseUrl + "/Countries/GetCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: AxiosResponse): Promise<CountryDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryDtoListOperationResult>(null as any);
    }
}

export class DashboardClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param organisationIds (optional) 
     * @param date (optional) 
     * @return Success
     */
    getVehicleStatistics(organisationIds: number[] | undefined, date: string | undefined , cancelToken?: CancelToken | undefined): Promise<DashboardVehicleStatisticsDtoListOperationResult> {
        let url_ = this.baseUrl + "/Dashboard/GetVehicleStatistics?";
        if (organisationIds === null)
            throw new Error("The parameter 'organisationIds' cannot be null.");
        else if (organisationIds !== undefined)
            organisationIds && organisationIds.forEach(item => { url_ += "organisationIds=" + encodeURIComponent("" + item) + "&"; });
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleStatistics(_response);
        });
    }

    protected processGetVehicleStatistics(response: AxiosResponse): Promise<DashboardVehicleStatisticsDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardVehicleStatisticsDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param organisationIds (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getDriverStatistics(organisationIds: number[] | undefined, dateStart: string | undefined, dateEnd: string | undefined , cancelToken?: CancelToken | undefined): Promise<DashboardDriverShortStatisticsDtoListOperationResult> {
        let url_ = this.baseUrl + "/Dashboard/GetDriverStatistics?";
        if (organisationIds === null)
            throw new Error("The parameter 'organisationIds' cannot be null.");
        else if (organisationIds !== undefined)
            organisationIds && organisationIds.forEach(item => { url_ += "organisationIds=" + encodeURIComponent("" + item) + "&"; });
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent("" + dateStart) + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "dateEnd=" + encodeURIComponent("" + dateEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriverStatistics(_response);
        });
    }

    protected processGetDriverStatistics(response: AxiosResponse): Promise<DashboardDriverShortStatisticsDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardDriverShortStatisticsDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getPagedSearchResults(body: GetSearchingResultsQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<DashboardSearchEngineDtoListOperationResult> {
        let url_ = this.baseUrl + "/Dashboard/GetPagedSearchResults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPagedSearchResults(_response);
        });
    }

    protected processGetPagedSearchResults(response: AxiosResponse): Promise<DashboardSearchEngineDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardSearchEngineDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @param applicationAccountId (optional) 
     * @param applyForAllApps (optional) 
     * @param beginDate (optional) 
     * @param paymentTypeEnum (optional) 
     * @return Success
     */
    updatePreferredPaymentType(driverId: number | undefined, applicationAccountId: number | undefined, applyForAllApps: boolean | undefined, beginDate: string | undefined, paymentTypeEnum: PreferredPaymentTypeEnum | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Dashboard/UpdatePreferredPaymentType?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        if (applicationAccountId === null)
            throw new Error("The parameter 'applicationAccountId' cannot be null.");
        else if (applicationAccountId !== undefined)
            url_ += "applicationAccountId=" + encodeURIComponent("" + applicationAccountId) + "&";
        if (applyForAllApps === null)
            throw new Error("The parameter 'applyForAllApps' cannot be null.");
        else if (applyForAllApps !== undefined)
            url_ += "applyForAllApps=" + encodeURIComponent("" + applyForAllApps) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent("" + beginDate) + "&";
        if (paymentTypeEnum === null)
            throw new Error("The parameter 'paymentTypeEnum' cannot be null.");
        else if (paymentTypeEnum !== undefined)
            url_ += "paymentTypeEnum=" + encodeURIComponent("" + paymentTypeEnum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePreferredPaymentType(_response);
        });
    }

    protected processUpdatePreferredPaymentType(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @param applicationAccountId (optional) 
     * @return Success
     */
    getPaymentTypeHistory(driverId: number | undefined, applicationAccountId: number | undefined , cancelToken?: CancelToken | undefined): Promise<DateTimeListOperationResult> {
        let url_ = this.baseUrl + "/Dashboard/GetPaymentTypeHistory?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        if (applicationAccountId === null)
            throw new Error("The parameter 'applicationAccountId' cannot be null.");
        else if (applicationAccountId !== undefined)
            url_ += "applicationAccountId=" + encodeURIComponent("" + applicationAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentTypeHistory(_response);
        });
    }

    protected processGetPaymentTypeHistory(response: AxiosResponse): Promise<DateTimeListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateTimeListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getForSelectPayoffs(driverId: number , cancelToken?: CancelToken | undefined): Promise<DashboardPayoffSelectItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/Dashboard/GetForSelectPayoffs/{driverId}";
        if (driverId === undefined || driverId === null)
            throw new Error("The parameter 'driverId' must be defined.");
        url_ = url_.replace("{driverId}", encodeURIComponent("" + driverId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForSelectPayoffs(_response);
        });
    }

    protected processGetForSelectPayoffs(response: AxiosResponse): Promise<DashboardPayoffSelectItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardPayoffSelectItemDtoListOperationResult>(null as any);
    }
}

export class DayOffsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: DayOffListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DayOffListQueryResult> {
        let url_ = this.baseUrl + "/DayOffs/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DayOffListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DayOffListQueryResult>(null as any);
    }
}

export class DigitalDocumentsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @return Success
     */
    getSignatureDeviceInfo(  cancelToken?: CancelToken | undefined): Promise<GetMyUserInfoQueryResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetSignatureDeviceInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignatureDeviceInfo(_response);
        });
    }

    protected processGetSignatureDeviceInfo(response: AxiosResponse): Promise<GetMyUserInfoQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyUserInfoQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: SendDigitalDocumentToQueueCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createCashRegisterDisbursement(body: CreateCashRegisterDocumentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/CreateCashRegisterDisbursement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCashRegisterDisbursement(_response);
        });
    }

    protected processCreateCashRegisterDisbursement(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDigitalDocumentInQueueCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @return Success
     */
    getFromQueue(  cancelToken?: CancelToken | undefined): Promise<DigitalDocumentSignatureDtoOperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetFromQueue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFromQueue(_response);
        });
    }

    protected processGetFromQueue(response: AxiosResponse): Promise<DigitalDocumentSignatureDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigitalDocumentSignatureDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @param modelJson (optional) 
     * @param body (optional) 
     * @return Success
     */
    getSignedPreview(modelJson: string | undefined, body: DigitalDocumentSignatureFieldDto[] | undefined , cancelToken?: CancelToken | undefined): Promise<DigitalDocumentSignatureDtoOperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetSignedPreview?";
        if (modelJson === null)
            throw new Error("The parameter 'modelJson' cannot be null.");
        else if (modelJson !== undefined)
            url_ += "modelJson=" + encodeURIComponent("" + modelJson) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSignedPreview(_response);
        });
    }

    protected processGetSignedPreview(response: AxiosResponse): Promise<DigitalDocumentSignatureDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigitalDocumentSignatureDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @return Success
     */
    getCurrentIdFromQueue(  cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetCurrentIdFromQueue";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentIdFromQueue(_response);
        });
    }

    protected processGetCurrentIdFromQueue(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @return Success
     */
    cancel(  cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: SignatureDeviceWebApi)
     * @param body (optional) 
     * @return Success
     */
    sign(body: SignDigitalDocumentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/Sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSign(_response);
        });
    }

    protected processSign(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: ListDigitalDocumentsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<ListDigitalDocumentsQueryResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ListDigitalDocumentsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListDigitalDocumentsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    viewFile(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/DigitalDocuments/ViewFile?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processViewFile(_response);
        });
    }

    protected processViewFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getForQueueRequest(body: GetDigitalDocumentsForQueueRequestQuery | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleDriversDigitalDocumentsDtoListOperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetForQueueRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForQueueRequest(_response);
        });
    }

    protected processGetForQueueRequest(response: AxiosResponse): Promise<VehicleDriversDigitalDocumentsDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDriversDigitalDocumentsDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param ids (optional) 
     * @param vehicleId (optional) 
     * @param groupTypes (optional) 
     * @return Success
     */
    getOverdueDocuments(ids: number[] | undefined, vehicleId: number | undefined, groupTypes: DigitalDocumentGroupTypeEnum[] | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleRentOverdueDigitalDocumentsDtoListOperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetOverdueDocuments?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (groupTypes === null)
            throw new Error("The parameter 'groupTypes' cannot be null.");
        else if (groupTypes !== undefined)
            groupTypes && groupTypes.forEach(item => { url_ += "groupTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOverdueDocuments(_response);
        });
    }

    protected processGetOverdueDocuments(response: AxiosResponse): Promise<VehicleRentOverdueDigitalDocumentsDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRentOverdueDigitalDocumentsDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getAllOverdueDocuments(  cancelToken?: CancelToken | undefined): Promise<VehicleRentOverdueDigitalDocumentsDtoListOperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetAllOverdueDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllOverdueDocuments(_response);
        });
    }

    protected processGetAllOverdueDocuments(response: AxiosResponse): Promise<VehicleRentOverdueDigitalDocumentsDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRentOverdueDigitalDocumentsDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getDocumentToSignList(body: MissingVehicleRentDigitalDocumentsListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MissingVehicleRentDigitalDocumentsListQueryResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetDocumentToSignList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentToSignList(_response);
        });
    }

    protected processGetDocumentToSignList(response: AxiosResponse): Promise<MissingVehicleRentDigitalDocumentsListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissingVehicleRentDigitalDocumentsListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param vehicleDriverHistoryId (optional) 
     * @param digitalDocumentTypeId (optional) 
     * @return Success
     */
    cancelDigitalDocumentType(vehicleDriverHistoryId: number | undefined, digitalDocumentTypeId: DigitalDocumentTypeEnum | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/CancelDigitalDocumentType?";
        if (vehicleDriverHistoryId === null)
            throw new Error("The parameter 'vehicleDriverHistoryId' cannot be null.");
        else if (vehicleDriverHistoryId !== undefined)
            url_ += "vehicleDriverHistoryId=" + encodeURIComponent("" + vehicleDriverHistoryId) + "&";
        if (digitalDocumentTypeId === null)
            throw new Error("The parameter 'digitalDocumentTypeId' cannot be null.");
        else if (digitalDocumentTypeId !== undefined)
            url_ += "digitalDocumentTypeId=" + encodeURIComponent("" + digitalDocumentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelDigitalDocumentType(_response);
        });
    }

    protected processCancelDigitalDocumentType(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param vehicleDriverHistoryId (optional) 
     * @param digitalDocumentTypeId (optional) 
     * @return Success
     */
    restoreCancelledDigitalDocumentTypeC(vehicleDriverHistoryId: number | undefined, digitalDocumentTypeId: DigitalDocumentTypeEnum | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/RestoreCancelledDigitalDocumentTypeC?";
        if (vehicleDriverHistoryId === null)
            throw new Error("The parameter 'vehicleDriverHistoryId' cannot be null.");
        else if (vehicleDriverHistoryId !== undefined)
            url_ += "vehicleDriverHistoryId=" + encodeURIComponent("" + vehicleDriverHistoryId) + "&";
        if (digitalDocumentTypeId === null)
            throw new Error("The parameter 'digitalDocumentTypeId' cannot be null.");
        else if (digitalDocumentTypeId !== undefined)
            url_ += "digitalDocumentTypeId=" + encodeURIComponent("" + digitalDocumentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreCancelledDigitalDocumentTypeC(_response);
        });
    }

    protected processRestoreCancelledDigitalDocumentTypeC(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param digitalDocumentId (optional) 
     * @return Success
     */
    getDigitalDocumentSignatures(digitalDocumentId: number | undefined , cancelToken?: CancelToken | undefined): Promise<DigitalDocumentSignatureDetailsDtoListOperationResult> {
        let url_ = this.baseUrl + "/DigitalDocuments/GetDigitalDocumentSignatures?";
        if (digitalDocumentId === null)
            throw new Error("The parameter 'digitalDocumentId' cannot be null.");
        else if (digitalDocumentId !== undefined)
            url_ += "digitalDocumentId=" + encodeURIComponent("" + digitalDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDigitalDocumentSignatures(_response);
        });
    }

    protected processGetDigitalDocumentSignatures(response: AxiosResponse): Promise<DigitalDocumentSignatureDetailsDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DigitalDocumentSignatureDetailsDtoListOperationResult>(null as any);
    }
}

export class DocumentsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: DocumentListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DocumentListQueryResult> {
        let url_ = this.baseUrl + "/Documents/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DocumentListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param name (optional) 
     * @return Success
     */
    create(name: string | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Documents/Create?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Documents/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: DocumentDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Documents/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    vehicleDocumentList(body: VehicleDocumentListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleDocumentListQueryResult> {
        let url_ = this.baseUrl + "/Documents/VehicleDocumentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehicleDocumentList(_response);
        });
    }

    protected processVehicleDocumentList(response: AxiosResponse): Promise<VehicleDocumentListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDocumentListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createVehicleDocument(body: VehicleDocumentDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Documents/CreateVehicleDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateVehicleDocument(_response);
        });
    }

    protected processCreateVehicleDocument(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    deleteVehicleDocument(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Documents/DeleteVehicleDocument/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteVehicleDocument(_response);
        });
    }

    protected processDeleteVehicleDocument(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateVehicleDocument(body: VehicleDocumentUpdateCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Documents/UpdateVehicleDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateVehicleDocument(_response);
        });
    }

    protected processUpdateVehicleDocument(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    vehicleDocumentPlaces(  cancelToken?: CancelToken | undefined): Promise<StringListOperationResult> {
        let url_ = this.baseUrl + "/Documents/VehicleDocumentPlaces";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehicleDocumentPlaces(_response);
        });
    }

    protected processVehicleDocumentPlaces(response: AxiosResponse): Promise<StringListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StringListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getIdsAndNames(  cancelToken?: CancelToken | undefined): Promise<DocumentsGetIdsAndNamesQueryResult> {
        let url_ = this.baseUrl + "/Documents/GetIdsAndNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdsAndNames(_response);
        });
    }

    protected processGetIdsAndNames(response: AxiosResponse): Promise<DocumentsGetIdsAndNamesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentsGetIdsAndNamesQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    vehiclesDocumentList(body: VehiclesDocumentListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<VehiclesDocumentListQueryResult> {
        let url_ = this.baseUrl + "/Documents/VehiclesDocumentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehiclesDocumentList(_response);
        });
    }

    protected processVehiclesDocumentList(response: AxiosResponse): Promise<VehiclesDocumentListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesDocumentListQueryResult>(null as any);
    }
}

export class DriverContactFormsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: DriverContactFormListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriverContactFormListQueryResult> {
        let url_ = this.baseUrl + "/DriverContactForms/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<DriverContactFormListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverContactFormListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    confirmContact(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DriverContactForms/ConfirmContact?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmContact(_response);
        });
    }

    protected processConfirmContact(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DriverContactForms/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    invokeDriverContactFormSync(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/DriverContactForms/InvokeDriverContactFormSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvokeDriverContactFormSync(_response);
        });
    }

    protected processInvokeDriverContactFormSync(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEmail(body: UpdateDriverContactFormEmailCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/DriverContactForms/UpdateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmail(_response);
        });
    }

    protected processUpdateEmail(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class DriversClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: DriversGetAllQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<DriversGetAllQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<DriversGetAllQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversGetAllQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DriversGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DriversGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: DriversCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<DriversCreateCommandResult> {
        let url_ = this.baseUrl + "/Drivers/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<DriversCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: DriversUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<DriversUpdateCommandResult> {
        let url_ = this.baseUrl + "/Drivers/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<DriversUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportDataToExcelFile(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportDataToExcelFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDataToExcelFile(_response);
        });
    }

    protected processExportDataToExcelFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    optimaExportPreview(body: GetOptimaExportPreviewQuery | undefined , cancelToken?: CancelToken | undefined): Promise<OptimaExportPreviewDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/OptimaExportPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOptimaExportPreview(_response);
        });
    }

    protected processOptimaExportPreview(response: AxiosResponse): Promise<OptimaExportPreviewDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OptimaExportPreviewDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param status (optional) 
     * @return Success
     */
    exportAllDriversDataToExcelFile(status: HrStatusEnum | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportAllDriversDataToExcelFile?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportAllDriversDataToExcelFile(_response);
        });
    }

    protected processExportAllDriversDataToExcelFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getForSettlementAutocomplete(body: GetForSettlementAutocompleteQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetForSettlementAutocompleteQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetForSettlementAutocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForSettlementAutocomplete(_response);
        });
    }

    protected processGetForSettlementAutocomplete(response: AxiosResponse): Promise<GetForSettlementAutocompleteQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetForSettlementAutocompleteQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massRemoveFromSIIPreview(body: GetRemoveDriversFromSIIPreviewQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MassChangeDriverHrTagPreviewDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/MassRemoveFromSIIPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassRemoveFromSIIPreview(_response);
        });
    }

    protected processMassRemoveFromSIIPreview(response: AxiosResponse): Promise<MassChangeDriverHrTagPreviewDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MassChangeDriverHrTagPreviewDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massRemoveFromSII(body: RemoveDriversFromSIICommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/MassRemoveFromSII";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassRemoveFromSII(_response);
        });
    }

    protected processMassRemoveFromSII(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massReportToSIIPreview(body: GetReportDriversToSIIPreviewQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MassChangeDriverHrTagPreviewDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/MassReportToSIIPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassReportToSIIPreview(_response);
        });
    }

    protected processMassReportToSIIPreview(response: AxiosResponse): Promise<MassChangeDriverHrTagPreviewDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MassChangeDriverHrTagPreviewDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massReportToSII(body: ReportDriversToSIICommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/MassReportToSII";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassReportToSII(_response);
        });
    }

    protected processMassReportToSII(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    setDisableRequestStatus(body: SetDriverDisableRequestStatusCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/SetDisableRequestStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDisableRequestStatus(_response);
        });
    }

    protected processSetDisableRequestStatus(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param removePayoffs (optional) 
     * @return Success
     */
    delete(id: number, removePayoffs: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<DriversDeleteCommandResult> {
        let url_ = this.baseUrl + "/Drivers/Delete/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (removePayoffs === null)
            throw new Error("The parameter 'removePayoffs' cannot be null.");
        else if (removePayoffs !== undefined)
            url_ += "removePayoffs=" + encodeURIComponent("" + removePayoffs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DriversDeleteCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversDeleteCommandResult>(null as any);
    }

    /**
     * @return Success
     */
    invokeDriverSync(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/InvokeDriverSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvokeDriverSync(_response);
        });
    }

    protected processInvokeDriverSync(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    invokeDriverContactFormSync(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/InvokeDriverContactFormSync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvokeDriverContactFormSync(_response);
        });
    }

    protected processInvokeDriverContactFormSync(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @param isActive (optional) 
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getPaymentsById(id: number | undefined, isActive: boolean | undefined, dateStart: string | undefined, dateEnd: string | undefined , cancelToken?: CancelToken | undefined): Promise<PaymentGetAllByQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetPaymentsById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent("" + dateStart) + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "dateEnd=" + encodeURIComponent("" + dateEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentsById(_response);
        });
    }

    protected processGetPaymentsById(response: AxiosResponse): Promise<PaymentGetAllByQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentGetAllByQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportToPdfDriverRequestForPayment(body: DriverExportToPdfRequestForPaymentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportToPdfDriverRequestForPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPdfDriverRequestForPayment(_response);
        });
    }

    protected processExportToPdfDriverRequestForPayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    exportDriverDataToPdfFile(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportDriverDataToPdfFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDriverDataToPdfFile(_response);
        });
    }

    protected processExportDriverDataToPdfFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    addToUserDriverList(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/AddToUserDriverList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToUserDriverList(_response);
        });
    }

    protected processAddToUserDriverList(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    removeFromUserDriverList(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/RemoveFromUserDriverList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveFromUserDriverList(_response);
        });
    }

    protected processRemoveFromUserDriverList(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getIdsAndNames(  cancelToken?: CancelToken | undefined): Promise<DriversGetIdsAndNamesQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetIdsAndNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdsAndNames(_response);
        });
    }

    protected processGetIdsAndNames(response: AxiosResponse): Promise<DriversGetIdsAndNamesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversGetIdsAndNamesQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportToPdfDriverProofOfIncome(body: DriverExportToPdfProofOfIncomeCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportToPdfDriverProofOfIncome";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPdfDriverProofOfIncome(_response);
        });
    }

    protected processExportToPdfDriverProofOfIncome(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportToPdfEquipmentReturnRequest(body: DriverExportToPdfEquipmentReturnRequestCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportToPdfEquipmentReturnRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPdfEquipmentReturnRequest(_response);
        });
    }

    protected processExportToPdfEquipmentReturnRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportToPdfPostOfficeBook(body: DriversExportToPdfPostOfficeBookCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportToPdfPostOfficeBook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPdfPostOfficeBook(_response);
        });
    }

    protected processExportToPdfPostOfficeBook(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @param mediumId (optional) 
     * @return Success
     */
    sendDriverAttachment(id: number | undefined, mediumId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/SendDriverAttachment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (mediumId === null)
            throw new Error("The parameter 'mediumId' cannot be null.");
        else if (mediumId !== undefined)
            url_ += "mediumId=" + encodeURIComponent("" + mediumId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDriverAttachment(_response);
        });
    }

    protected processSendDriverAttachment(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    addPit11(body: DriverAddPit11Command | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/AddPit11";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddPit11(_response);
        });
    }

    protected processAddPit11(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getPit11Progress(  cancelToken?: CancelToken | undefined): Promise<Pit11ProgressDto> {
        let url_ = this.baseUrl + "/Drivers/GetPit11Progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPit11Progress(_response);
        });
    }

    protected processGetPit11Progress(response: AxiosResponse): Promise<Pit11ProgressDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Pit11ProgressDto>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportToPdfPaymentsSummaryForTax(body: ExportToPdfPaymentsSummaryForTaxCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportToPdfPaymentsSummaryForTax";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPdfPaymentsSummaryForTax(_response);
        });
    }

    protected processExportToPdfPaymentsSummaryForTax(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param nip (optional) 
     * @return Success
     */
    getSubject(nip: string | undefined , cancelToken?: CancelToken | undefined): Promise<GusSubjectDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetSubject?";
        if (nip === null)
            throw new Error("The parameter 'nip' cannot be null.");
        else if (nip !== undefined)
            url_ += "nip=" + encodeURIComponent("" + nip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSubject(_response);
        });
    }

    protected processGetSubject(response: AxiosResponse): Promise<GusSubjectDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GusSubjectDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @param nip (optional) 
     * @param isAuthorizedToRepresentTheCompany (optional) 
     * @return Success
     */
    updateDriverSubjectFromGus(driverId: number | undefined, nip: string | undefined, isAuthorizedToRepresentTheCompany: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<DriverSubjectDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/UpdateDriverSubjectFromGus?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        if (nip === null)
            throw new Error("The parameter 'nip' cannot be null.");
        else if (nip !== undefined)
            url_ += "nip=" + encodeURIComponent("" + nip) + "&";
        if (isAuthorizedToRepresentTheCompany === null)
            throw new Error("The parameter 'isAuthorizedToRepresentTheCompany' cannot be null.");
        else if (isAuthorizedToRepresentTheCompany !== undefined)
            url_ += "isAuthorizedToRepresentTheCompany=" + encodeURIComponent("" + isAuthorizedToRepresentTheCompany) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDriverSubjectFromGus(_response);
        });
    }

    protected processUpdateDriverSubjectFromGus(response: AxiosResponse): Promise<DriverSubjectDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverSubjectDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getMultipleForAutocomplete(body: DriverGetMultipleForAutocompleteQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriverAutocompleteDtoListOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetMultipleForAutocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMultipleForAutocomplete(_response);
        });
    }

    protected processGetMultipleForAutocomplete(response: AxiosResponse): Promise<DriverAutocompleteDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverAutocompleteDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getForChargeExemptionAutocomplete(body: GetForChargeExemptionAutocompleteQuery | undefined , cancelToken?: CancelToken | undefined): Promise<ChargeExemptDriverDtoListOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetForChargeExemptionAutocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForChargeExemptionAutocomplete(_response);
        });
    }

    protected processGetForChargeExemptionAutocomplete(response: AxiosResponse): Promise<ChargeExemptDriverDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChargeExemptDriverDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massExportRequestForPayment(body: DriverMassExportToPdfRequestForPaymentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/MassExportRequestForPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassExportRequestForPayment(_response);
        });
    }

    protected processMassExportRequestForPayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportToPdfPayoffsSummary(body: DriversExportToPdfPayoffsSummaryCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportToPdfPayoffsSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportToPdfPayoffsSummary(_response);
        });
    }

    protected processExportToPdfPayoffsSummary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getDebtors(body: DriversGetDebtorsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriversGetDebtorsQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetDebtors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDebtors(_response);
        });
    }

    protected processGetDebtors(response: AxiosResponse): Promise<DriversGetDebtorsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversGetDebtorsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getDriversForVerification(body: DriversGetAllForVerificationQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriversGetAllForVerificationQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetDriversForVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriversForVerification(_response);
        });
    }

    protected processGetDriversForVerification(response: AxiosResponse): Promise<DriversGetAllForVerificationQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversGetAllForVerificationQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getDriversCountForVerification(body: GetAllDriversCountForVerificationQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriverVerificationCountDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetDriversCountForVerification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriversCountForVerification(_response);
        });
    }

    protected processGetDriversCountForVerification(response: AxiosResponse): Promise<DriverVerificationCountDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverVerificationCountDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    setIsContactedForDebt(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/SetIsContactedForDebt?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetIsContactedForDebt(_response);
        });
    }

    protected processSetIsContactedForDebt(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    setDriverFilesVisibility(body: SetDriverFilesVisibilityCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/SetDriverFilesVisibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDriverFilesVisibility(_response);
        });
    }

    protected processSetDriverFilesVisibility(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateDebtNote(body: UpdateDriverDebtNoteCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/UpdateDebtNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDebtNote(_response);
        });
    }

    protected processUpdateDebtNote(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getWithdrawStatus(id: number , cancelToken?: CancelToken | undefined): Promise<DriverWithdrawStatusDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetWithdrawStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWithdrawStatus(_response);
        });
    }

    protected processGetWithdrawStatus(response: AxiosResponse): Promise<DriverWithdrawStatusDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverWithdrawStatusDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    downloadHrTagLegend(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/DownloadHrTagLegend";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadHrTagLegend(_response);
        });
    }

    protected processDownloadHrTagLegend(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param status (optional) 
     * @return Success
     */
    exportForHrStatusVerification(status: HrStatusEnum | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportForHrStatusVerification?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportForHrStatusVerification(_response);
        });
    }

    protected processExportForHrStatusVerification(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param city (optional) 
     * @param buildingNumber (optional) 
     * @param street (optional) 
     * @param voivodeship (optional) 
     * @return Success
     */
    getTaxOffice(city: string | undefined, buildingNumber: string | undefined, street: string | undefined, voivodeship: string | undefined , cancelToken?: CancelToken | undefined): Promise<DriverTaxOfficeDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetTaxOffice?";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "city=" + encodeURIComponent("" + city) + "&";
        if (buildingNumber === null)
            throw new Error("The parameter 'buildingNumber' cannot be null.");
        else if (buildingNumber !== undefined)
            url_ += "buildingNumber=" + encodeURIComponent("" + buildingNumber) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "street=" + encodeURIComponent("" + street) + "&";
        if (voivodeship === null)
            throw new Error("The parameter 'voivodeship' cannot be null.");
        else if (voivodeship !== undefined)
            url_ += "voivodeship=" + encodeURIComponent("" + voivodeship) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxOffice(_response);
        });
    }

    protected processGetTaxOffice(response: AxiosResponse): Promise<DriverTaxOfficeDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverTaxOfficeDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getTaxOfficeDictionary(  cancelToken?: CancelToken | undefined): Promise<TaxOfficeDictionaryItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetTaxOfficeDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxOfficeDictionary(_response);
        });
    }

    protected processGetTaxOfficeDictionary(response: AxiosResponse): Promise<TaxOfficeDictionaryItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxOfficeDictionaryItemDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getBalance(id: number , cancelToken?: CancelToken | undefined): Promise<DriverBalanceDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetBalance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBalance(_response);
        });
    }

    protected processGetBalance(response: AxiosResponse): Promise<DriverBalanceDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverBalanceDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    getLastModificationDate(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<DateTimeOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetLastModificationDate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastModificationDate(_response);
        });
    }

    protected processGetLastModificationDate(response: AxiosResponse): Promise<DateTimeOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateTimeOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getMails(body: GetDriverMailsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<GetDriverMailsQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetMails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMails(_response);
        });
    }

    protected processGetMails(response: AxiosResponse): Promise<GetDriverMailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDriverMailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getOrganisationOnlinePaymentInvoicingMethod(id: number , cancelToken?: CancelToken | undefined): Promise<OrganisationOnlinePaymentInvoicingMethodEnumNullableOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetOrganisationOnlinePaymentInvoicingMethod/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganisationOnlinePaymentInvoicingMethod(_response);
        });
    }

    protected processGetOrganisationOnlinePaymentInvoicingMethod(response: AxiosResponse): Promise<OrganisationOnlinePaymentInvoicingMethodEnumNullableOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationOnlinePaymentInvoicingMethodEnumNullableOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param firstName (optional) 
     * @param lastname (optional) 
     * @param drivingLicenseNumber (optional) 
     * @return Success
     */
    getDrivingLicenseDetailsFromCepik(firstName: string | undefined, lastname: string | undefined, drivingLicenseNumber: string | undefined , cancelToken?: CancelToken | undefined): Promise<DriverDrivingLicenseDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetDrivingLicenseDetailsFromCepik?";
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastname === null)
            throw new Error("The parameter 'lastname' cannot be null.");
        else if (lastname !== undefined)
            url_ += "lastname=" + encodeURIComponent("" + lastname) + "&";
        if (drivingLicenseNumber === null)
            throw new Error("The parameter 'drivingLicenseNumber' cannot be null.");
        else if (drivingLicenseNumber !== undefined)
            url_ += "drivingLicenseNumber=" + encodeURIComponent("" + drivingLicenseNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrivingLicenseDetailsFromCepik(_response);
        });
    }

    protected processGetDrivingLicenseDetailsFromCepik(response: AxiosResponse): Promise<DriverDrivingLicenseDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverDrivingLicenseDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportDriversToCsv(body: ExportDriversCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportDriversToCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDriversToCsv(_response);
        });
    }

    protected processExportDriversToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @param year (optional) 
     * @return Success
     */
    getDriverSiiSummary(id: number | undefined, year: number | undefined , cancelToken?: CancelToken | undefined): Promise<DriverSiiSumaryItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetDriverSiiSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriverSiiSummary(_response);
        });
    }

    protected processGetDriverSiiSummary(response: AxiosResponse): Promise<DriverSiiSumaryItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverSiiSumaryItemDtoListOperationResult>(null as any);
    }

    /**
     * @return Success
     */
    getTokenDetails(token: string , cancelToken?: CancelToken | undefined): Promise<ReuploadTokenDtoOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetTokenDetails/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTokenDetails(_response);
        });
    }

    protected processGetTokenDetails(response: AxiosResponse): Promise<ReuploadTokenDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReuploadTokenDtoOperationResult>(null as any);
    }

    /**
     * @return Success
     */
    invokeUploadMissingFiles(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/InvokeUploadMissingFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInvokeUploadMissingFiles(_response);
        });
    }

    protected processInvokeUploadMissingFiles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    refreshUploadToken(body: RefreshDriverUploadTokenCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/RefreshUploadToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshUploadToken(_response);
        });
    }

    protected processRefreshUploadToken(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    syncToFlovi(body: SyncDriverToFloviCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/SyncToFlovi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncToFlovi(_response);
        });
    }

    protected processSyncToFlovi(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    cancelVehicleReservation(body: CancelDriverVehicleReservationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/CancelVehicleReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelVehicleReservation(_response);
        });
    }

    protected processCancelVehicleReservation(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    approveVehicleReservation(body: ApproveDriverVehicleReservationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/ApproveVehicleReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveVehicleReservation(_response);
        });
    }

    protected processApproveVehicleReservation(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getVehicleReservations(body: GetDriverVehicleReservationListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<GetDriverVehicleReservationListQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetVehicleReservations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleReservations(_response);
        });
    }

    protected processGetVehicleReservations(response: AxiosResponse): Promise<GetDriverVehicleReservationListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDriverVehicleReservationListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getPendingReservationsForDriver(body: GetPendingReservationsForDriverQuery | undefined , cancelToken?: CancelToken | undefined): Promise<PendingDriverVehicleReservationDtoListOperationResult> {
        let url_ = this.baseUrl + "/Drivers/GetPendingReservationsForDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPendingReservationsForDriver(_response);
        });
    }

    protected processGetPendingReservationsForDriver(response: AxiosResponse): Promise<PendingDriverVehicleReservationDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PendingDriverVehicleReservationDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    assignVehicleToReservation(body: AssignVehicleToReservationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Drivers/AssignVehicleToReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignVehicleToReservation(_response);
        });
    }

    protected processAssignVehicleToReservation(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportDebtors(body: ExportDebtorsToCsvCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Drivers/ExportDebtors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDebtors(_response);
        });
    }

    protected processExportDebtors(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getDriverDebtorsPenaltySummaryExportList(body: DriverDebtorsPenaltySummaryExportHistoryListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriverDebtorsPenaltySummaryExportHistoryListQueryResult> {
        let url_ = this.baseUrl + "/Drivers/GetDriverDebtorsPenaltySummaryExportList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriverDebtorsPenaltySummaryExportList(_response);
        });
    }

    protected processGetDriverDebtorsPenaltySummaryExportList(response: AxiosResponse): Promise<DriverDebtorsPenaltySummaryExportHistoryListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverDebtorsPenaltySummaryExportHistoryListQueryResult>(null as any);
    }
}

export class HrTagsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: HrTagListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<HrTagListQueryResult> {
        let url_ = this.baseUrl + "/HrTags/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<HrTagListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HrTagListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: HrTagCreateCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/HrTags/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/HrTags/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: HrTagDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/HrTags/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @return Success
     */
    getSelectList(driverId: number | undefined , cancelToken?: CancelToken | undefined): Promise<HrTagSelectListDtoListOperationResult> {
        let url_ = this.baseUrl + "/HrTags/GetSelectList?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<HrTagSelectListDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HrTagSelectListDtoListOperationResult>(null as any);
    }
}

export class InstallmentSchemasClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: InstallmentListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<InstallmentListResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<InstallmentListResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstallmentListResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<InstallmentSchemaDtoOperationResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<InstallmentSchemaDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstallmentSchemaDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: InstallmentSchemaDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(id: number, body: InstallmentSchemaDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/Update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getPaged(body: InstallmentsGetPagedQuery | undefined , cancelToken?: CancelToken | undefined): Promise<InstallmentsGetPagedQueryResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/GetPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<InstallmentsGetPagedQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InstallmentsGetPagedQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    cancel(body: CancelInstallmentSchemaCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/InstallmentSchemas/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancel(_response);
        });
    }

    protected processCancel(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class InviteProgramsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: InviteProgramListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<InviteProgramListQueryResult> {
        let url_ = this.baseUrl + "/InvitePrograms/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<InviteProgramListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteProgramListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    details(id: number , cancelToken?: CancelToken | undefined): Promise<InviteProgramDtoOperationResult> {
        let url_ = this.baseUrl + "/InvitePrograms/Details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<InviteProgramDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InviteProgramDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: InviteProgramDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/InvitePrograms/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: InviteProgramDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/InvitePrograms/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    setDraftState(body: SetInviteProgramDraftStateCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/InvitePrograms/SetDraftState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDraftState(_response);
        });
    }

    protected processSetDraftState(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/InvitePrograms/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * @return Success
     */
    isInviteCodeValid(code: string , cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/InvitePrograms/IsInviteCodeValid/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsInviteCodeValid(_response);
        });
    }

    protected processIsInviteCodeValid(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }
}

export class InvoicesClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: InvoiceListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<InvoiceListQueryResult> {
        let url_ = this.baseUrl + "/Invoices/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<InvoiceListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    sendToDriver(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Invoices/SendToDriver?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendToDriver(_response);
        });
    }

    protected processSendToDriver(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param ids (optional) 
     * @return Success
     */
    downloadSelected(ids: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Invoices/DownloadSelected?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadSelected(_response);
        });
    }

    protected processDownloadSelected(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class KSeFClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    send(body: KSeFSendInvoicesCommand | undefined , cancelToken?: CancelToken | undefined): Promise<KSeFSendInvoicesResultOperationResult> {
        let url_ = this.baseUrl + "/KSeF/invoices/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<KSeFSendInvoicesResultOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KSeFSendInvoicesResultOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    status(invoiceId: number , cancelToken?: CancelToken | undefined): Promise<KSeFStatusResultOperationResult> {
        let url_ = this.baseUrl + "/KSeF/invoices/{invoiceId}/status";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: AxiosResponse): Promise<KSeFStatusResultOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KSeFStatusResultOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    config(  cancelToken?: CancelToken | undefined): Promise<KSeFConfigResultOperationResult> {
        let url_ = this.baseUrl + "/KSeF/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfig(_response);
        });
    }

    protected processConfig(response: AxiosResponse): Promise<KSeFConfigResultOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KSeFConfigResultOperationResult>(null as any);
    }
}

export class LandingPageClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @return Success
     */
    getCounters(  cancelToken?: CancelToken | undefined): Promise<LandingPageCountersDtoOperationResult> {
        let url_ = this.baseUrl + "/LandingPage/GetCounters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCounters(_response);
        });
    }

    protected processGetCounters(response: AxiosResponse): Promise<LandingPageCountersDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LandingPageCountersDtoOperationResult>(null as any);
    }
}

export class MailgunClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @param body (optional) 
     * @return Success
     */
    notify(body: MailgunWebhookDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Mailgun/Notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNotify(_response);
        });
    }

    protected processNotify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MailsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: MailListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MailListQueryResult> {
        let url_ = this.baseUrl + "/Mails/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<MailListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    rulesList(body: MailRulesListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MailRulesListQueryResult> {
        let url_ = this.baseUrl + "/Mails/RulesList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRulesList(_response);
        });
    }

    protected processRulesList(response: AxiosResponse): Promise<MailRulesListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailRulesListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    details(id: number , cancelToken?: CancelToken | undefined): Promise<RuleDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/Mails/Details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<RuleDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RuleDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    columnEntities(mailType: MailTypeEnum , cancelToken?: CancelToken | undefined): Promise<MailTypeEntitiesDtoOperationResult> {
        let url_ = this.baseUrl + "/Mails/ColumnEntities/{mailType}";
        if (mailType === undefined || mailType === null)
            throw new Error("The parameter 'mailType' must be defined.");
        url_ = url_.replace("{mailType}", encodeURIComponent("" + mailType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processColumnEntities(_response);
        });
    }

    protected processColumnEntities(response: AxiosResponse): Promise<MailTypeEntitiesDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailTypeEntitiesDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: RuleDetailsDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/Mails/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getSelectList(  cancelToken?: CancelToken | undefined): Promise<MailTypeDetailSelectListDtoListOperationResult> {
        let url_ = this.baseUrl + "/Mails/GetSelectList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<MailTypeDetailSelectListDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailTypeDetailSelectListDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    download(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Mails/Download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massResendMails(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Mails/MassResendMails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassResendMails(_response);
        });
    }

    protected processMassResendMails(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massResendMailsCopy(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Mails/MassResendMailsCopy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassResendMailsCopy(_response);
        });
    }

    protected processMassResendMailsCopy(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getLogsByMailId(id: number , cancelToken?: CancelToken | undefined): Promise<MailgunLogDtoListOperationResult> {
        let url_ = this.baseUrl + "/Mails/GetLogsByMailId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogsByMailId(_response);
        });
    }

    protected processGetLogsByMailId(response: AxiosResponse): Promise<MailgunLogDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MailgunLogDtoListOperationResult>(null as any);
    }
}

export class MassCampaignsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMassCampaignCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ImportLogExtendedDtoOperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<ImportLogExtendedDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportLogExtendedDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createFromCopy(body: CreateMassCampaignCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ImportLogExtendedDtoOperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/CreateFromCopy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFromCopy(_response);
        });
    }

    protected processCreateFromCopy(response: AxiosResponse): Promise<ImportLogExtendedDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportLogExtendedDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getList(body: MassCampaignListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MassCampaignListQueryResult> {
        let url_ = this.baseUrl + "/MassCampaigns/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<MassCampaignListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MassCampaignListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    changeStatus(body: ChangeMassCampaignStatusCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/ChangeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeStatus(_response);
        });
    }

    protected processChangeStatus(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    restore(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/Restore/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getRecipients(id: number , cancelToken?: CancelToken | undefined): Promise<MassCampaignRecipientDtoListOperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/GetRecipients/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipients(_response);
        });
    }

    protected processGetRecipients(response: AxiosResponse): Promise<MassCampaignRecipientDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MassCampaignRecipientDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getPoints(  cancelToken?: CancelToken | undefined): Promise<DecimalNullableOperationResult> {
        let url_ = this.baseUrl + "/MassCampaigns/GetPoints";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPoints(_response);
        });
    }

    protected processGetPoints(response: AxiosResponse): Promise<DecimalNullableOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DecimalNullableOperationResult>(null as any);
    }
}

export class MediaClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: MediaUploadScope)
     * @return Success
     */
    media(  cancelToken?: CancelToken | undefined): Promise<MediaCreateCommandResult> {
        let url_ = this.baseUrl + "/Media";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMedia(_response);
        });
    }

    protected processMedia(response: AxiosResponse): Promise<MediaCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MediaCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: MediaDownloadScope)
     * @return Success
     */
    download(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Media/Download/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadPublic(id: string , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Media/DownloadPublic/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadPublic(_response);
        });
    }

    protected processDownloadPublic(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class MobileApplicationsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getMyInfo(  cancelToken?: CancelToken | undefined): Promise<DriverInfoDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: AxiosResponse): Promise<DriverInfoDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverInfoDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getInviteProgramCard(  cancelToken?: CancelToken | undefined): Promise<MobileApplicationInviteProgramCardDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetInviteProgramCard";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInviteProgramCard(_response);
        });
    }

    protected processGetInviteProgramCard(response: AxiosResponse): Promise<MobileApplicationInviteProgramCardDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationInviteProgramCardDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getBalance(  cancelToken?: CancelToken | undefined): Promise<MobileApplicationDriverBalanceDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBalance(_response);
        });
    }

    protected processGetBalance(response: AxiosResponse): Promise<MobileApplicationDriverBalanceDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationDriverBalanceDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getMyCompanyData(  cancelToken?: CancelToken | undefined): Promise<DriverCompanyDataDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMyCompanyData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyCompanyData(_response);
        });
    }

    protected processGetMyCompanyData(response: AxiosResponse): Promise<DriverCompanyDataDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverCompanyDataDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getWeeklyEarnings(  cancelToken?: CancelToken | undefined): Promise<MobileApplicationWeeklyEarningsDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetWeeklyEarnings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeeklyEarnings(_response);
        });
    }

    protected processGetWeeklyEarnings(response: AxiosResponse): Promise<MobileApplicationWeeklyEarningsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationWeeklyEarningsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getSettlements(body: GetMobileApplicationSettlementsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationSettlementItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetSettlements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettlements(_response);
        });
    }

    protected processGetSettlements(response: AxiosResponse): Promise<MobileApplicationSettlementItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationSettlementItemDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    exportSettlementToPdf(body: ExportMobileApplicationSettlementToPdfCommand | undefined , cancelToken?: CancelToken | undefined): Promise<FileMimeDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/ExportSettlementToPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSettlementToPdf(_response);
        });
    }

    protected processExportSettlementToPdf(response: AxiosResponse): Promise<FileMimeDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileMimeDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getInvoices(body: GetMobileApplicationInvoiceListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationInvoiceDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetInvoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: AxiosResponse): Promise<MobileApplicationInvoiceDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationInvoiceDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getInvoicePdf(id: number , cancelToken?: CancelToken | undefined): Promise<FileMimeDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetInvoicePdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePdf(_response);
        });
    }

    protected processGetInvoicePdf(response: AxiosResponse): Promise<FileMimeDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileMimeDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getMyFiles(  cancelToken?: CancelToken | undefined): Promise<DriverMobileFileDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMyFiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyFiles(_response);
        });
    }

    protected processGetMyFiles(response: AxiosResponse): Promise<DriverMobileFileDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverMobileFileDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getMyMissingFileTypes(  cancelToken?: CancelToken | undefined): Promise<DriverMobileMissingFilesDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMyMissingFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyMissingFileTypes(_response);
        });
    }

    protected processGetMyMissingFileTypes(response: AxiosResponse): Promise<DriverMobileMissingFilesDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverMobileMissingFilesDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @param file (optional) 
     * @param fileTypeId (optional) 
     * @return Success
     */
    uploadMyFile(body: Body | undefined, file: FileParameter | undefined, fileTypeId: FileTypeEnum | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/UploadMyFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (fileTypeId === null || fileTypeId === undefined)
            throw new Error("The parameter 'fileTypeId' cannot be null.");
        else
            content_.append("FileTypeId", fileTypeId.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadMyFile(_response);
        });
    }

    protected processUploadMyFile(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    downloadMyFile(mediumId: number , cancelToken?: CancelToken | undefined): Promise<FileMimeDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/DownloadMyFile/{mediumId}";
        if (mediumId === undefined || mediumId === null)
            throw new Error("The parameter 'mediumId' must be defined.");
        url_ = url_.replace("{mediumId}", encodeURIComponent("" + mediumId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadMyFile(_response);
        });
    }

    protected processDownloadMyFile(response: AxiosResponse): Promise<FileMimeDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileMimeDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    updateDriverPersonalInformation(body: UpdateMobileApplicationDriverPersonalInformationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/UpdateDriverPersonalInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDriverPersonalInformation(_response);
        });
    }

    protected processUpdateDriverPersonalInformation(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getMyPayoutMethodSummary(  cancelToken?: CancelToken | undefined): Promise<PayoutMethodSummaryDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMyPayoutMethodSummary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyPayoutMethodSummary(_response);
        });
    }

    protected processGetMyPayoutMethodSummary(response: AxiosResponse): Promise<PayoutMethodSummaryDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoutMethodSummaryDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    updateMyPayoutMethod(body: UpdateMyPayoutMethodCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/UpdateMyPayoutMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMyPayoutMethod(_response);
        });
    }

    protected processUpdateMyPayoutMethod(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getPayoutRequestState(  cancelToken?: CancelToken | undefined): Promise<MobileApplicationPayoutRequestStateDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetPayoutRequestState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPayoutRequestState(_response);
        });
    }

    protected processGetPayoutRequestState(response: AxiosResponse): Promise<MobileApplicationPayoutRequestStateDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationPayoutRequestStateDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    requestPayout(body: RequestMobileApplicationPayoutCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/RequestPayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestPayout(_response);
        });
    }

    protected processRequestPayout(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    requestAccountDisable(  cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/RequestAccountDisable";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestAccountDisable(_response);
        });
    }

    protected processRequestAccountDisable(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    createOnlinePayment(body: CreateMobileApplicationOnlinePaymentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationOnlinePaymentUrlDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/CreateOnlinePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOnlinePayment(_response);
        });
    }

    protected processCreateOnlinePayment(response: AxiosResponse): Promise<MobileApplicationOnlinePaymentUrlDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationOnlinePaymentUrlDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    createOnlinePaymentForTransport(body: CreateMobileApplicationOnlinePaymentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationOnlinePaymentUrlDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/CreateOnlinePaymentForTransport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOnlinePaymentForTransport(_response);
        });
    }

    protected processCreateOnlinePaymentForTransport(response: AxiosResponse): Promise<MobileApplicationOnlinePaymentUrlDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationOnlinePaymentUrlDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    cancelVehicleReservation(body: CancelMobileApplicationVehicleReservationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/CancelVehicleReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelVehicleReservation(_response);
        });
    }

    protected processCancelVehicleReservation(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    createReservation(body: CreateMobileApplicationVehicleReservationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/CreateReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateReservation(_response);
        });
    }

    protected processCreateReservation(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getMyReservations(body: GetMobileApplicationVehicleReservationsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationVehicleReservationDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMyReservations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyReservations(_response);
        });
    }

    protected processGetMyReservations(response: AxiosResponse): Promise<MobileApplicationVehicleReservationDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationVehicleReservationDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getLatestReservation(  cancelToken?: CancelToken | undefined): Promise<MobileApplicationVehicleReservationDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetLatestReservation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestReservation(_response);
        });
    }

    protected processGetLatestReservation(response: AxiosResponse): Promise<MobileApplicationVehicleReservationDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationVehicleReservationDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getOnlinePayments(body: GetMobileApplicationOnlinePaymentsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationOnlinePaymentItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetOnlinePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOnlinePayments(_response);
        });
    }

    protected processGetOnlinePayments(response: AxiosResponse): Promise<MobileApplicationOnlinePaymentItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationOnlinePaymentItemDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getFinancialHistory(body: GetMobileApplicationFinancialHistoryQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationFinancialHistoryDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetFinancialHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFinancialHistory(_response);
        });
    }

    protected processGetFinancialHistory(response: AxiosResponse): Promise<MobileApplicationFinancialHistoryDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationFinancialHistoryDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getFinancialHistoryOverdue(body: GetMobileApplicationFinancialHistoryOverdueQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationFinancialHistoryOverdueDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetFinancialHistoryOverdue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFinancialHistoryOverdue(_response);
        });
    }

    protected processGetFinancialHistoryOverdue(response: AxiosResponse): Promise<MobileApplicationFinancialHistoryOverdueDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationFinancialHistoryOverdueDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getCurrentRentedVehicle(  cancelToken?: CancelToken | undefined): Promise<MobileApplicationRentedVehicleDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetCurrentRentedVehicle";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentRentedVehicle(_response);
        });
    }

    protected processGetCurrentRentedVehicle(response: AxiosResponse): Promise<MobileApplicationRentedVehicleDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationRentedVehicleDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getRentalHistory(body: GetMobileApplicationRentalHistoryQuery | undefined , cancelToken?: CancelToken | undefined): Promise<MobileApplicationRentedVehicleDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetRentalHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRentalHistory(_response);
        });
    }

    protected processGetRentalHistory(response: AxiosResponse): Promise<MobileApplicationRentedVehicleDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MobileApplicationRentedVehicleDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getTaxQualificationState(  cancelToken?: CancelToken | undefined): Promise<TaxQualificationStateDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetTaxQualificationState";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxQualificationState(_response);
        });
    }

    protected processGetTaxQualificationState(response: AxiosResponse): Promise<TaxQualificationStateDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxQualificationStateDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getTaxQualificationFlow(  cancelToken?: CancelToken | undefined): Promise<TaxQualificationFlowDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetTaxQualificationFlow";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTaxQualificationFlow(_response);
        });
    }

    protected processGetTaxQualificationFlow(response: AxiosResponse): Promise<TaxQualificationFlowDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxQualificationFlowDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    declareTaxQualification(body: DeclareMobileApplicationTaxQualificationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<TaxQualificationDeclarationResultDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/DeclareTaxQualification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeclareTaxQualification(_response);
        });
    }

    protected processDeclareTaxQualification(response: AxiosResponse): Promise<TaxQualificationDeclarationResultDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxQualificationDeclarationResultDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getMissingData(  cancelToken?: CancelToken | undefined): Promise<DriverMissingDataDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetMissingData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissingData(_response);
        });
    }

    protected processGetMissingData(response: AxiosResponse): Promise<DriverMissingDataDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverMissingDataDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    updateMissingData(body: UpdateMobileApplicationMissingDataCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/UpdateMissingData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMissingData(_response);
        });
    }

    protected processUpdateMissingData(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    attachMissingDocument(body: AttachMobileApplicationMissingDocumentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/AttachMissingDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAttachMissingDocument(_response);
        });
    }

    protected processAttachMissingDocument(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getDrivingLicense(  cancelToken?: CancelToken | undefined): Promise<DriverDrivingLicenseDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/GetDrivingLicense";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDrivingLicense(_response);
        });
    }

    protected processGetDrivingLicense(response: AxiosResponse): Promise<DriverDrivingLicenseDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverDrivingLicenseDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    selectTaxOffice(body: SelectMobileApplicationTaxOfficeCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/SelectTaxOffice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSelectTaxOffice(_response);
        });
    }

    protected processSelectTaxOffice(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    correctAddress(body: CorrectMobileApplicationAddressCommand | undefined , cancelToken?: CancelToken | undefined): Promise<TaxQualificationDeclarationResultDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplications/CorrectAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCorrectAddress(_response);
        });
    }

    protected processCorrectAddress(response: AxiosResponse): Promise<TaxQualificationDeclarationResultDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaxQualificationDeclarationResultDtoOperationResult>(null as any);
    }
}

export class MobileApplicationsSupportClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    sendAiMessage(body: SendMobileApplicationAiMessageCommand | undefined , cancelToken?: CancelToken | undefined): Promise<SendMobileApplicationAiMessageCommandDetailsOperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/SendAiMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendAiMessage(_response);
        });
    }

    protected processSendAiMessage(response: AxiosResponse): Promise<SendMobileApplicationAiMessageCommandDetailsOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SendMobileApplicationAiMessageCommandDetailsOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    createTicket(body: CreateMobileApplicationSupportTicketCommand | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/CreateTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTicket(_response);
        });
    }

    protected processCreateTicket(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getActiveTicket(  cancelToken?: CancelToken | undefined): Promise<SupportTicketDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/GetActiveTicket";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveTicket(_response);
        });
    }

    protected processGetActiveTicket(response: AxiosResponse): Promise<SupportTicketDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupportTicketDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    getArchivedTicketDetails(ticketId: number , cancelToken?: CancelToken | undefined): Promise<SupportTicketDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/GetArchivedTicketDetails/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetArchivedTicketDetails(_response);
        });
    }

    protected processGetArchivedTicketDetails(response: AxiosResponse): Promise<SupportTicketDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupportTicketDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    getTicketHistory(body: GetMobileApplicationSupportTicketHistoryQuery | undefined , cancelToken?: CancelToken | undefined): Promise<GetMobileApplicationSupportTicketHistoryQueryResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/GetTicketHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketHistory(_response);
        });
    }

    protected processGetTicketHistory(response: AxiosResponse): Promise<GetMobileApplicationSupportTicketHistoryQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMobileApplicationSupportTicketHistoryQueryResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getTicketMessages(ticketId: number, skip: number | undefined, take: number | undefined , cancelToken?: CancelToken | undefined): Promise<SupportTicketMessageDtoListOperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/GetTicketMessages/{ticketId}?";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketMessages(_response);
        });
    }

    protected processGetTicketMessages(response: AxiosResponse): Promise<SupportTicketMessageDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupportTicketMessageDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    sendDriverMessage(body: SendMobileApplicationDriverMessageCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/SendDriverMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDriverMessage(_response);
        });
    }

    protected processSendDriverMessage(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @param ticketId (optional) 
     * @param file (optional) 
     * @return Success
     */
    sendDriverFile(body: Body2 | undefined, ticketId: number | undefined, file: FileParameter | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/SendDriverFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (ticketId === null || ticketId === undefined)
            throw new Error("The parameter 'ticketId' cannot be null.");
        else
            content_.append("TicketId", ticketId.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendDriverFile(_response);
        });
    }

    protected processSendDriverFile(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    finishFileUpload(body: FinishMobileApplicationFileUploadCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/FinishFileUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinishFileUpload(_response);
        });
    }

    protected processFinishFileUpload(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @return Success
     */
    downloadTicketFile(messageId: number , cancelToken?: CancelToken | undefined): Promise<FileMimeDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/DownloadTicketFile/{messageId}";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadTicketFile(_response);
        });
    }

    protected processDownloadTicketFile(response: AxiosResponse): Promise<FileMimeDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileMimeDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    closeConversationByDriver(body: CloseMobileApplicationDriverConversationCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/CloseConversationByDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseConversationByDriver(_response);
        });
    }

    protected processCloseConversationByDriver(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    setTicketHelpfulness(body: SetMobileApplicationSupportTicketHelpfulnessCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/SetTicketHelpfulness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTicketHelpfulness(_response);
        });
    }

    protected processSetTicketHelpfulness(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    confirmTicketActivity(body: ConfirmMobileApplicationSupportTicketActivityCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileApplicationsSupport/ConfirmTicketActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmTicketActivity(_response);
        });
    }

    protected processConfirmTicketActivity(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class MobileAuthsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @param body (optional) 
     * @return Success
     */
    generateSmsCode(body: GenerateSmsCodeCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/MobileAuths/GenerateSmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSmsCode(_response);
        });
    }

    protected processGenerateSmsCode(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    driverLogin(body: DriverLoginCommand | undefined , cancelToken?: CancelToken | undefined): Promise<TokenDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileAuths/DriverLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDriverLogin(_response);
        });
    }

    protected processDriverLogin(response: AxiosResponse): Promise<TokenDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDtoOperationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    refreshToken(body: string | undefined , cancelToken?: CancelToken | undefined): Promise<TokenDtoOperationResult> {
        let url_ = this.baseUrl + "/MobileAuths/RefreshToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRefreshToken(_response);
        });
    }

    protected processRefreshToken(response: AxiosResponse): Promise<TokenDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenDtoOperationResult>(null as any);
    }
}

export class NotificationsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: DriverMobileApplication)
     * @param body (optional) 
     * @return Success
     */
    addToken(body: AddNotificationTokenCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Notifications/AddToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddToken(_response);
        });
    }

    protected processAddToken(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class OnlinePaymentsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @param id (optional) 
     * @return Success
     */
    status(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/OnlinePayments/Status?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatus(_response);
        });
    }

    protected processStatus(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOnlinePaymentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/OnlinePayments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    payUNotify(body: any | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/OnlinePayments/PayUNotify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayUNotify(_response);
        });
    }

    protected processPayUNotify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    checkOrderStatus(id: string , cancelToken?: CancelToken | undefined): Promise<OnlinePaymentPreviewDtoOperationResult> {
        let url_ = this.baseUrl + "/OnlinePayments/CheckOrderStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOrderStatus(_response);
        });
    }

    protected processCheckOrderStatus(response: AxiosResponse): Promise<OnlinePaymentPreviewDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnlinePaymentPreviewDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: OnlinePaymentListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<OnlinePaymentListQueryResult> {
        let url_ = this.baseUrl + "/OnlinePayments/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OnlinePaymentListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnlinePaymentListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/OnlinePayments/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class OrganisationsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: OrganisationsListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<OrganisationsListQueryResult> {
        let url_ = this.baseUrl + "/Organisations/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<OrganisationsListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationsListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getIdsAndNames(body: OrganisationsGetIdsAndNamesQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OrganisationsGetIdsAndNamesQueryResult> {
        let url_ = this.baseUrl + "/Organisations/GetIdsAndNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdsAndNames(_response);
        });
    }

    protected processGetIdsAndNames(response: AxiosResponse): Promise<OrganisationsGetIdsAndNamesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationsGetIdsAndNamesQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<OrganisationGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Organisations/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<OrganisationGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: OrganisationCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OrganisationCreateCommandResult> {
        let url_ = this.baseUrl + "/Organisations/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OrganisationCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: OrganisationUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OrganisationUpdateCommandResult> {
        let url_ = this.baseUrl + "/Organisations/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OrganisationUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Organisations/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * @param code (optional) 
     * @return Success
     */
    getAddress(code: string | undefined , cancelToken?: CancelToken | undefined): Promise<StringOperationResult> {
        let url_ = this.baseUrl + "/Organisations/GetAddress?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAddress(_response);
        });
    }

    protected processGetAddress(response: AxiosResponse): Promise<StringOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StringOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getForSelect(  cancelToken?: CancelToken | undefined): Promise<OrganisationSelectItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/Organisations/GetForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForSelect(_response);
        });
    }

    protected processGetForSelect(response: AxiosResponse): Promise<OrganisationSelectItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganisationSelectItemDtoListOperationResult>(null as any);
    }
}

export class PaymentsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updatePaymentSettings(body: PaymentUpdateSettingsCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Payments/UpdatePaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePaymentSettings(_response);
        });
    }

    protected processUpdatePaymentSettings(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getPaymentSettings(  cancelToken?: CancelToken | undefined): Promise<PaymentGetSettingsQueryResult> {
        let url_ = this.baseUrl + "/Payments/GetPaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentSettings(_response);
        });
    }

    protected processGetPaymentSettings(response: AxiosResponse): Promise<PaymentGetSettingsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentGetSettingsQueryResult>(null as any);
    }
}

export class PayoffClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: PayoffCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PayoffCreateCommandResult> {
        let url_ = this.baseUrl + "/Payoff/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PayoffCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getPaged(body: PayoffGetPagedQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PayoffGetPagedQueryResult> {
        let url_ = this.baseUrl + "/Payoff/GetPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<PayoffGetPagedQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffGetPagedQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<PayoffsGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Payoff/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<PayoffsGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffsGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: PayoffUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PayoffUpdateCommandResult> {
        let url_ = this.baseUrl + "/Payoff/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<PayoffUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getVehiclesForAutocomplete(body: PayoffGetVehiclesForAutocompleteQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PayoffGetVehiclesForAutocompleteQueryResult> {
        let url_ = this.baseUrl + "/Payoff/GetVehiclesForAutocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehiclesForAutocomplete(_response);
        });
    }

    protected processGetVehiclesForAutocomplete(response: AxiosResponse): Promise<PayoffGetVehiclesForAutocompleteQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffGetVehiclesForAutocompleteQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<PayoffDeleteCommandResult> {
        let url_ = this.baseUrl + "/Payoff/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<PayoffDeleteCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffDeleteCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    restore(body: PayoffRestoreDeletedCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<PayoffRestoreDeletedCommandResult> {
        let url_ = this.baseUrl + "/Payoff/Restore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<PayoffRestoreDeletedCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PayoffRestoreDeletedCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @return Success
     */
    createDayOffPayoff(driverId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Payoff/CreateDayOffPayoff?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDayOffPayoff(_response);
        });
    }

    protected processCreateDayOffPayoff(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    importPayoff(body: ImportPayoffCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ImportLogDtoOperationResult> {
        let url_ = this.baseUrl + "/Payoff/ImportPayoff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportPayoff(_response);
        });
    }

    protected processImportPayoff(response: AxiosResponse): Promise<ImportLogDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportLogDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    activate(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Payoff/Activate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivate(_response);
        });
    }

    protected processActivate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getDriverWithdrawStatus(id: number , cancelToken?: CancelToken | undefined): Promise<DriverWithdrawStatusDtoOperationResult> {
        let url_ = this.baseUrl + "/Payoff/GetDriverWithdrawStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDriverWithdrawStatus(_response);
        });
    }

    protected processGetDriverWithdrawStatus(response: AxiosResponse): Promise<DriverWithdrawStatusDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverWithdrawStatusDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    checkDriverBailiffPayoffs(id: number , cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/Payoff/CheckDriverBailiffPayoffs/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckDriverBailiffPayoffs(_response);
        });
    }

    protected processCheckDriverBailiffPayoffs(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    export(body: ExportPayoffsCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Payoff/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massDelete(body: MassDeletePayoffCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Payoff/MassDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassDelete(_response);
        });
    }

    protected processMassDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class ReferralsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: ReferralsListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<ReferralsListQueryResult> {
        let url_ = this.baseUrl + "/Referrals/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ReferralsListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralsListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: ReferralDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/Referrals/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Referrals/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: ReferralDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/Referrals/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @return Success
     */
    getById(id: number, dateStart: string | undefined, dateEnd: string | undefined , cancelToken?: CancelToken | undefined): Promise<ReferralDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/Referrals/GetById/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent("" + dateStart) + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "dateEnd=" + encodeURIComponent("" + dateEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ReferralDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReferralDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    driversList(body: DriversReferralsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<DriversReferralsQueryResult> {
        let url_ = this.baseUrl + "/Referrals/DriversList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDriversList(_response);
        });
    }

    protected processDriversList(response: AxiosResponse): Promise<DriversReferralsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriversReferralsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    rentPaidPercentageList(body: RentPaidPercentageReferralsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<RentPaidPercentageReferralsQueryResult> {
        let url_ = this.baseUrl + "/Referrals/RentPaidPercentageList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRentPaidPercentageList(_response);
        });
    }

    protected processRentPaidPercentageList(response: AxiosResponse): Promise<RentPaidPercentageReferralsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RentPaidPercentageReferralsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    settlementsList(body: SettlementsReferralsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementsReferralsQueryResult> {
        let url_ = this.baseUrl + "/Referrals/SettlementsList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettlementsList(_response);
        });
    }

    protected processSettlementsList(response: AxiosResponse): Promise<SettlementsReferralsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementsReferralsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    vehicleRentList(body: VehicleRentReferralsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleRentReferralsQueryResult> {
        let url_ = this.baseUrl + "/Referrals/VehicleRentList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVehicleRentList(_response);
        });
    }

    protected processVehicleRentList(response: AxiosResponse): Promise<VehicleRentReferralsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleRentReferralsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Referrals/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * @return Success
     */
    getExpirationDays(code: string , cancelToken?: CancelToken | undefined): Promise<Int32NullableOperationResult> {
        let url_ = this.baseUrl + "/Referrals/GetExpirationDays/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExpirationDays(_response);
        });
    }

    protected processGetExpirationDays(response: AxiosResponse): Promise<Int32NullableOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32NullableOperationResult>(null as any);
    }
}

export class ReportClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createSchema(body: ReportSchemaDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Report/CreateSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSchema(_response);
        });
    }

    protected processCreateSchema(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    schemaList(  cancelToken?: CancelToken | undefined): Promise<ReportSchemaDtoListOperationResult> {
        let url_ = this.baseUrl + "/Report/SchemaList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchemaList(_response);
        });
    }

    protected processSchemaList(response: AxiosResponse): Promise<ReportSchemaDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportSchemaDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateSchema(body: ReportSchemaDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Report/UpdateSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchema(_response);
        });
    }

    protected processUpdateSchema(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    deleteSchema(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Report/DeleteSchema/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSchema(_response);
        });
    }

    protected processDeleteSchema(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    restoreSchema(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Report/RestoreSchema/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreSchema(_response);
        });
    }

    protected processRestoreSchema(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    schemaListSelect(  cancelToken?: CancelToken | undefined): Promise<IdAndNameResultListOperationResult> {
        let url_ = this.baseUrl + "/Report/SchemaListSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSchemaListSelect(_response);
        });
    }

    protected processSchemaListSelect(response: AxiosResponse): Promise<IdAndNameResultListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdAndNameResultListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: ReportListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<ReportListQueryResult> {
        let url_ = this.baseUrl + "/Report/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ReportListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    details(id: number , cancelToken?: CancelToken | undefined): Promise<ReportDtoOperationResult> {
        let url_ = this.baseUrl + "/Report/Details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<ReportDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    onlyUpdate(body: ReportDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Report/OnlyUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOnlyUpdate(_response);
        });
    }

    protected processOnlyUpdate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateAndSendEmail(body: ReportDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Report/UpdateAndSendEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAndSendEmail(_response);
        });
    }

    protected processUpdateAndSendEmail(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    gerOverdueReport(id: number , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/Report/GerOverdueReport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGerOverdueReport(_response);
        });
    }

    protected processGerOverdueReport(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    checkOverdueReports(  cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/Report/CheckOverdueReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckOverdueReports(_response);
        });
    }

    protected processCheckOverdueReports(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }
}

export class ResourcesClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: ResourceListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<ResourceListQueryResult> {
        let url_ = this.baseUrl + "/Resources/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ResourceListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResourceListQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param name (optional) 
     * @return Success
     */
    create(name: string | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Resources/Create?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Resources/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Resources/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: ResourceDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Resources/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @param searchPhrase (optional) 
     * @return Success
     */
    getForPayoffAutocomplete(id: number | undefined, searchPhrase: string | undefined , cancelToken?: CancelToken | undefined): Promise<IdAndNameResultListOperationResult> {
        let url_ = this.baseUrl + "/Resources/GetForPayoffAutocomplete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (searchPhrase === null)
            throw new Error("The parameter 'searchPhrase' cannot be null.");
        else if (searchPhrase !== undefined)
            url_ += "searchPhrase=" + encodeURIComponent("" + searchPhrase) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForPayoffAutocomplete(_response);
        });
    }

    protected processGetForPayoffAutocomplete(response: AxiosResponse): Promise<IdAndNameResultListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IdAndNameResultListOperationResult>(null as any);
    }
}

export class SettingsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getSettlementSettings(  cancelToken?: CancelToken | undefined): Promise<SettlementSettingsDtoOperationResult> {
        let url_ = this.baseUrl + "/Settings/GetSettlementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettlementSettings(_response);
        });
    }

    protected processGetSettlementSettings(response: AxiosResponse): Promise<SettlementSettingsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementSettingsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateSettlementSettings(body: SettlementSettingsDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settings/UpdateSettlementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSettlementSettings(_response);
        });
    }

    protected processUpdateSettlementSettings(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class SettlementsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getPaged(body: SettlementsGetPagedQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementsGetPagedQueryResult> {
        let url_ = this.baseUrl + "/Settlements/GetPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<SettlementsGetPagedQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementsGetPagedQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<SettlementsGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Settlements/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SettlementsGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementsGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getLatestForSettlementCreation(body: GetBasicDataForSettlementCreationQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GetBasicDataForSettlementCreationQueryResult> {
        let url_ = this.baseUrl + "/Settlements/GetLatestForSettlementCreation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestForSettlementCreation(_response);
        });
    }

    protected processGetLatestForSettlementCreation(response: AxiosResponse): Promise<GetBasicDataForSettlementCreationQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBasicDataForSettlementCreationQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    checkIfSettled(body: HasBeenSettledQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/Settlements/CheckIfSettled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckIfSettled(_response);
        });
    }

    protected processCheckIfSettled(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @return Success
     */
    hasWaitingSettlements(driverId: number | undefined , cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/Settlements/HasWaitingSettlements?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHasWaitingSettlements(_response);
        });
    }

    protected processHasWaitingSettlements(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: SettlementCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementCreateCommandResult> {
        let url_ = this.baseUrl + "/Settlements/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<SettlementCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: SettlementUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementUpdateCommandResult> {
        let url_ = this.baseUrl + "/Settlements/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<SettlementUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    quickUpdate(body: SettlementQuickUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementQuickUpdateCommandResult> {
        let url_ = this.baseUrl + "/Settlements/QuickUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuickUpdate(_response);
        });
    }

    protected processQuickUpdate(response: AxiosResponse): Promise<SettlementQuickUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementQuickUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<SettlementDeleteCommandResult> {
        let url_ = this.baseUrl + "/Settlements/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<SettlementDeleteCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementDeleteCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    export(body: SettlementsExportDailyCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementsExportDailyCommandResult> {
        let url_ = this.baseUrl + "/Settlements/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<SettlementsExportDailyCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementsExportDailyCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportDetailed(body: ExportSettlementsDetailedCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Settlements/ExportDetailed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportDetailed(_response);
        });
    }

    protected processExportDetailed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportTakenCash(body: ExportTakenCashFromSettlementsCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Settlements/ExportTakenCash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportTakenCash(_response);
        });
    }

    protected processExportTakenCash(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getExportsInfo(  cancelToken?: CancelToken | undefined): Promise<GetExportsInfoQueryResult> {
        let url_ = this.baseUrl + "/Settlements/GetExportsInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportsInfo(_response);
        });
    }

    protected processGetExportsInfo(response: AxiosResponse): Promise<GetExportsInfoQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetExportsInfoQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    changePaymentStatus(body: SettlementChangePaymentStatusRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementChangePaymentStatusResult> {
        let url_ = this.baseUrl + "/Settlements/ChangePaymentStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePaymentStatus(_response);
        });
    }

    protected processChangePaymentStatus(response: AxiosResponse): Promise<SettlementChangePaymentStatusResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementChangePaymentStatusResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massDelete(body: SettlementMassDeleteCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassDelete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassDelete(_response);
        });
    }

    protected processMassDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    importTaxi(body: ImportTaxiCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ImportTaxiCommandResult> {
        let url_ = this.baseUrl + "/Settlements/ImportTaxi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportTaxi(_response);
        });
    }

    protected processImportTaxi(response: AxiosResponse): Promise<ImportTaxiCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportTaxiCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    importFood(body: ImportFoodCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ImportFoodCommandResult> {
        let url_ = this.baseUrl + "/Settlements/ImportFood";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportFood(_response);
        });
    }

    protected processImportFood(response: AxiosResponse): Promise<ImportFoodCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportFoodCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    sendEmailToDrivers(body: SendEmailToDriverCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/SendEmailToDrivers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailToDrivers(_response);
        });
    }

    protected processSendEmailToDrivers(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    sendEmailsToDrivers(body: SendEmailsToDriversCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/SendEmailsToDrivers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailsToDrivers(_response);
        });
    }

    protected processSendEmailsToDrivers(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massExportSettlements(body: ExportSettlementToFileForPaymentCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Settlements/MassExportSettlements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassExportSettlements(_response);
        });
    }

    protected processMassExportSettlements(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    getPaymentsById(id: number | undefined, isActive: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<PaymentGetAllByQueryResult> {
        let url_ = this.baseUrl + "/Settlements/GetPaymentsById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaymentsById(_response);
        });
    }

    protected processGetPaymentsById(response: AxiosResponse): Promise<PaymentGetAllByQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentGetAllByQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getExportHistory(body: SettlementsExportHistoryQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<SettlementsExportHistoryQueryResult> {
        let url_ = this.baseUrl + "/Settlements/GetExportHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportHistory(_response);
        });
    }

    protected processGetExportHistory(response: AxiosResponse): Promise<SettlementsExportHistoryQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettlementsExportHistoryQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    adjustCommissions(body: SettlementAdjustCommissionDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/AdjustCommissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdjustCommissions(_response);
        });
    }

    protected processAdjustCommissions(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    changeManualEditPayoff(body: SettlementChangeManualEditFlagCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/ChangeManualEditPayoff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeManualEditPayoff(_response);
        });
    }

    protected processChangeManualEditPayoff(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param driverId (optional) 
     * @return Success
     */
    sendEmailToDriver(driverId: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/SendEmailToDriver?";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "driverId=" + encodeURIComponent("" + driverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmailToDriver(_response);
        });
    }

    protected processSendEmailToDriver(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    exportSettlementToPdf(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Settlements/ExportSettlementToPdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSettlementToPdf(_response);
        });
    }

    protected processExportSettlementToPdf(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getOverdues(  cancelToken?: CancelToken | undefined): Promise<BooleanOperationResult> {
        let url_ = this.baseUrl + "/Settlements/GetOverdues";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOverdues(_response);
        });
    }

    protected processGetOverdues(response: AxiosResponse): Promise<BooleanOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createSettlementFromCash(body: SettlementCreateCashSettleCommand | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/Settlements/CreateSettlementFromCash";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSettlementFromCash(_response);
        });
    }

    protected processCreateSettlementFromCash(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    includeInExport(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/IncludeInExport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIncludeInExport(_response);
        });
    }

    protected processIncludeInExport(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    createInvoice(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Settlements/CreateInvoice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massUpdateServiceFee(body: SettlementMassUpdateServiceFeeDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassUpdateServiceFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassUpdateServiceFee(_response);
        });
    }

    protected processMassUpdateServiceFee(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massClearServiceFee(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassClearServiceFee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassClearServiceFee(_response);
        });
    }

    protected processMassClearServiceFee(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massCreateInvoice(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Settlements/MassCreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassCreateInvoice(_response);
        });
    }

    protected processMassCreateInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massMoveSettlementBackToWaiting(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassMoveSettlementBackToWaiting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassMoveSettlementBackToWaiting(_response);
        });
    }

    protected processMassMoveSettlementBackToWaiting(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massCancelSiiPayoffs(body: number[] | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassCancelSiiPayoffs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassCancelSiiPayoffs(_response);
        });
    }

    protected processMassCancelSiiPayoffs(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massAddSiiPayoffs(body: SettlementMassAddSiiPayoffsDto | undefined , cancelToken?: CancelToken | undefined): Promise<MassAddSiiPayoffsResultDtoOperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassAddSiiPayoffs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassAddSiiPayoffs(_response);
        });
    }

    protected processMassAddSiiPayoffs(response: AxiosResponse): Promise<MassAddSiiPayoffsResultDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MassAddSiiPayoffsResultDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massForceRavapiPaymentsTitle(body: MassForceRavapiPaymentsTitleCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Settlements/MassForceRavapiPaymentsTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassForceRavapiPaymentsTitle(_response);
        });
    }

    protected processMassForceRavapiPaymentsTitle(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getWithdrawStatus(id: number , cancelToken?: CancelToken | undefined): Promise<DriverWithdrawStatusDtoOperationResult> {
        let url_ = this.baseUrl + "/Settlements/GetWithdrawStatus/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWithdrawStatus(_response);
        });
    }

    protected processGetWithdrawStatus(response: AxiosResponse): Promise<DriverWithdrawStatusDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DriverWithdrawStatusDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    getLastModificationDate(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<DateTimeOperationResult> {
        let url_ = this.baseUrl + "/Settlements/GetLastModificationDate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastModificationDate(_response);
        });
    }

    protected processGetLastModificationDate(response: AxiosResponse): Promise<DateTimeOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateTimeOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    importPetrol(body: ImportPetrolCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ImportLogDtoOperationResult> {
        let url_ = this.baseUrl + "/Settlements/ImportPetrol";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportPetrol(_response);
        });
    }

    protected processImportPetrol(response: AxiosResponse): Promise<ImportLogDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportLogDtoOperationResult>(null as any);
    }
}

export class StatisticsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param dateStart (optional) 
     * @param dateEnd (optional) 
     * @param organisationId (optional) 
     * @param periodFilter (optional) 
     * @return Success
     */
    getDetails(dateStart: string | undefined, dateEnd: string | undefined, organisationId: number | undefined, periodFilter: SettlementPeriodFilterEnum | undefined , cancelToken?: CancelToken | undefined): Promise<StatisticsGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Statistics/GetDetails?";
        if (dateStart === null)
            throw new Error("The parameter 'dateStart' cannot be null.");
        else if (dateStart !== undefined)
            url_ += "dateStart=" + encodeURIComponent("" + dateStart) + "&";
        if (dateEnd === null)
            throw new Error("The parameter 'dateEnd' cannot be null.");
        else if (dateEnd !== undefined)
            url_ += "dateEnd=" + encodeURIComponent("" + dateEnd) + "&";
        if (organisationId === null)
            throw new Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        if (periodFilter === null)
            throw new Error("The parameter 'periodFilter' cannot be null.");
        else if (periodFilter !== undefined)
            url_ += "periodFilter=" + encodeURIComponent("" + periodFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<StatisticsGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatisticsGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    createBundle(body: StatisticsCreateBundleCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<StatisticsCreateCardCommandResult> {
        let url_ = this.baseUrl + "/Statistics/CreateBundle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBundle(_response);
        });
    }

    protected processCreateBundle(response: AxiosResponse): Promise<StatisticsCreateCardCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatisticsCreateCardCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getBundles(  cancelToken?: CancelToken | undefined): Promise<StatisticsGetBundlesQueryResult> {
        let url_ = this.baseUrl + "/Statistics/GetBundles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBundles(_response);
        });
    }

    protected processGetBundles(response: AxiosResponse): Promise<StatisticsGetBundlesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatisticsGetBundlesQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getBundleDetails(id: number , cancelToken?: CancelToken | undefined): Promise<StatisticsGetBundleDetailsQueryResult> {
        let url_ = this.baseUrl + "/Statistics/GetBundleDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBundleDetails(_response);
        });
    }

    protected processGetBundleDetails(response: AxiosResponse): Promise<StatisticsGetBundleDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatisticsGetBundleDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Statistics/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: StatisticsBundleBase | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Statistics/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class SupportTicketsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getTickets(body: GetTicketsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<GetTicketsQueryResult> {
        let url_ = this.baseUrl + "/SupportTickets/GetTickets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTickets(_response);
        });
    }

    protected processGetTickets(response: AxiosResponse): Promise<GetTicketsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTicketsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getOpenSupportTicketsCount(  cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/GetOpenSupportTicketsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenSupportTicketsCount(_response);
        });
    }

    protected processGetOpenSupportTicketsCount(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getTicketDetails(ticketId: number , cancelToken?: CancelToken | undefined): Promise<SupportTicketDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/GetTicketDetails/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketDetails(_response);
        });
    }

    protected processGetTicketDetails(response: AxiosResponse): Promise<SupportTicketDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupportTicketDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param skip (optional) 
     * @param take (optional) 
     * @return Success
     */
    getTicketMessages(ticketId: number, skip: number | undefined, take: number | undefined , cancelToken?: CancelToken | undefined): Promise<SupportTicketMessageDtoListOperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/GetTicketMessages/{ticketId}?";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTicketMessages(_response);
        });
    }

    protected processGetTicketMessages(response: AxiosResponse): Promise<SupportTicketMessageDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupportTicketMessageDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    claimTicket(body: ClaimTicketCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/ClaimTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClaimTicket(_response);
        });
    }

    protected processClaimTicket(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    takeOverTicket(body: TakeOverTicketCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/TakeOverTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTakeOverTicket(_response);
        });
    }

    protected processTakeOverTicket(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    sendEmployeeMessage(body: SendEmployeeMessageCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/SendEmployeeMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmployeeMessage(_response);
        });
    }

    protected processSendEmployeeMessage(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    grantUploadPermission(body: GrantUploadPermissionCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/GrantUploadPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGrantUploadPermission(_response);
        });
    }

    protected processGrantUploadPermission(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    endUploadPermission(body: EndUploadPermissionCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/EndUploadPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEndUploadPermission(_response);
        });
    }

    protected processEndUploadPermission(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    saveTicketFileToDriverFiles(body: SaveTicketFileToDriverFilesCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/SaveTicketFileToDriverFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveTicketFileToDriverFiles(_response);
        });
    }

    protected processSaveTicketFileToDriverFiles(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    closeTicket(body: CloseTicketCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/CloseTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloseTicket(_response);
        });
    }

    protected processCloseTicket(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    deleteTicket(body: DeleteTicketCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/DeleteTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTicket(_response);
        });
    }

    protected processDeleteTicket(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    restoreTicket(body: RestoreTicketCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/SupportTickets/RestoreTicket";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestoreTicket(_response);
        });
    }

    protected processRestoreTicket(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class TerytClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    searchCities(body: SearchTerytCitiesQuery | undefined , cancelToken?: CancelToken | undefined): Promise<TerytCitySuggestionDtoListOperationResult> {
        let url_ = this.baseUrl + "/Teryt/SearchCities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchCities(_response);
        });
    }

    protected processSearchCities(response: AxiosResponse): Promise<TerytCitySuggestionDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TerytCitySuggestionDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    searchStreets(body: SearchTerytStreetsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<TerytStreetSuggestionDtoListOperationResult> {
        let url_ = this.baseUrl + "/Teryt/SearchStreets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchStreets(_response);
        });
    }

    protected processSearchStreets(response: AxiosResponse): Promise<TerytStreetSuggestionDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TerytStreetSuggestionDtoListOperationResult>(null as any);
    }
}

export class TranslationsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @return Success
     */
    translations(language: SupportedLanguage , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Translations/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTranslations(_response);
        });
    }

    protected processTranslations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserNotificationsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getAll(  cancelToken?: CancelToken | undefined): Promise<MessageNotificationDtoListOperationResult> {
        let url_ = this.baseUrl + "/UserNotifications/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<MessageNotificationDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MessageNotificationDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    changeIsReaded(body: ChangeMessageNotificationIsReadedCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/UserNotifications/ChangeIsReaded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeIsReaded(_response);
        });
    }

    protected processChangeIsReaded(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    changeAllIsReaded(  cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/UserNotifications/ChangeAllIsReaded";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeAllIsReaded(_response);
        });
    }

    protected processChangeAllIsReaded(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getQuantity(  cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/UserNotifications/GetQuantity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQuantity(_response);
        });
    }

    protected processGetQuantity(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }
}

export class UsersClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getMyInfo(  cancelToken?: CancelToken | undefined): Promise<GetMyUserInfoQueryResult> {
        let url_ = this.baseUrl + "/Users/GetMyInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyInfo(_response);
        });
    }

    protected processGetMyInfo(response: AxiosResponse): Promise<GetMyUserInfoQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyUserInfoQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getPaged(body: UsersGetPagedQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UsersGetPagedQueryResult> {
        let url_ = this.baseUrl + "/Users/GetPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPaged(_response);
        });
    }

    protected processGetPaged(response: AxiosResponse): Promise<UsersGetPagedQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UsersGetPagedQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: string , cancelToken?: CancelToken | undefined): Promise<UserGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Users/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: UserCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UserCreateCommandResult> {
        let url_ = this.baseUrl + "/Users/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<UserCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: UserUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<UserUpdateCommandResult> {
        let url_ = this.baseUrl + "/Users/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<UserUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    generateNewPassword(body: ResetUserPasswordCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Users/GenerateNewPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateNewPassword(_response);
        });
    }

    protected processGenerateNewPassword(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Users/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: string , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Users/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getUsersForAutocomplete(  cancelToken?: CancelToken | undefined): Promise<UserAutocompleteDtoListOperationResult> {
        let url_ = this.baseUrl + "/Users/GetUsersForAutocomplete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersForAutocomplete(_response);
        });
    }

    protected processGetUsersForAutocomplete(response: AxiosResponse): Promise<UserAutocompleteDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAutocompleteDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportWithdrawSummary(body: ExportUserWithdrawSummaryCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Users/ExportWithdrawSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportWithdrawSummary(_response);
        });
    }

    protected processExportWithdrawSummary(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getExportWithdrawSummaryList(body: GetExportUserWithdrawSummaryListQuery | undefined , cancelToken?: CancelToken | undefined): Promise<GetExportUserWithdrawSummaryListQueryResult> {
        let url_ = this.baseUrl + "/Users/GetExportWithdrawSummaryList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportWithdrawSummaryList(_response);
        });
    }

    protected processGetExportWithdrawSummaryList(response: AxiosResponse): Promise<GetExportUserWithdrawSummaryListQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetExportUserWithdrawSummaryListQueryResult>(null as any);
    }
}

export class VehicleLogsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param organisationId (optional) 
     * @return Success
     */
    list(dateFrom: string | undefined, dateTo: string | undefined, organisationId: number | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleLogListItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/List?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent("" + dateTo) + "&";
        if (organisationId === null)
            throw new Error("The parameter 'organisationId' cannot be null.");
        else if (organisationId !== undefined)
            url_ += "organisationId=" + encodeURIComponent("" + organisationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<VehicleLogListItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleLogListItemDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    addEvent(body: VehicleLogAddEventDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/AddEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddEvent(_response);
        });
    }

    protected processAddEvent(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param date (optional) 
     * @param vehicleId (optional) 
     * @return Success
     */
    details(date: string | undefined, vehicleId: number | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleLogDetailsDtoOperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/Details?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDetails(_response);
        });
    }

    protected processDetails(response: AxiosResponse): Promise<VehicleLogDetailsDtoOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleLogDetailsDtoOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param date (optional) 
     * @param vehicleId (optional) 
     * @param comment (optional) 
     * @return Success
     */
    createComment(date: string | undefined, vehicleId: number | undefined, comment: string | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/CreateComment?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param vehicleLogCommentId (optional) 
     * @param comment (optional) 
     * @return Success
     */
    updateComment(vehicleLogCommentId: number | undefined, comment: string | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/UpdateComment?";
        if (vehicleLogCommentId === null)
            throw new Error("The parameter 'vehicleLogCommentId' cannot be null.");
        else if (vehicleLogCommentId !== undefined)
            url_ += "vehicleLogCommentId=" + encodeURIComponent("" + vehicleLogCommentId) + "&";
        if (comment === null)
            throw new Error("The parameter 'comment' cannot be null.");
        else if (comment !== undefined)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    iconSchemaList(  cancelToken?: CancelToken | undefined): Promise<VehicleLogIconSchemaDtoListOperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/IconSchemaList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIconSchemaList(_response);
        });
    }

    protected processIconSchemaList(response: AxiosResponse): Promise<VehicleLogIconSchemaDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleLogIconSchemaDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    addIconSchema(body: VehicleLogIconSchemaDto | undefined , cancelToken?: CancelToken | undefined): Promise<Int32OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/AddIconSchema";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIconSchema(_response);
        });
    }

    protected processAddIconSchema(response: AxiosResponse): Promise<Int32OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Int32OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    deleteIconSchema(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/DeleteIconSchema/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIconSchema(_response);
        });
    }

    protected processDeleteIconSchema(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    addIcon(body: VehicleLogIconDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/AddIcon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIcon(_response);
        });
    }

    protected processAddIcon(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param searchPhrase (optional) 
     * @return Success
     */
    getIconSchemaForAutocomplete(searchPhrase: string | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleLogIconSchemaDtoListOperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/GetIconSchemaForAutocomplete?";
        if (searchPhrase === null)
            throw new Error("The parameter 'searchPhrase' cannot be null.");
        else if (searchPhrase !== undefined)
            url_ += "searchPhrase=" + encodeURIComponent("" + searchPhrase) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIconSchemaForAutocomplete(_response);
        });
    }

    protected processGetIconSchemaForAutocomplete(response: AxiosResponse): Promise<VehicleLogIconSchemaDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleLogIconSchemaDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    deleteIcon(id: number , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/VehicleLogs/DeleteIcon/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteIcon(_response);
        });
    }

    protected processDeleteIcon(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }
}

export class VehiclesClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getAll(body: VehiclesGetAllQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<VehiclesGetAllQueryResult> {
        let url_ = this.baseUrl + "/Vehicles/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<VehiclesGetAllQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesGetAllQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getVehicleDriverHistories(body: VehicleGetAllDriversHistoryQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<VehicleGetAllDriversHistoryQueryResult> {
        let url_ = this.baseUrl + "/Vehicles/GetVehicleDriverHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVehicleDriverHistories(_response);
        });
    }

    protected processGetVehicleDriverHistories(response: AxiosResponse): Promise<VehicleGetAllDriversHistoryQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleGetAllDriversHistoryQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getById(id: number , cancelToken?: CancelToken | undefined): Promise<VehiclesGetDetailsQueryResult> {
        let url_ = this.baseUrl + "/Vehicles/GetById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VehiclesGetDetailsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesGetDetailsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    create(body: VehiclesCreateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<VehiclesCreateCommandResult> {
        let url_ = this.baseUrl + "/Vehicles/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<VehiclesCreateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesCreateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    update(body: VehiclesUpdateCommandRequest | undefined , cancelToken?: CancelToken | undefined): Promise<VehiclesUpdateCommandResult> {
        let url_ = this.baseUrl + "/Vehicles/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<VehiclesUpdateCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesUpdateCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    getForDriverAutocomplete(body: VehiclesGetForDriverAutocompleteQueryRequest | undefined , cancelToken?: CancelToken | undefined): Promise<VehiclesGetForDriverAutocompleteQueryResult> {
        let url_ = this.baseUrl + "/Vehicles/GetForDriverAutocomplete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetForDriverAutocomplete(_response);
        });
    }

    protected processGetForDriverAutocomplete(response: AxiosResponse): Promise<VehiclesGetForDriverAutocompleteQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesGetForDriverAutocompleteQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    delete(id: number , cancelToken?: CancelToken | undefined): Promise<VehicleDeleteCommandResult> {
        let url_ = this.baseUrl + "/Vehicles/Delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<VehicleDeleteCommandResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleDeleteCommandResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    restore(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/Restore?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRestore(_response);
        });
    }

    protected processRestore(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param vehicleId (optional) 
     * @param body (optional) 
     * @return Success
     */
    addIncident(vehicleId: number | undefined, body: VehicleIncidentBase | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/AddIncident?";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddIncident(_response);
        });
    }

    protected processAddIncident(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param vehicleId (optional) 
     * @param isVehicleShared (optional) 
     * @param body (optional) 
     * @return Success
     */
    changeDriver(vehicleId: number | undefined, isVehicleShared: boolean | undefined, body: VehicleSharingInformationDto | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/ChangeDriver?";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (isVehicleShared === null)
            throw new Error("The parameter 'isVehicleShared' cannot be null.");
        else if (isVehicleShared !== undefined)
            url_ += "isVehicleShared=" + encodeURIComponent("" + isVehicleShared) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeDriver(_response);
        });
    }

    protected processChangeDriver(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateIncidents(body: VehicleUpdateIncidentsCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/UpdateIncidents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIncidents(_response);
        });
    }

    protected processUpdateIncidents(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massSetCommission(body: VehicleMassSetCommissionCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/MassSetCommission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassSetCommission(_response);
        });
    }

    protected processMassSetCommission(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getIdsAndNames(  cancelToken?: CancelToken | undefined): Promise<VehiclesGetIdsAndNamesQueryResult> {
        let url_ = this.baseUrl + "/Vehicles/GetIdsAndNames";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIdsAndNames(_response);
        });
    }

    protected processGetIdsAndNames(response: AxiosResponse): Promise<VehiclesGetIdsAndNamesQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehiclesGetIdsAndNamesQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @return Success
     */
    getIncidents(id: number , cancelToken?: CancelToken | undefined): Promise<VehicleIncidentDtoListOperationResult> {
        let url_ = this.baseUrl + "/Vehicles/GetIncidents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIncidents(_response);
        });
    }

    protected processGetIncidents(response: AxiosResponse): Promise<VehicleIncidentDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleIncidentDtoListOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    massSetIncludedInPromotionDayOff(body: VehicleMassChangeIncludedInPromotionDayOffCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/MassSetIncludedInPromotionDayOff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMassSetIncludedInPromotionDayOff(_response);
        });
    }

    protected processMassSetIncludedInPromotionDayOff(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param id (optional) 
     * @return Success
     */
    getLastModificationDate(id: number | undefined , cancelToken?: CancelToken | undefined): Promise<DateTimeOperationResult> {
        let url_ = this.baseUrl + "/Vehicles/GetLastModificationDate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLastModificationDate(_response);
        });
    }

    protected processGetLastModificationDate(response: AxiosResponse): Promise<DateTimeOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DateTimeOperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportVehiclesToCsv(body: ExportAllVehiclesToCsvCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Vehicles/ExportVehiclesToCsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportVehiclesToCsv(_response);
        });
    }

    protected processExportVehiclesToCsv(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    updateReturnDate(body: VehicleUpdateReturnDateCommand | undefined , cancelToken?: CancelToken | undefined): Promise<OperationResult> {
        let url_ = this.baseUrl + "/Vehicles/UpdateReturnDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateReturnDate(_response);
        });
    }

    protected processUpdateReturnDate(response: AxiosResponse): Promise<OperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OperationResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportVehiclePaidRent(body: ExportVehiclePaidRentCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Vehicles/ExportVehiclePaidRent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportVehiclePaidRent(_response);
        });
    }

    protected processExportVehiclePaidRent(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    setVehiclesCashback(body: SetVehiclesCashbackCommand | undefined , cancelToken?: CancelToken | undefined): Promise<SetVehiclesCashbackResultItemDtoListOperationResult> {
        let url_ = this.baseUrl + "/Vehicles/SetVehiclesCashback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetVehiclesCashback(_response);
        });
    }

    protected processSetVehiclesCashback(response: AxiosResponse): Promise<SetVehiclesCashbackResultItemDtoListOperationResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetVehiclesCashbackResultItemDtoListOperationResult>(null as any);
    }
}

export class WorkLogsClient extends ApiClientBase {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    list(body: WorkLogsQuery | undefined , cancelToken?: CancelToken | undefined): Promise<WorkLogsQueryResult> {
        let url_ = this.baseUrl + "/WorkLogs/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<WorkLogsQueryResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            try {
                result200 = JSON.parse(resultData200);
            }
            catch (e) {
                result200 = resultData200;
            }
            return result200;

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorkLogsQueryResult>(null as any);
    }

    /**
     * (Auth policies: ApiScope)
     * @param body (optional) 
     * @return Success
     */
    exportWorkLogs(body: ExportWorkLogsCommand | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/WorkLogs/ExportWorkLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportWorkLogs(_response);
        });
    }

    protected processExportWorkLogs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface AddNotificationTokenCommand {
    token?: string | undefined;
}

export interface AdditionalCityFeeDto {
    name?: string | undefined;
    value?: number;
}

export interface AdditionsListStatistics {
    payoffId?: number;
    quota?: number;
    userFullName?: string | undefined;
    userId?: string | undefined;
    driver?: string | undefined;
}

export interface AdditionsNumberAndAmountStatistics {
    quantity?: number;
    quota?: number;
    userFullName?: string | undefined;
}

export interface AiAssistantConfigurationDto {
    id?: number;
    isEnabled?: boolean;
    isDriverDataAccessEnabled?: boolean;
    model?: string | undefined;
    maxOutputTokens?: number;
    monthlyBudget?: number;
    dialogsPerDriverPerDay?: number;
    dialogsPerDriverPerHour?: number;
    classificationConfidenceThreshold?: number;
    supportHoursFrom?: string;
    supportHoursTo?: string;
    supportWorksOnMonday?: boolean;
    supportWorksOnTuesday?: boolean;
    supportWorksOnWednesday?: boolean;
    supportWorksOnThursday?: boolean;
    supportWorksOnFriday?: boolean;
    supportWorksOnSaturday?: boolean;
    supportWorksOnSunday?: boolean;
    chatAttachmentRetentionDays?: number;
    isKnowledgeLearningEnabled?: boolean;
    knowledgeLearningIntervalDays?: number;
    knowledgeLearningTicketLimit?: number;
    knowledgeLearningProposalThreshold?: number;
    knowledgeLearningObservationExpiryDays?: number;
    knowledgeLearningLastRunAt?: string | undefined;
    assistantBudgetReservePercent?: number;
    modificationDate?: string;
    currentPeriodUsage?: AiUsageDto;
    usageHistory?: AiUsageDto[] | undefined;
}

export interface AiAssistantConfigurationDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiAssistantConfigurationDto;
}

export interface AiChatMessageDto {
    role?: AiChatRoleEnum;
    content?: string | undefined;
    kind?: AiMessageKindEnum;
}

export enum AiChatRoleEnum {
    User = 1,
    Assistant = 2,
}

export interface AiKnowledgeArticleDetailsDto {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    createdAt?: string;
    modificationDate?: string;
    modificationUserName?: string | undefined;
    content?: string | undefined;
}

export interface AiKnowledgeArticleDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiKnowledgeArticleDetailsDto;
}

export enum AiKnowledgeArticleFieldEnum {
    Title = 1,
    Description = 2,
    Keywords = 3,
    Category = 4,
}

export interface AiKnowledgeArticleListItemDto {
    id?: number;
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    createdAt?: string;
    modificationDate?: string;
    modificationUserName?: string | undefined;
}

export interface AiKnowledgeArticleListItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: AiKnowledgeArticleListItemDto[] | undefined;
}

export interface AiKnowledgeArticleReviewDto {
    articleId?: number;
    article?: AiKnowledgeArticleValuesDto;
    contentLines?: string[] | undefined;
    fragments?: AiKnowledgeFragmentDto[] | undefined;
    canPrepareAgain?: boolean;
}

export interface AiKnowledgeArticleReviewDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiKnowledgeArticleReviewDto;
}

export interface AiKnowledgeArticleValuesDto {
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    content?: string | undefined;
}

export interface AiKnowledgeArticleValuesDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiKnowledgeArticleValuesDto;
}

export interface AiKnowledgeFragmentDto {
    id?: number;
    articleId?: number;
    statusId?: AiKnowledgeProposalStatusEnum;
    justification?: string | undefined;
    changes?: AiKnowledgeProposalChangeDto[] | undefined;
    observations?: AiKnowledgeProposalObservationDto[] | undefined;
}

export interface AiKnowledgeFragmentEditDto {
    proposalId?: number;
    articleId?: number;
    statusId?: AiKnowledgeProposalStatusEnum;
    isApplicable?: boolean;
    current?: AiKnowledgeArticleValuesDto;
    proposed?: AiKnowledgeArticleValuesDto;
    articleModificationDate?: string;
    changes?: AiKnowledgeProposalChangeDto[] | undefined;
    observations?: AiKnowledgeProposalObservationDto[] | undefined;
}

export interface AiKnowledgeFragmentEditDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiKnowledgeFragmentEditDto;
}

export interface AiKnowledgeFragmentPreparedDto {
    isAlreadyCovered?: boolean;
}

export interface AiKnowledgeFragmentPreparedDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiKnowledgeFragmentPreparedDto;
}

export interface AiKnowledgeObservationListItemDto {
    id?: number;
    text?: string | undefined;
    articleId?: number | undefined;
    articleCategory?: string | undefined;
    articleTitle?: string | undefined;
    proposalId?: number | undefined;
    proposalStatusId?: AiKnowledgeProposalStatusEnum;
    statusId?: AiKnowledgeObservationStatusEnum;
    ticketIds?: number[] | undefined;
    lastTicketAt?: string;
}

export interface AiKnowledgeObservationListItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: AiKnowledgeObservationListItemDto[] | undefined;
}

export enum AiKnowledgeObservationStatusEnum {
    Collecting = 1,
    Proposed = 2,
    Approved = 3,
    Rejected = 4,
    AlreadyCovered = 5,
    Expired = 6,
}

export interface AiKnowledgeProposalChangeDto {
    id?: number;
    order?: number;
    kindId?: AiKnowledgeProposalChangeKindEnum;
    newText?: string | undefined;
    originalText?: string | undefined;
    lineIndex?: number | undefined;
}

export enum AiKnowledgeProposalChangeKindEnum {
    AppendToParagraph = 1,
    InsertParagraphAfter = 2,
    ReplaceParagraph = 3,
    ReplaceKeywords = 4,
    ReplaceDescription = 5,
}

export interface AiKnowledgeProposalDetailsDto {
    id?: number;
    statusId?: AiKnowledgeProposalStatusEnum;
    proposed?: AiKnowledgeArticleValuesDto;
    justification?: string | undefined;
    rejectionReason?: string | undefined;
    observations?: AiKnowledgeProposalObservationDto[] | undefined;
}

export interface AiKnowledgeProposalDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: AiKnowledgeProposalDetailsDto;
}

export interface AiKnowledgeProposalObservationDto {
    id?: number;
    text?: string | undefined;
    ticketIds?: number[] | undefined;
}

export enum AiKnowledgeProposalStatusEnum {
    Pending = 1,
    Approved = 2,
    ApprovedWithChanges = 3,
    Rejected = 4,
    ParagraphChanged = 5,
}

export enum AiMessageKindEnum {
    Knowledge = 1,
    Clarification = 2,
    NoAnswerHandoff = 3,
    Fallback = 4,
    RateLimit = 5,
    DialogLimit = 6,
    QuickReply = 7,
    SmartHandoff = 8,
    SmartGreet = 9,
    SmartClose = 10,
    AccountData = 11,
}

export interface AiSupportHoursContextDto {
    from?: string | undefined;
    to?: string | undefined;
}

export interface AiUsageDto {
    periodStart?: string;
    estimatedCostUsd?: number;
    knowledgeLearningCostUsd?: number;
}

export enum AmountFilterTypeEnum {
    LessThanOrEqualTo = 0,
    GreaterOrEqualTo = 1,
}

export enum ApplicationAccountActiveStatus {
    ActiveFree = 1,
    ActiveInUse = 2,
    ActiveInUseNotWorkingFromOneUpToThreeDays = 3,
    ActiveInUseNotWorkingFromFourUpToFiveDays = 4,
    TempBanned = 5,
    PermBanned = 6,
    SimCardDown = 7,
}

export interface ApplicationAccountCreateCommandRequest {
    organisationId?: number | undefined;
    driverId?: number | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    isActive?: boolean;
    activeDate?: string | undefined;
    isBanned?: boolean;
    isPermBanned?: boolean;
    isBannedTo?: string | undefined;
    applicationId?: ApplicationEnum;
    email?: string | undefined;
    notes?: string | undefined;
    isDeleted?: boolean;
    forceAccountActiveStatus?: ApplicationAccountActiveStatus;
    paymentTypeHistoryItems?: ApplicationAccountPaymentTypeHistoryItem[] | undefined;
    owner?: ApplicationAccountOwnerEnum;
    assignDriversPaymentType?: boolean;
}

export interface ApplicationAccountCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface ApplicationAccountFile {
    id?: number;
    fileName?: string | undefined;
}

export interface ApplicationAccountForDriverGetAll {
    name?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ApplicationAccountIdAndNameResult {
    id: number;
    name: string;
    applicationId?: ApplicationEnum;
    owner?: ApplicationAccountOwnerEnum;
}

export enum ApplicationAccountOwnerEnum {
    Company = 1,
    Driver = 2,
}

export interface ApplicationAccountPaymentTypeHistoryItem {
    id?: number;
    beginDate?: string | undefined;
    isActive?: boolean;
    preferredPaymentTypeId?: PreferredPaymentTypeEnum;
}

export interface ApplicationAccountUpdateCommandRequest {
    organisationId?: number | undefined;
    driverId?: number | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    isActive?: boolean;
    activeDate?: string | undefined;
    isBanned?: boolean;
    isPermBanned?: boolean;
    isBannedTo?: string | undefined;
    applicationId?: ApplicationEnum;
    email?: string | undefined;
    notes?: string | undefined;
    isDeleted?: boolean;
    forceAccountActiveStatus?: ApplicationAccountActiveStatus;
    paymentTypeHistoryItems?: ApplicationAccountPaymentTypeHistoryItem[] | undefined;
    owner?: ApplicationAccountOwnerEnum;
    assignDriversPaymentType?: boolean;
    id?: number;
    mediaIds?: number[] | undefined;
}

export interface ApplicationAccountUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface ApplicationAccountsDeleteCommandResult {
    success: boolean;
    errors: string[];
}

export interface ApplicationAccountsDriverHistoryQueryResultItem {
    from?: string | undefined;
    to?: string | undefined;
    driverFullName?: string | undefined;
    driverId?: number | undefined;
}

export interface ApplicationAccountsGetAllQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    application?: ApplicationEnum;
    organisationId?: number | undefined;
    isBanned?: boolean | undefined;
    showDeleted?: boolean;
    stateDate?: string | undefined;
    owner: ApplicationAccountOwnerEnum;
    driverFullName?: string | undefined;
    comments?: string | undefined;
}

export interface ApplicationAccountsGetAllQueryResult {
    success: boolean;
    errors: string[];
    result?: ApplicationAccountsGetAllQueryResultItemPagedResultBody;
}

export interface ApplicationAccountsGetAllQueryResultItem {
    id?: number;
    name?: string | undefined;
    organisation?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    isActive?: boolean;
    isBanned?: boolean;
    isPermBanned?: boolean;
    isBannedTo?: string | undefined;
    driver?: string | undefined;
    applicationId?: ApplicationEnum;
    preferredPaymentType?: PreferredPaymentTypeEnum;
    lastAccountActive?: string | undefined;
    accountActiveStatus?: ApplicationAccountActiveStatus;
    email?: string | undefined;
    isDeleted?: boolean;
    owner?: ApplicationAccountOwnerEnum;
    comments?: string | undefined;
}

export interface ApplicationAccountsGetAllQueryResultItemPagedResultBody {
    items: ApplicationAccountsGetAllQueryResultItem[];
    count: number;
}

export interface ApplicationAccountsGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: ApplicationAccountsGetDetailsQueryResultDetails;
}

export interface ApplicationAccountsGetDetailsQueryResultDetails {
    organisationId?: number | undefined;
    driverId?: number | undefined;
    name?: string | undefined;
    phoneNumber?: string | undefined;
    password?: string | undefined;
    isActive?: boolean;
    activeDate?: string | undefined;
    isBanned?: boolean;
    isPermBanned?: boolean;
    isBannedTo?: string | undefined;
    applicationId?: ApplicationEnum;
    email?: string | undefined;
    notes?: string | undefined;
    isDeleted?: boolean;
    forceAccountActiveStatus?: ApplicationAccountActiveStatus;
    paymentTypeHistoryItems?: ApplicationAccountPaymentTypeHistoryItem[] | undefined;
    owner?: ApplicationAccountOwnerEnum;
    assignDriversPaymentType?: boolean;
    id?: number;
    media?: ApplicationAccountFile[] | undefined;
}

export interface ApplicationAccountsGetDriverHistoryQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: ApplicationAccountsDriverHistoryQueryResultItem[] | undefined;
}

export interface ApplicationAccountsGetIdsAndNamesQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: ApplicationAccountIdAndNameResult[] | undefined;
}

export enum ApplicationEnum {
    Uber = 1,
    Bolt = 2,
    FreeNow = 3,
    UberEats = 4,
    BoltFood = 5,
    Glovo = 6,
    XpressDelivery = 7,
    Stuart = 8,
    Lime = 9,
    Dpd = 10,
    Wolt = 11,
    SzamaExpress = 12,
    ITaxi = 13,
    Tasku = 14,
    None = 15,
    Jush = 16,
    Novapost = 17,
    Flovi = 18,
}

export interface ApplicationSettlementBonusSettingDto {
    applicationId: ApplicationEnum;
    applicationName: string;
    bonusTaxVat: number;
}

export interface ApplicationSettlementGetDetailsQueryResultDetails {
    settlementId: number;
    applicationId: ApplicationEnum;
    applicationAccountId?: number | undefined;
    applicationQuota: number;
    promotion: number;
    tips: number;
    netBonus: number;
    minus: number;
    commission: number;
    remainingTax: number;
    grossBonus: number;
    isExcludedFromCommissions: boolean;
    owner: ApplicationAccountOwnerEnum;
    id: number;
    applicationAccountName: string;
}

export interface ApplicationSettlementItem {
    id?: number;
    settlementId?: number;
    applicationId?: ApplicationEnum;
    applicationAccountName?: string | undefined;
    applicationQuota?: number;
    promotion?: number;
    tips?: number;
    netBonus?: number;
    minus?: number;
    commission?: number;
    remainingTax?: number;
    grossBonus?: number;
    applicationTotal?: number;
    sum?: number;
}

export interface ApplicationSettlementStatistics {
    applicationType?: ApplicationEnum;
    applicationQuota?: number;
    promotion?: number;
    tips?: number;
    netBonus?: number;
    minus?: number;
    commission?: number;
    remainingTax?: number;
    grossBonus?: number;
    applicationTotal?: number;
    sum?: number;
}

export interface ApplicationTypeAndValue {
    application?: ApplicationEnum;
    readonly displayName?: string | undefined;
    value?: number;
}

export interface ApproveDriverVehicleReservationCommand {
    id?: number;
}

export interface ApproveKnowledgeProposalCommand {
    proposalId?: number;
    isEdited?: boolean;
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    content?: string | undefined;
    articleModificationDate?: string | undefined;
}

export interface ArticlesGetAllByGroupQueryRequest {
    groupSlug: string;
}

export interface ArticlesGetAllByGroupQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: ArticlesGetAllByGroupQueryResultDetails[] | undefined;
}

export interface ArticlesGetAllByGroupQueryResultDetails {
    title: string;
    articleSlug: string;
}

export interface ArticlesGetAllGroupsQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: ArticlesGetAllGroupsQueryResultDetails[] | undefined;
}

export interface ArticlesGetAllGroupsQueryResultDetails {
    groupSlug: string;
    groupName: string;
}

export interface ArticlesGetDetailsQueryRequest {
    groupSlug: string;
    articleSlug: string;
}

export interface ArticlesGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: ArticlesGetDetailsQueryResultDetails;
}

export interface ArticlesGetDetailsQueryResultDetails {
    userName: string;
    title: string;
    articleSlug: string;
    groupSlug: string;
    content: string;
    modificationDate: string;
}

export interface AssignVehicleToReservationCommand {
    reservationId?: number;
    vehicleId?: number;
}

export interface AttachMobileApplicationMissingDocumentCommand {
    documentTypeId?: FileTypeEnum;
    mediumId?: number;
}

export enum AuditEntryChangedByType {
    User = 1,
    Driver = 2,
    System = 3,
}

export enum AuditEntryType {
    Create = 1,
    Modification = 2,
    Delete = 3,
    Restore = 4,
}

export interface AverageDriversScore {
    days?: number;
    earnings?: number;
    earningsIncludePayoffs?: number;
}

export enum B2BFilter {
    SettlingB2B = 0,
    NotSettlingB2B = 1,
}

export interface BonusCampaignCourseDto {
    id?: number;
    bonusCampaignId?: number;
    courseQuantity: number;
    bonusAmount: number;
}

export interface BonusCampaignDto {
    id: number;
    description: string;
    dateStart: string;
    dateEnd: string;
    status: BonusCampaignStatusEnum;
    amount?: number | undefined;
    application: ApplicationEnum;
    organisationIds?: number[] | undefined;
    courses?: BonusCampaignCourseDto[] | undefined;
    vehicles?: BonusCampaignVehicleDto[] | undefined;
    additionalConditions: number;
    canBeModify: boolean;
}

export interface BonusCampaignDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: BonusCampaignDto[] | undefined;
}

export interface BonusCampaignDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: BonusCampaignDto;
}

export interface BonusCampaignDtoPagedResultBody {
    items: BonusCampaignDto[];
    count: number;
}

export interface BonusCampaignListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    status?: BonusCampaignStatusEnum;
    vehicleBrand?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    organisationId?: number | undefined;
    vehicleId?: number | undefined;
    description?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    application?: ApplicationEnum;
    amount?: number | undefined;
    sticker?: StickerEnum;
}

export interface BonusCampaignListQueryResult {
    success: boolean;
    errors: string[];
    result?: BonusCampaignDtoPagedResultBody;
}

export enum BonusCampaignStatusEnum {
    Active = 1,
    Upcome = 2,
    Finished = 3,
}

export interface BonusCampaignVehicleDto {
    id?: number;
    bonusCampaignId?: number;
    vehicleId?: number | undefined;
    vehicleBrand?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    name?: string | undefined;
    stickerId?: StickerEnum;
}

export interface BooleanOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: boolean;
}

export interface CancelDriverVehicleReservationCommand {
    id?: number;
    cancelReason?: DriverVehicleReservationCancelReasonEnum;
}

export interface CancelInstallmentSchemaCommand {
    id?: number;
}

export interface CancelMobileApplicationVehicleReservationCommand {
    id?: number;
}

export interface CanceledPayoffsStatistics {
    quantity?: number;
    quota?: number;
    userFullName?: string | undefined;
}

export interface CashFlowDto {
    organisationId: number;
    value: number;
    description: string;
    resourceId?: number | undefined;
    createdTime?: string;
    updatedTime?: string;
    isDeleted?: boolean;
    cashFlowPaymentTypeId: CashFlowPaymentTypeEnum;
    media: CashFlowMediumDto[];
}

export interface CashFlowDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: CashFlowDto;
}

export interface CashFlowListItemDto {
    id?: number;
    settlementId?: number | undefined;
    payoffId?: number | undefined;
    organisation?: string | undefined;
    driver?: string | undefined;
    value?: number;
    sum?: number;
    description?: string | undefined;
    reasonId?: PayoffReasonEnum;
    isDeleted?: boolean;
    resourceName?: string | undefined;
    createdTime?: string | undefined;
    updatedTime?: string | undefined;
    cashFlowPaymentTypeId?: CashFlowPaymentTypeEnum;
    payoffPaymentTypeId?: PayoffPaymentTypeEnum;
    cashFlowReportId?: number | undefined;
}

export interface CashFlowListItemDtoPagedResultBody {
    items: CashFlowListItemDto[];
    count: number;
}

export interface CashFlowListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    organisationId?: number | undefined;
    showDeleted?: boolean;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    markIncludedInReport?: boolean;
}

export interface CashFlowListQueryResult {
    success: boolean;
    errors: string[];
    result?: CashFlowListItemDtoPagedResultBody;
    organisationsCashBalances?: OrganisationCashBalance[] | undefined;
}

export interface CashFlowMediumDto {
    id?: number;
    name?: string | undefined;
}

export enum CashFlowPaymentTypeEnum {
    Cash = 1,
    Transfer = 2,
    AdvancePaymentCash = 3,
    AdvancePaymentTransfer = 4,
}

export interface CashFlowReportListItemDto {
    id: number;
    organisationId: number;
    organisation: string;
    cashBefore: number;
    depositCashBefore: number;
    cashAfter: number;
    depositCashAfter: number;
    dateStart: string;
    dateEnd: string;
    isSend: boolean;
    includedInReport: CashFlowShortListItemDto[];
    notIncludedInReport: CashFlowShortListItemDto[];
}

export interface CashFlowReportListItemDtoPagedResultBody {
    items: CashFlowReportListItemDto[];
    count: number;
}

export interface CashFlowReportListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    organisationId?: number | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface CashFlowReportListQueryResult {
    success: boolean;
    errors: string[];
    result?: CashFlowReportListItemDtoPagedResultBody;
}

export interface CashFlowShortListItemDto {
    fullName: string;
    source: CashFlowSourceEnum;
    type?: CashFlowPaymentTypeEnum;
    description?: string | undefined;
    resource?: string | undefined;
    updatedTime?: string | undefined;
    value: number;
}

export enum CashFlowSourceEnum {
    Settlement = 1,
    Payoff = 2,
    CashFlow = 3,
}

export interface ChangeMassCampaignStatusCommand {
    id?: number;
    status?: MassCampaignStatusEnum;
}

export interface ChangeMessageNotificationIsReadedCommand {
    id?: number;
    state?: boolean;
}

export interface ChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
}

export interface ChargeExemptDriverDto {
    id: number;
    fullName: string;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
}

export interface ChargeExemptDriverDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: ChargeExemptDriverDto[] | undefined;
}

export interface ClaimTicketCommand {
    ticketId?: number;
}

export interface CloseMobileApplicationDriverConversationCommand {
    ticketId?: number;
}

export interface CloseTicketCommand {
    ticketId?: number;
    closeReasonId?: SupportTicketCloseReasonEnum;
    comment?: string | undefined;
}

export enum CollectionOperatorEnum {
    AtLeastOneOfSelected = 1,
    AllIncluded = 2,
}

export enum ColumnTypeEnum {
    IntegerNumber = 1,
    DecimalNumber = 2,
    Text = 3,
    DateTime = 4,
    Boolean = 5,
    Enum = 6,
    List = 7,
    Unknown = 8,
}

export interface ColumnTypeNameDto {
    name?: string | undefined;
    columnType?: ColumnTypeEnum;
    isList?: boolean;
}

export enum CommissionBaseFieldEnum {
    ApplicationTotal = 1,
    Sum = 2,
}

export enum CommissionCalculationTypeEnum {
    AsMuchAsPossible = 1,
    AllOrNothing = 2,
    ForceAll = 3,
}

export interface ConditionDto {
    id?: number;
    parentConditionGroupId?: number | undefined;
    parentConditionGroup?: ConditionGroupDto;
    childConditionGroupId?: number | undefined;
    childConditionGroup?: ConditionGroupDto;
    conditionKey: string;
    nestedProperty?: string | undefined;
    operator: string;
    conditionValue: string;
    collectionOperator?: string | undefined;
}

export interface ConditionGroupDto {
    id?: number;
    groupTypeId: GroupTypeEnum;
    ruleId: number;
    isEditable: boolean;
    conditions: ConditionDto[];
}

export interface ConfirmMobileApplicationSupportTicketActivityCommand {
    ticketId?: number;
}

export enum ContractStatusEnum {
    Active = 1,
    Inactive = 2,
}

export interface CorrectMobileApplicationAddressCommand {
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    voivodeship?: string | undefined;
}

export interface CountryDto {
    code?: string | undefined;
    name?: string | undefined;
}

export interface CountryDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: CountryDto[] | undefined;
}

export interface CreateArticleCommand {
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    content?: string | undefined;
}

export interface CreateCashRegisterDocumentCommand {
    settlementId?: number;
    driverId?: number;
}

export interface CreateMassCampaignCommand {
    mediumId?: number | undefined;
    campaignToCopy?: MassCampaignCopyDto;
    executionDate?: string;
    messages?: MassCampaignMessageDto[] | undefined;
}

export interface CreateMobileApplicationOnlinePaymentCommand {
    amount?: number;
    invoiceType?: InvoiceTypeEnum;
    createType?: CreateOnlinePaymentTypeEnum;
}

export interface CreateMobileApplicationSupportTicketCommand {
    history?: AiChatMessageDto[] | undefined;
    language?: DriverLanguageEnum;
}

export interface CreateMobileApplicationVehicleReservationCommand {
    date?: string;
    vehicleType?: VehicleTypeEnum;
    vehicleName?: VehicleNameEnum;
}

export interface CreateOnlinePaymentCommand {
    driverId?: number;
    amount?: number;
    createType?: CreateOnlinePaymentTypeEnum;
    isDashboardRequest?: boolean;
    includeInvoice?: boolean;
    invoiceNip?: string | undefined;
    invoiceType?: InvoiceTypeEnum;
}

export enum CreateOnlinePaymentTypeEnum {
    ForFuturePayment = 1,
    ForFuturePaymentForTransport = 2,
    DebtPayment = 3,
    AdvancePayment = 4,
}

export interface DashboardDriverShortStatisticsDto {
    organisationName: string;
    fullName: string;
    driverId: number;
    registrationDate: string;
    hasContact: boolean;
}

export interface DashboardDriverShortStatisticsDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DashboardDriverShortStatisticsDto[] | undefined;
}

export interface DashboardPayoffSelectItemDto {
    id: number;
    date?: string | undefined;
    customReason: string;
    reason?: PayoffReasonEnum;
    baseQuota: number;
    remainingQuota: number;
    amount: number;
    isSelected: boolean;
    comment: string;
}

export interface DashboardPayoffSelectItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DashboardPayoffSelectItemDto[] | undefined;
}

export interface DashboardSearchEngineDriverDto {
    id: number;
    fullName: string;
}

export interface DashboardSearchEngineDto {
    id: number;
    recordTypeEnum: DashboardSearchEngineRecordTypeEnum;
    displayName: string;
    date?: string | undefined;
    drivers: DashboardSearchEngineDriverDto[];
}

export interface DashboardSearchEngineDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DashboardSearchEngineDto[] | undefined;
}

export enum DashboardSearchEngineRecordTypeEnum {
    Driver = 1,
    Vehicle = 2,
    ApplicationAccount = 3,
    Settlement = 4,
}

export interface DashboardVehicleDetailsStatisticsDto {
    type: VehicleTypeEnum;
    registrationNumber: string;
    vehicleId: number;
    drivers: IdAndNameResult[];
    status: VehicleStatusEnum;
    sticker?: string | undefined;
}

export interface DashboardVehicleShortStatisticsDto {
    type: VehicleTypeEnum;
    rented: number;
    readyToWork: number;
    workshop: number;
    theft: number;
    organisationId: number;
    detailsStatistics: DashboardVehicleDetailsStatisticsDto[];
}

export interface DashboardVehicleStatisticsDto {
    organisationId?: number;
    shortStatistics?: DashboardVehicleShortStatisticsDto[] | undefined;
}

export interface DashboardVehicleStatisticsDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DashboardVehicleStatisticsDto[] | undefined;
}

export interface DateAndValue {
    date?: string;
    value?: number;
}

export interface DateTimeListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: string[] | undefined;
}

export interface DateTimeOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: string;
}

export interface DayOffListItemDto {
    id: number;
    fullName: string;
    driverId: number;
    phoneNumber: string;
    vehicleName: string;
    settlementId: number;
    settlementNumber: string;
    date?: string | undefined;
    organisationId: number;
    baseQuota: number;
}

export interface DayOffListItemDtoPagedResultBody {
    items: DayOffListItemDto[];
    count: number;
}

export interface DayOffListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    showDeleted?: boolean;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    fullName?: string | undefined;
    phoneNumber?: string | undefined;
    vehicleName?: string | undefined;
    settlementNumber?: string | undefined;
}

export interface DayOffListQueryResult {
    success: boolean;
    errors: string[];
    result?: DayOffListItemDtoPagedResultBody;
}

export interface DebtSettingDto {
    id: number;
    color: string;
    icon: string;
    value: number;
}

export interface DebtorListItemDto {
    id: number;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    vehicleName?: string | undefined;
    vehicleId?: number | undefined;
    organisation?: string | undefined;
    currentBalance: number;
    balanceWithDeposits: number;
    dateOfFirstUnpaidPayoff?: string | undefined;
    dateOfLastUnpaidPayoff?: string | undefined;
    debtNotes?: string | undefined;
    isContactedForDebt: boolean;
    debtSetting?: DebtSettingDto;
    statusDateCallForPayment?: string | undefined;
    numberOfCallsForPayment: number;
    hasAccessToPayUPayments: boolean;
}

export interface DebtorListItemDtoPagedResultBody {
    items: DebtorListItemDto[];
    count: number;
}

export interface DecimalNullableOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: number | undefined;
}

export interface DeclareMobileApplicationTaxQualificationCommand {
    path?: TaxQualificationPathEnum;
    pesel?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    voivodeship?: string | undefined;
    socialInsuranceOption?: SocialInsuranceOptionEnum;
    contractStartDate?: string | undefined;
    nip?: string | undefined;
    studentCardMediumId?: number | undefined;
    workPermitMediumId?: number | undefined;
    contractOfMandateOtherEmployerMediumId?: number | undefined;
    lastModificationDate?: string;
}

export interface DeleteTicketCommand {
    ticketIds?: number[] | undefined;
}

export interface DigitalDocumentDriverHistoryDto {
    id: number;
    type: DigitalDocumentTypeEnum;
    mediaId?: number | undefined;
    hasSignatures?: boolean;
}

export enum DigitalDocumentGroupTypeEnum {
    VehicleRent = 1,
    DriverHrTag = 2,
    Driver = 3,
}

export enum DigitalDocumentListFilterTypeEnum {
    Waiting = 1,
    Signed = 2,
    Deleted = 3,
}

export interface DigitalDocumentListItemDto {
    id?: number;
    digitalDocumentTypeId?: DigitalDocumentTypeEnum;
    driverFullName?: string | undefined;
    driverId?: number;
    vehicleName?: string | undefined;
    vehicleId?: number;
    isSigned?: boolean;
    isDeleted?: boolean;
    isForcedReceive?: boolean;
    createdBy?: string;
    createdByName?: string | undefined;
    createdDate?: string;
    updatedBy?: string | undefined;
    updatedByName?: string | undefined;
    updatedDate?: string | undefined;
    contractSubject?: string | undefined;
    hasSignatures?: boolean;
}

export interface DigitalDocumentListItemDtoPagedResultBody {
    items: DigitalDocumentListItemDto[];
    count: number;
}

export interface DigitalDocumentQueueDriverDto {
    id: number;
    fullName: string;
    isDebtor: boolean;
}

export interface DigitalDocumentQueueDto {
    type: DigitalDocumentTypeEnum;
    status: DigitalDocumentStatusEnum;
    model: string;
    bonusCamapignId?: number | undefined;
    isForcedReceive: boolean;
}

export interface DigitalDocumentQueueStatusDto {
    driverId: number;
    fullName: string;
    isForcedReceive: boolean;
    type: DigitalDocumentTypeEnum;
    status: DigitalDocumentStatusEnum;
    contractSubject: string;
}

export interface DigitalDocumentSignatureDetailsDto {
    id?: number;
    digitalDocumentId?: number;
    driverId?: number | undefined;
    userId?: string | undefined;
    userFullName?: string | undefined;
    driverFullName?: string | undefined;
    organisation?: string | undefined;
    date?: string | undefined;
    digitalDocumentSignerType?: DigitalDocumentSignerTypeEnum;
}

export interface DigitalDocumentSignatureDetailsDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DigitalDocumentSignatureDetailsDto[] | undefined;
}

export interface DigitalDocumentSignatureDriverDto {
    id: number;
    fullName: string;
    email: string;
    phoneNumber: string;
}

export interface DigitalDocumentSignatureDto {
    id: number;
    driver: DigitalDocumentSignatureDriverDto;
    vehicleRent?: DigitalDocumentSignatureVehicleRentDto;
    documentModel?: string | undefined;
    isValid: boolean;
    type: DigitalDocumentTypeEnum;
    fileUrl: string;
    bonusCamapignId?: number | undefined;
    isForcedReceive: boolean;
    createdDate?: string;
    signatures: DigitalDocumentSignatureFieldDto[];
    previousTransferProtocolModel?: string | undefined;
    previousTransferProtocolFileName?: string | undefined;
    previousTransferProtocolFileId?: number | undefined;
    employeeId?: string | undefined;
    employeeFullName?: string | undefined;
}

export interface DigitalDocumentSignatureDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DigitalDocumentSignatureDto;
}

export interface DigitalDocumentSignatureFieldDto {
    name: string;
    value: string;
    signatureDate?: string;
}

export interface DigitalDocumentSignatureVehicleRentDto {
    id: number;
    name: string;
    dailyCommissions?: number;
    readonly weeklyCommissions?: number;
    vehicleType?: VehicleTypeEnum;
}

export enum DigitalDocumentSignerTypeEnum {
    Driver = 1,
    User = 2,
}

export enum DigitalDocumentStatusEnum {
    NotFound = 1,
    WaitingForSignature = 2,
    IsSigned = 3,
}

export enum DigitalDocumentTypeEnum {
    LeaseAgreement = 1,
    LoanAgreement = 2,
    TransferProtocol = 3,
    ReceivingProtocol = 4,
    PromissoryNote = 5,
    DeclarationLackOfSII = 6,
    ContractOfMandateDriver = 7,
    ContractOfMandateCourier = 8,
    StudentStatusConfirmation = 9,
    BikeTransferProtocol = 10,
    BikeReceivingProtocol = 11,
    GeneralProtocol = 12,
    CashRegisterReceipt = 13,
    CashRegisterDisbursement = 14,
}

export enum DisabilityLevelEnum {
    Light = 1,
    Moderate = 2,
    Significant = 3,
    UnderSixteen = 4,
}

export enum DisableMobileApplicationRequestStatusEnum {
    Pending = 1,
    Finished = 2,
}

export interface DocumentDto {
    id?: number;
    name?: string | undefined;
}

export interface DocumentDtoPagedResultBody {
    items: DocumentDto[];
    count: number;
}

export interface DocumentIdAndNameResult {
    id: number;
    name: string;
}

export interface DocumentListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface DocumentListQueryResult {
    success: boolean;
    errors: string[];
    result?: DocumentDtoPagedResultBody;
}

export enum DocumentRejectionReasonEnum {
    Unreadable = 1,
    Expired = 2,
    WrongDocument = 3,
    IncompleteScan = 4,
    DataMismatch = 5,
    Other = 6,
}

export enum DocumentVerificationStatusEnum {
    Unverified = 1,
    Confirmed = 2,
    Rejected = 3,
}

export interface DocumentsGetIdsAndNamesQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: DocumentIdAndNameResult[] | undefined;
}

export interface DriverAddPit11Command {
    media?: IdAndNameResult[] | undefined;
    sendPitOnDriverEmail?: boolean;
    getRandomDriverEmailResult?: boolean;
}

export interface DriverAutocompleteDto {
    id: number;
    fullName: string;
    email: string;
    phoneNumber: string;
    disabled: boolean;
    vehicle: VehicleDetailsForDriverAutocompleteDto;
}

export interface DriverAutocompleteDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DriverAutocompleteDto[] | undefined;
}

export interface DriverBalanceDto {
    id?: number;
    settlementsBalance?: number;
    settlementsCurrentBalance?: number;
    settlementsCurrentBalanceWithoutFuturePayoffs?: number;
    settlementsTotalBalance?: number;
    externalBalance?: number;
}

export interface DriverBalanceDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverBalanceDto;
}

export interface DriverCompanyDataDto {
    name?: string | undefined;
    nip?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    propertyNumber?: string | undefined;
    postalCode?: string | undefined;
    postTown?: string | undefined;
    flatNumber?: string | undefined;
    isComplete?: boolean;
}

export interface DriverCompanyDataDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverCompanyDataDto;
}

export interface DriverContactFormListItemDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    town?: string | undefined;
    serviceDescription?: string | undefined;
    serviceModel?: string | undefined;
    driverContactFormServiceTypeId?: DriverContactFormServiceTypeEnum;
    vehicleModel?: DriverContactFormVehicleModelEnum;
    hasContacted?: boolean;
    contactDate?: string | undefined;
    completingFormDate?: string;
    language?: DriverLanguageEnum;
}

export interface DriverContactFormListItemDtoPagedResultBody {
    items: DriverContactFormListItemDto[];
    count: number;
}

export interface DriverContactFormListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    town?: string | undefined;
    driverContactFormServiceTypeId?: DriverContactFormServiceTypeEnum;
    hasContacted?: boolean | undefined;
    contactDateStart?: string | undefined;
    contactDateEnd?: string | undefined;
    completingFormDateStart?: string | undefined;
    completingFormDateEnd?: string | undefined;
    vehicleModel?: DriverContactFormVehicleModelEnum;
    language?: DriverLanguageEnum;
}

export interface DriverContactFormListQueryResult {
    success: boolean;
    errors: string[];
    result?: DriverContactFormListItemDtoPagedResultBody;
}

export enum DriverContactFormServiceTypeEnum {
    Courier = 1,
    Taxi = 2,
    BikeService = 3,
    Unknown = 4,
}

export enum DriverContactFormVehicleModelEnum {
    ToyotaCorolla2018 = 1,
    ToyotaYarisCross2023 = 2,
    ToyotaYaris2022 = 3,
    SkodaFabia2018 = 4,
    DaciaLodgy2016 = 5,
    FordFocus2018 = 6,
    KiaRio2018 = 7,
    ToyotaAygo2021 = 8,
    ToyotaCHR = 9,
    MtbBike = 1000,
    CityBike = 1001,
    Scooter = 1002,
    CommonBike = 1003,
    Mtb100120 = 1004,
    Mtb6080 = 1005,
    City100120 = 1006,
    City6080 = 1007,
}

export interface DriverDebtorsPenaltySummaryExportHistoryListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface DriverDebtorsPenaltySummaryExportHistoryListQueryResult {
    success: boolean;
    errors: string[];
    result?: DriverDebtorsPenaltySummaryExportHistoryListQueryResultItemPagedResultBody;
}

export interface DriverDebtorsPenaltySummaryExportHistoryListQueryResultItem {
    id: number;
    userId: string;
    userName: string;
    date: string;
    mediumId: number;
    fileName: string;
}

export interface DriverDebtorsPenaltySummaryExportHistoryListQueryResultItemPagedResultBody {
    items: DriverDebtorsPenaltySummaryExportHistoryListQueryResultItem[];
    count: number;
}

export enum DriverDiscoverySourceEnum {
    Facebook = 1,
    Olx = 2,
    GoogleMaps = 3,
    Posters = 4,
    Instagram = 5,
    LargeScreenAdvertising = 6,
    CarAdvertising = 7,
    FriendReferral = 8,
    GoogleSearch = 9,
    BlueCityAdvertising = 10,
    BikeAdvertising = 11,
    OtherAdvertising = 12,
}

export interface DriverDiscoverySourceEnumInt32IdAndValueData {
    id?: DriverDiscoverySourceEnum;
    value?: number;
}

export interface DriverDocumentVerificationDto {
    id?: number;
    documentTypeId?: FileTypeEnum;
    verificationStatusId?: DocumentVerificationStatusEnum;
    rejectionReasonId?: DocumentRejectionReasonEnum;
    customReason?: string | undefined;
    mediumId?: number | undefined;
    driverId?: number;
}

export interface DriverDrivingLicenseCategoryDto {
    category?: string | undefined;
    expirationDate?: string | undefined;
}

export interface DriverDrivingLicenseCodeValueDto {
    code: string;
    value: string;
}

export interface DriverDrivingLicenseDetailsDto {
    documentStatusCode: string;
    documentStatusDisplayName: string;
    documentExpirationDate?: string | undefined;
    statusChangeReasons: DriverDrivingLicenseCodeValueDto[];
    licenseCategories: DriverDrivingLicenseItemDto[];
    alerts: DriverDrivingLicenseCodeValueDto[];
}

export interface DriverDrivingLicenseDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverDrivingLicenseDetailsDto;
}

export interface DriverDrivingLicenseDto {
    isNotFoundInRegistry?: boolean;
    documentStatusCode?: string | undefined;
    documentStatusDisplayName?: string | undefined;
    documentExpirationDate?: string | undefined;
    fullName?: string | undefined;
    drivingLicenseNumber?: string | undefined;
    readDate?: string;
    categories?: DriverDrivingLicenseCategoryDto[] | undefined;
}

export interface DriverDrivingLicenseDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverDrivingLicenseDto;
}

export interface DriverDrivingLicenseItemDto {
    category: string;
    expirationDate?: string | undefined;
}

export interface DriverExportToPdfEquipmentReturnRequestCommand {
    id?: number;
}

export interface DriverExportToPdfProofOfIncomeCommand {
    id?: number;
    dateStart?: string;
    dateEnd?: string;
}

export interface DriverExportToPdfRequestForPaymentCommand {
    id?: number;
    payoffIds?: number[] | undefined;
    withPaymentUrl?: boolean;
}

export enum DriverFilter {
    All = 0,
    UseCompanyCar = 1,
    UseCompanyApplicationAccount = 2,
    TakePartInLegalizationProcess = 3,
    Debtors = 4,
    ContactHasNotBeenMade = 5,
    MyDriverList = 6,
}

export enum DriverForVerificationDetailsFilter {
    Lacks = 0,
    PersonalVerification = 1,
    SiiMakingDecision = 2,
    OtherProblem = 3,
    CepikVerificationRequired = 4,
}

export interface DriverGetMultipleForAutocompleteQuery {
    searchPhrase?: string | undefined;
    ids?: number[] | undefined;
    showDisabled?: boolean;
}

export interface DriverHrTagBasicInfoDto {
    id?: number;
    hrTagId?: number;
    hrStatusEnum?: HrStatusEnum;
}

export interface DriverIdAndNameResult {
    id: number;
    name: string;
    organisationId?: number | undefined;
}

export interface DriverInfoDto {
    id?: number;
    displayName?: string | undefined;
    organisationId?: number;
    officeName?: string | undefined;
    officeAddress?: string | undefined;
    organisationInvoicingMethod?: OrganisationOnlinePaymentInvoicingMethodEnum;
    driverStatus?: DriverMobileStatusEnum;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    bankAccountNumber?: string | undefined;
    workCountryId?: WorkCountryEnum;
    haveAccessToPayUPayments?: boolean;
    disableMobileApplicationRequestStatusId?: DisableMobileApplicationRequestStatusEnum;
    driverSelectedVehicleId?: DriverSelectedVehicleTypeEnum;
    withdrawBlockReasonId?: WithdrawBlockReasonEnum;
    supportHoursFrom?: string | undefined;
    supportHoursTo?: string | undefined;
    supportWorksOnMonday?: boolean;
    supportWorksOnTuesday?: boolean;
    supportWorksOnWednesday?: boolean;
    supportWorksOnThursday?: boolean;
    supportWorksOnFriday?: boolean;
    supportWorksOnSaturday?: boolean;
    supportWorksOnSunday?: boolean;
}

export interface DriverInfoDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverInfoDto;
}

export interface DriverInsuranceDto {
    id?: number;
    typeId?: DriverInsuranceTypeEnum;
    text?: string | undefined;
    externalWage?: ExternalWageEnum;
    verificationStatusId?: DocumentVerificationStatusEnum;
    rejectionReasonId?: DocumentRejectionReasonEnum;
    customReason?: string | undefined;
    mediumId?: number | undefined;
    disabilityLevelId?: DisabilityLevelEnum;
    driverId?: number;
}

export enum DriverInsuranceTypeEnum {
    InsuranceFromWork = 1,
    InsuranceFromDuty = 2,
    InsuranceFromOtherOrder = 3,
    InsuranceFromContract = 4,
    InsuranceFromDifferentSource = 5,
    Pensioner = 6,
    Annuitant = 7,
    Student = 8,
    DisabilityCertificate = 9,
}

export enum DriverLanguageEnum {
    Pl = 1,
    En = 2,
    Ru = 3,
    Cz = 4,
}

export interface DriverLegalizationServiceHistoryDto {
    id?: number;
    type?: LegalizationHistoryTypeEnum;
    description?: string | undefined;
    date?: string;
    media?: DriverLegalizationServiceHistoryMediumDto[] | undefined;
}

export interface DriverLegalizationServiceHistoryMediumDto {
    id?: number;
    fileName?: string | undefined;
}

export interface DriverListHrTagDto {
    id?: number;
    name?: string | undefined;
    hrStatusEnum?: HrStatusEnum;
    icon?: string | undefined;
}

export interface DriverLoginCommand {
    login?: string | undefined;
    password?: string | undefined;
}

export interface DriverMassExportToPdfRequestForPaymentCommand {
    driverIds?: number[] | undefined;
    withPaymentUrl?: boolean;
}

export interface DriverMediaFile {
    id?: number;
    fileName?: string | undefined;
    isMobileAppVisible?: boolean;
}

export interface DriverMissingDataDto {
    isApplicable?: boolean;
    isOptional?: boolean;
    pesel?: string | undefined;
    isPeselEditable?: boolean;
    drivingLicenseNumber?: string | undefined;
    isDrivingLicenseNumberEditable?: boolean;
    actionRequiredCount?: number;
    documents?: DriverMissingDocumentDto[] | undefined;
}

export interface DriverMissingDataDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverMissingDataDto;
}

export interface DriverMissingDocumentDto {
    documentTypeId?: FileTypeEnum;
    verificationStatusId?: DocumentVerificationStatusEnum;
    rejectionReasonId?: DocumentRejectionReasonEnum;
    customReason?: string | undefined;
    mediumId?: number | undefined;
    fileName?: string | undefined;
    isActionRequired?: boolean;
}

export interface DriverMobileFileDto {
    mediumId?: number;
    fileTypeId?: FileTypeEnum;
    originalFileName?: string | undefined;
    createdAt?: string;
    status?: ContractStatusEnum;
}

export interface DriverMobileFileDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DriverMobileFileDto[] | undefined;
}

export interface DriverMobileMissingFilesDto {
    required?: MissingFileTypeDto[] | undefined;
    optional?: MissingFileTypeDto[] | undefined;
}

export interface DriverMobileMissingFilesDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverMobileMissingFilesDto;
}

export enum DriverMobileStatusEnum {
    ActionRequired = 1,
    PendingActivation = 2,
    Suspended = 3,
    Idle = 4,
    Active = 5,
    BeforeFirstSettlement = 6,
}

export interface DriverNameDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface DriverPaymentTypeHistoryItem {
    id?: number;
    beginDate?: string | undefined;
    isActive?: boolean;
    applicationAccountName?: string | undefined;
    applicationAccountId?: number | undefined;
    preferredPaymentTypeId?: PreferredPaymentTypeEnum;
    applicationAccountOwner?: ApplicationAccountOwnerEnum;
    assignForAllApplicationAccounts?: boolean;
}

export interface DriverPaymentTypeStatusStatistics {
    driverStatusEnum?: DriverStatusEnum;
    daily?: number;
    weekly?: number;
    onDemand?: number;
    readonly sum?: number;
}

export interface DriverPreferredPaymentTypeStatistics {
    daily?: number;
    weekly?: number;
    onDemand?: number;
    readonly sum?: number;
}

export interface DriverReferralDto {
    id?: number;
    driverId?: number;
    driverFullName?: string | undefined;
    registerDate?: string | undefined;
    activityDate?: string | undefined;
}

export interface DriverReferralDtoPagedResultBody {
    items: DriverReferralDto[];
    count: number;
}

export enum DriverSelectedVehicleTypeEnum {
    Car = 1,
    Motor = 2,
    Bike = 3,
}

export interface DriverSiiSumaryItemDto {
    month: number;
    paidAmount: number;
    billedAmount: number;
    overduePaidAmount: number;
}

export interface DriverSiiSumaryItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: DriverSiiSumaryItemDto[] | undefined;
}

export enum DriverStatusEnum {
    Active = 1,
    Warning = 2,
    New = 3,
    Problem = 4,
    Inactive = 5,
    WaitingForActivation = 6,
    NoSettlementsInLast2Weeks = 7,
    Bailiff = 8,
    Debtor = 9,
    PaymentSuspension = 10,
    Fraud = 11,
    OfficeVisitRequired = 12,
    Duplicate = 13,
    FilesMissingAfterUserRegistration = 14,
    HasMobileApplication = 15,
}

export interface DriverStatusTagDto {
    id: number;
    driverId: number;
    driverStatusId: DriverStatusEnum;
    reason?: string | undefined;
}

export interface DriverStatusTagListItemDto {
    driverStatusId?: DriverStatusEnum;
    reason?: string | undefined;
}

export interface DriverSubjectDto {
    name?: string | undefined;
    nip?: string | undefined;
    regon?: string | undefined;
    krs?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    propertyNumber?: string | undefined;
    flatNumber?: string | undefined;
    postalCode?: string | undefined;
    postTown?: string | undefined;
    isVatPayer: boolean;
    isAuthorizedToRepresentTheCompany: boolean;
    isCompanyActive: boolean;
    isVatPayerConfirmation: boolean;
    isAuthorizedToRepresentTheCompanyConfirmation: boolean;
    isCompanyActiveConfirmation: boolean;
    isManualEdit: boolean;
}

export interface DriverSubjectDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverSubjectDto;
}

export interface DriverTaxOfficeDto {
    taxOffices?: string[] | undefined;
}

export interface DriverTaxOfficeDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverTaxOfficeDto;
}

export enum DriverVehicleReservationCancelReasonEnum {
    NotApprovedInTime = 1,
    VehicleUnavailable = 2,
    CancelledByDriver = 3,
    CancelledByUser = 4,
    ArrangementsChange = 5,
}

export interface DriverVehicleReservationListItemDto {
    id: number;
    date: string;
    vehicleTypeId: VehicleTypeEnum;
    vehicleNameId?: VehicleNameEnum;
    vehicleId?: number | undefined;
    driverId?: number;
    driverFullName?: string | undefined;
    vehicleName?: string | undefined;
    vehicleOrganisationId?: number | undefined;
    statusId: DriverVehicleReservationStatusEnum;
    cancelReasonId?: DriverVehicleReservationCancelReasonEnum;
    createdAt: string;
    changedAt?: string | undefined;
    changedByUserId?: string | undefined;
    changedByUser?: string | undefined;
}

export interface DriverVehicleReservationListItemDtoPagedResultBody {
    items: DriverVehicleReservationListItemDto[];
    count: number;
}

export enum DriverVehicleReservationStatusEnum {
    Waiting = 1,
    Approved = 2,
    Cancelled = 3,
}

export interface DriverVehicleShareDto {
    newVehicle?: DriverVehicleShareItemDto;
    oldVehicle?: DriverVehicleShareItemDto;
}

export interface DriverVehicleShareItemDto {
    id: number;
    vehicleName: string;
    isVehicleHistoryShouldEndToday: boolean;
    vehicleDrivers: DriverNameDto[];
}

export interface DriverVerificationCountDto {
    lacksCount: number;
    personalVerificationCount: number;
    siiMakingDecisionCount: number;
    otherProblemCount: number;
    cepikVerificationCount: number;
}

export interface DriverVerificationCountDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverVerificationCountDto;
}

export interface DriverVerificationDto {
    id?: number;
    organisation?: string | undefined;
    vehicle?: string | undefined;
    firstName?: string | undefined;
    secondName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    studentCardExpiryDate?: string | undefined;
    dayOfReportToSSI?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    hrNotes?: string | undefined;
    driverHrTags?: DriverListHrTagDto[] | undefined;
    hasLackOfData?: boolean;
    hasPersonalVerificationData?: boolean;
    hasSiiMakingDecisionData?: boolean;
    hasOtherProblem?: boolean;
}

export interface DriverVerificationDtoPagedResultBody {
    items: DriverVerificationDto[];
    count: number;
}

export enum DriverVerificationFilter {
    ForVerification = 0,
    Verified = 1,
}

export interface DriverVerificationFilterCounter {
    lacksCount: number;
    personalVerificationCount: number;
    siiMakingDecisionCount: number;
    otherProblemCount: number;
}

export interface DriverVerificationFilterRequestDto {
    firstName: string;
    lastName: string;
    vehicleId?: number | undefined;
    studentCardExpiryDate?: string | undefined;
    dayOfReportToSSI?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    email: string;
    phoneNumber: string;
    organisationId?: number | undefined;
    driverVerificationFilter: DriverVerificationFilter;
    driverForVerificationDetailsFilter?: DriverForVerificationDetailsFilter;
    hrTags: number[];
    hrNotes: string;
}

export interface DriverWithdrawStatusDto {
    id: number;
    isWithdrawBlocked: boolean;
    hasDriverWithdrawBlockingStatuses: boolean;
}

export interface DriverWithdrawStatusDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: DriverWithdrawStatusDto;
}

export interface DriversCreateCommandRequest {
    organisationId?: number | undefined;
    firstName?: string | undefined;
    secondName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    secondPhoneNumber?: string | undefined;
    townToRide?: string | undefined;
    pesel?: string | undefined;
    parentsNames?: string | undefined;
    birthDate?: string | undefined;
    birthPlace?: string | undefined;
    familyName?: string | undefined;
    nationality?: string | undefined;
    birthCountry?: string | undefined;
    citizenshipCode?: string | undefined;
    voivodeship?: string | undefined;
    postalCode?: string | undefined;
    taxOffice?: string | undefined;
    nfz?: string | undefined;
    isPensioner?: boolean;
    isAnnuitant?: boolean;
    isDisabled?: boolean;
    isInsuredFromWork?: boolean;
    isInsuredFromDuty?: boolean;
    isInsuredFromOtherOrder?: boolean;
    isInsuredFromContract?: boolean;
    isInsuredFromDifferentSource?: boolean;
    insuranceSource?: string | undefined;
    isStudent?: boolean;
    hasAcceptedSendingPit11ByEmail?: boolean;
    idNumber?: string | undefined;
    isBankAccountNumberSkipped?: boolean;
    bankAccountNumber?: string | undefined;
    czechiaBankAccountNumber?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    flatNumber?: string | undefined;
    county?: string | undefined;
    commune?: string | undefined;
    communeCode?: string | undefined;
    marketingAgreement?: boolean;
    regulationsAgreement?: boolean;
    rentAgreement?: boolean;
    isChangingPartner?: boolean;
    hasContacted?: boolean;
    isAccountsOwnerOfSelectedApps?: boolean;
    taxiIdentifier?: string | undefined;
    comments?: string | undefined;
    legalizationNotes?: string | undefined;
    legalizationEmploymentTypeId?: LegalizationEmploymentTypeEnum;
    legalizationWorkingTimeTypeId?: LegalizationWorkingTimeTypeEnum;
    legalizationResidentCardTypeId?: LegalizationResidentCardTypeEnum;
    driverSelectedVehicle?: DriverSelectedVehicleTypeEnum;
    vehicleOwnership?: VehicleOwnershipEnum;
    preferredPaymentType?: PreferredPaymentTypeEnum;
    driverHrTags?: DriverHrTagBasicInfoDto[] | undefined;
    workCountryId?: WorkCountryEnum;
    nfzOrganizationId?: NfzOrganizationEnum;
    stopSendingReminderAboutMissingInsuranceInfo?: boolean;
    dayOfReportToSSI?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    hrNotes?: string | undefined;
    externalWage?: ExternalWageEnum;
    preferredPaymentMethod?: PreferredPaymentMethodEnum;
    preferredPaymentMethodDetails?: string | undefined;
    cooperationEndDate?: string | undefined;
    driverLanguageId?: DriverLanguageEnum;
    applications?: ApplicationEnum[] | undefined;
    driverPaymentTypeHistoryItems?: DriverPaymentTypeHistoryItem[] | undefined;
    legalizationServices?: LegalizationServiceEnum[] | undefined;
    legalizationServiceHistory?: DriverLegalizationServiceHistoryDto[] | undefined;
    applicationAccountIds?: number[] | undefined;
    isDeleted?: boolean;
    studentCardExpiryDate?: string | undefined;
    isVehicleTheft?: boolean | undefined;
    isNotDuplicate?: boolean | undefined;
    isDriverHistoryShouldEndToday: boolean;
    disregardInEmailsWithListOfDebtors: boolean;
    statusDateCallForPayment: string;
    disregardInEmailReason?: string | undefined;
    subject?: DriverSubjectDto;
    driverVehicleShare: DriverVehicleShareDto;
    discoverySourceId?: DriverDiscoverySourceEnum;
    debtNotes?: string | undefined;
    isContactedForDebt?: boolean;
    invoiceIndex?: number | undefined;
    driverInsurances: DriverInsuranceDto[];
    driverDocumentVerifications: DriverDocumentVerificationDto[];
    driverStatusTags: DriverStatusTagDto[];
    isWithdrawBlocked: boolean;
    isSilenced: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    driverHaveAccessToDigitalDocuments: boolean;
    contractStartDate?: string | undefined;
    referralName?: string | undefined;
    referralId?: number | undefined;
    lastModificationDate?: string;
    drivingLicenseNumber?: string | undefined;
    isDrivingLicenseVerification: boolean;
    drivingLicenseVerificationTypeId?: OrganisationDrivingLicenseVerificationTypeEnum;
    siiEmploymentTypeId?: SiiEmploymentTypeEnum;
    siiEmploymentTypeChangeDate?: string | undefined;
    isSentToFlovi?: boolean;
    telegramNickname?: string | undefined;
    mediaIds?: number[] | undefined;
}

export interface DriversCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface DriversDeleteCommandResult {
    success: boolean;
    errors: string[];
}

export interface DriversExportToPdfPayoffsSummaryCommand {
    dateFrom?: string;
    dateTo?: string;
    isSendEmail?: boolean;
    isSaveOnDriverFiles?: boolean;
    id?: number;
}

export interface DriversExportToPdfPostOfficeBookCommand {
    ids?: number[] | undefined;
    indexToStartCountingRows?: number | undefined;
}

export interface DriversGetAllForVerificationQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    dto?: DriverVerificationFilterRequestDto;
}

export interface DriversGetAllForVerificationQueryResult {
    success: boolean;
    errors: string[];
    result?: DriverVerificationDtoPagedResultBody;
    filterCounter?: DriverVerificationFilterCounter;
}

export interface DriversGetAllQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    townToRide?: string | undefined;
    applicationIds?: ApplicationEnum[] | undefined;
    showDeleted?: boolean;
    pesel?: string | undefined;
    idNumber?: string | undefined;
    organisationId?: number | undefined;
    registrationNumber?: string | undefined;
    bankAccountNumber?: string | undefined;
    applicationAccountNameOrPhoneNumber?: string | undefined;
    preferredPaymentTypeDate?: string | undefined;
    isStudent?: boolean | undefined;
    legalizationEmploymentType?: LegalizationEmploymentTypeEnum;
    legalizationWorkingTimeType?: LegalizationWorkingTimeTypeEnum;
    legalizationResidentCardType?: LegalizationResidentCardTypeEnum;
    legalizationServices?: LegalizationServiceEnum[] | undefined;
    workCountryId?: WorkCountryEnum;
    nfzOrganizationId?: NfzOrganizationEnum;
    showDuplicate?: boolean | undefined;
    driverFilter?: DriverFilter;
    notWorkSinceDateTime?: string | undefined;
    hrTags?: number[] | undefined;
    driverStatusTags?: DriverStatusEnum[] | undefined;
    isWithdrawBlocked?: boolean | undefined;
    withdrawBlockReasons?: WithdrawBlockReasonEnum[] | undefined;
    hasAutomaticPaymentSuspension?: boolean | undefined;
    comments?: string | undefined;
    debtNotes?: string | undefined;
    hrNotes?: string | undefined;
    legalizationNotes?: string | undefined;
    driverStatusTagCollectionOperator?: CollectionOperatorEnum;
    isSentToFlovi?: boolean | undefined;
    telegramNickname?: string | undefined;
    isSilenced?: boolean | undefined;
    disableMobileApplicationRequestStatuses?: DisableMobileApplicationRequestStatusEnum[] | undefined;
}

export interface DriversGetAllQueryResult {
    success: boolean;
    errors: string[];
    result?: DriversGetAllQueryResultItemPagedResultBody;
}

export interface DriversGetAllQueryResultItem {
    id?: number;
    settlementsBalance?: number;
    settlementsCurrentBalance?: number;
    settlementsCurrentBalanceWithoutFuturePayoffs?: number;
    settlementsTotalBalance?: number;
    externalBalance?: number;
    organisation?: string | undefined;
    vehicle?: string | undefined;
    firstName?: string | undefined;
    secondName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    secondPhoneNumber?: string | undefined;
    townToRide?: string | undefined;
    pesel?: string | undefined;
    parentsNames?: string | undefined;
    birthDate?: string;
    birthPlace?: string | undefined;
    familyName?: string | undefined;
    nationality?: string | undefined;
    birthCountry?: string | undefined;
    voivodeship?: string | undefined;
    postalCode?: string | undefined;
    taxOffice?: string | undefined;
    isPensioner?: boolean;
    isAnnuitant?: boolean;
    isDisabled?: boolean;
    disabilityCertificateLevel?: DisabilityLevelEnum;
    isInsuredFromWork?: boolean;
    isInsuredFromDuty?: boolean;
    isInsuredFromOtherOrder?: boolean;
    isInsuredFromContract?: boolean;
    isInsuredFromDifferentSource?: boolean;
    insuranceSource?: string | undefined;
    isStudent?: boolean;
    hasAcceptedSendingPit11ByEmail?: boolean;
    idNumber?: string | undefined;
    bankAccountNumber?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    address?: string | undefined;
    flatNumber?: string | undefined;
    marketingAgreement?: boolean;
    regulationsAgreement?: boolean;
    rentAgreement?: boolean;
    isChangingPartner?: boolean;
    hasContacted?: boolean;
    isAccountsOwnerOfSelectedApps?: boolean;
    taxiIdentifier?: string | undefined;
    comments?: string | undefined;
    hrNotes?: string | undefined;
    legalizationNotes?: string | undefined;
    registerDate?: string | undefined;
    cooperationEndDate?: string | undefined;
    status?: DriverStatusEnum;
    driverSelectedVehicle?: DriverSelectedVehicleTypeEnum;
    vehicleOwnership?: VehicleOwnershipEnum;
    preferredPaymentType?: PreferredPaymentTypeEnum;
    preferredPaymentMethod?: PreferredPaymentMethodEnum;
    externalWage?: ExternalWageEnum;
    applicationIds?: ApplicationEnum[] | undefined;
    applicationAccounts?: ApplicationAccountForDriverGetAll[] | undefined;
    isDeleted?: boolean;
    dayOfReportToSSI?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    age?: number | undefined;
    legalizationEmploymentType?: LegalizationEmploymentTypeEnum;
    legalizationWorkingTimeType?: LegalizationWorkingTimeTypeEnum;
    legalizationResidentCardType?: LegalizationResidentCardTypeEnum;
    legalizationServices?: LegalizationServiceEnum[] | undefined;
    workCountryId?: WorkCountryEnum;
    nfzOrganizationId?: NfzOrganizationEnum;
    statusDateCallForPayment?: string | undefined;
    numberOfCallsForPayment?: number;
    discoverySourceId?: DriverDiscoverySourceEnum;
    debtNotes?: string | undefined;
    isContactedForDebt?: boolean;
    driverHrTags?: DriverListHrTagDto[] | undefined;
    driverStatusTags?: DriverStatusTagListItemDto[] | undefined;
    isWithdrawBlocked?: boolean;
    withdrawBlockReasonId?: WithdrawBlockReasonEnum;
    isSilenced?: boolean;
    disableMobileApplicationRequestStatusId?: DisableMobileApplicationRequestStatusEnum;
    isSentToFlovi?: boolean;
    telegramNickname?: string | undefined;
}

export interface DriversGetAllQueryResultItemPagedResultBody {
    items: DriversGetAllQueryResultItem[];
    count: number;
}

export interface DriversGetDebtorsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    organisationId?: number | undefined;
    currentBalance?: number | undefined;
    isRentingFleetVehicle: boolean;
    debtQuota?: number | undefined;
    quotaFilterType?: AmountFilterTypeEnum;
}

export interface DriversGetDebtorsQueryResult {
    success: boolean;
    errors: string[];
    result?: DebtorListItemDtoPagedResultBody;
}

export interface DriversGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: DriversGetDetailsQueryResultDetails;
}

export interface DriversGetDetailsQueryResultDetails {
    organisationId?: number | undefined;
    firstName?: string | undefined;
    secondName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    secondPhoneNumber?: string | undefined;
    townToRide?: string | undefined;
    pesel?: string | undefined;
    parentsNames?: string | undefined;
    birthDate?: string | undefined;
    birthPlace?: string | undefined;
    familyName?: string | undefined;
    nationality?: string | undefined;
    birthCountry?: string | undefined;
    citizenshipCode?: string | undefined;
    voivodeship?: string | undefined;
    postalCode?: string | undefined;
    taxOffice?: string | undefined;
    nfz?: string | undefined;
    isPensioner?: boolean;
    isAnnuitant?: boolean;
    isDisabled?: boolean;
    isInsuredFromWork?: boolean;
    isInsuredFromDuty?: boolean;
    isInsuredFromOtherOrder?: boolean;
    isInsuredFromContract?: boolean;
    isInsuredFromDifferentSource?: boolean;
    insuranceSource?: string | undefined;
    isStudent?: boolean;
    hasAcceptedSendingPit11ByEmail?: boolean;
    idNumber?: string | undefined;
    isBankAccountNumberSkipped?: boolean;
    bankAccountNumber?: string | undefined;
    czechiaBankAccountNumber?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    flatNumber?: string | undefined;
    county?: string | undefined;
    commune?: string | undefined;
    communeCode?: string | undefined;
    marketingAgreement?: boolean;
    regulationsAgreement?: boolean;
    rentAgreement?: boolean;
    isChangingPartner?: boolean;
    hasContacted?: boolean;
    isAccountsOwnerOfSelectedApps?: boolean;
    taxiIdentifier?: string | undefined;
    comments?: string | undefined;
    legalizationNotes?: string | undefined;
    legalizationEmploymentTypeId?: LegalizationEmploymentTypeEnum;
    legalizationWorkingTimeTypeId?: LegalizationWorkingTimeTypeEnum;
    legalizationResidentCardTypeId?: LegalizationResidentCardTypeEnum;
    driverSelectedVehicle?: DriverSelectedVehicleTypeEnum;
    vehicleOwnership?: VehicleOwnershipEnum;
    preferredPaymentType?: PreferredPaymentTypeEnum;
    driverHrTags?: DriverHrTagBasicInfoDto[] | undefined;
    workCountryId?: WorkCountryEnum;
    nfzOrganizationId?: NfzOrganizationEnum;
    stopSendingReminderAboutMissingInsuranceInfo?: boolean;
    dayOfReportToSSI?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    hrNotes?: string | undefined;
    externalWage?: ExternalWageEnum;
    preferredPaymentMethod?: PreferredPaymentMethodEnum;
    preferredPaymentMethodDetails?: string | undefined;
    cooperationEndDate?: string | undefined;
    driverLanguageId?: DriverLanguageEnum;
    applications?: ApplicationEnum[] | undefined;
    driverPaymentTypeHistoryItems?: DriverPaymentTypeHistoryItem[] | undefined;
    legalizationServices?: LegalizationServiceEnum[] | undefined;
    legalizationServiceHistory?: DriverLegalizationServiceHistoryDto[] | undefined;
    applicationAccountIds?: number[] | undefined;
    isDeleted?: boolean;
    studentCardExpiryDate?: string | undefined;
    isVehicleTheft?: boolean | undefined;
    isNotDuplicate?: boolean | undefined;
    isDriverHistoryShouldEndToday: boolean;
    disregardInEmailsWithListOfDebtors: boolean;
    statusDateCallForPayment: string;
    disregardInEmailReason?: string | undefined;
    subject?: DriverSubjectDto;
    driverVehicleShare: DriverVehicleShareDto;
    discoverySourceId?: DriverDiscoverySourceEnum;
    debtNotes?: string | undefined;
    isContactedForDebt?: boolean;
    invoiceIndex?: number | undefined;
    driverInsurances: DriverInsuranceDto[];
    driverDocumentVerifications: DriverDocumentVerificationDto[];
    driverStatusTags: DriverStatusTagDto[];
    isWithdrawBlocked: boolean;
    isSilenced: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    driverHaveAccessToDigitalDocuments: boolean;
    contractStartDate?: string | undefined;
    referralName?: string | undefined;
    referralId?: number | undefined;
    lastModificationDate?: string;
    drivingLicenseNumber?: string | undefined;
    isDrivingLicenseVerification: boolean;
    drivingLicenseVerificationTypeId?: OrganisationDrivingLicenseVerificationTypeEnum;
    siiEmploymentTypeId?: SiiEmploymentTypeEnum;
    siiEmploymentTypeChangeDate?: string | undefined;
    isSentToFlovi?: boolean;
    telegramNickname?: string | undefined;
    id?: number;
    settlementsBalance?: number;
    settlementsCurrentBalance?: number;
    settlementsCurrentBalanceWithoutFuturePayoffs?: number;
    settlementsTotalBalance?: number;
    externalBalance?: number;
    registerDate?: string | undefined;
    media?: DriverMediaFile[] | undefined;
    isOnUserDriverList?: boolean;
    wasReminderSent?: boolean;
    canRefreshFileUploadToken: boolean;
    fileUploadTokenExpirationDate?: string | undefined;
    disableMobileApplicationRequestStatusId?: DisableMobileApplicationRequestStatusEnum;
    withdrawBlockReasonId?: WithdrawBlockReasonEnum;
    selfInvoicingGrant?: KSeFSelfInvoicingGrantDto;
}

export interface DriversGetIdsAndNamesQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: DriverIdAndNameResult[] | undefined;
}

export interface DriversReferralsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: number;
    driverStatus?: DriverStatusEnum;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface DriversReferralsQueryResult {
    success: boolean;
    errors: string[];
    result?: DriverReferralDtoPagedResultBody;
}

export interface DriversUpdateCommandRequest {
    organisationId?: number | undefined;
    firstName?: string | undefined;
    secondName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    secondPhoneNumber?: string | undefined;
    townToRide?: string | undefined;
    pesel?: string | undefined;
    parentsNames?: string | undefined;
    birthDate?: string | undefined;
    birthPlace?: string | undefined;
    familyName?: string | undefined;
    nationality?: string | undefined;
    birthCountry?: string | undefined;
    citizenshipCode?: string | undefined;
    voivodeship?: string | undefined;
    postalCode?: string | undefined;
    taxOffice?: string | undefined;
    nfz?: string | undefined;
    isPensioner?: boolean;
    isAnnuitant?: boolean;
    isDisabled?: boolean;
    isInsuredFromWork?: boolean;
    isInsuredFromDuty?: boolean;
    isInsuredFromOtherOrder?: boolean;
    isInsuredFromContract?: boolean;
    isInsuredFromDifferentSource?: boolean;
    insuranceSource?: string | undefined;
    isStudent?: boolean;
    hasAcceptedSendingPit11ByEmail?: boolean;
    idNumber?: string | undefined;
    isBankAccountNumberSkipped?: boolean;
    bankAccountNumber?: string | undefined;
    czechiaBankAccountNumber?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    flatNumber?: string | undefined;
    county?: string | undefined;
    commune?: string | undefined;
    communeCode?: string | undefined;
    marketingAgreement?: boolean;
    regulationsAgreement?: boolean;
    rentAgreement?: boolean;
    isChangingPartner?: boolean;
    hasContacted?: boolean;
    isAccountsOwnerOfSelectedApps?: boolean;
    taxiIdentifier?: string | undefined;
    comments?: string | undefined;
    legalizationNotes?: string | undefined;
    legalizationEmploymentTypeId?: LegalizationEmploymentTypeEnum;
    legalizationWorkingTimeTypeId?: LegalizationWorkingTimeTypeEnum;
    legalizationResidentCardTypeId?: LegalizationResidentCardTypeEnum;
    driverSelectedVehicle?: DriverSelectedVehicleTypeEnum;
    vehicleOwnership?: VehicleOwnershipEnum;
    preferredPaymentType?: PreferredPaymentTypeEnum;
    driverHrTags?: DriverHrTagBasicInfoDto[] | undefined;
    workCountryId?: WorkCountryEnum;
    nfzOrganizationId?: NfzOrganizationEnum;
    stopSendingReminderAboutMissingInsuranceInfo?: boolean;
    dayOfReportToSSI?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    hrNotes?: string | undefined;
    externalWage?: ExternalWageEnum;
    preferredPaymentMethod?: PreferredPaymentMethodEnum;
    preferredPaymentMethodDetails?: string | undefined;
    cooperationEndDate?: string | undefined;
    driverLanguageId?: DriverLanguageEnum;
    applications?: ApplicationEnum[] | undefined;
    driverPaymentTypeHistoryItems?: DriverPaymentTypeHistoryItem[] | undefined;
    legalizationServices?: LegalizationServiceEnum[] | undefined;
    legalizationServiceHistory?: DriverLegalizationServiceHistoryDto[] | undefined;
    applicationAccountIds?: number[] | undefined;
    isDeleted?: boolean;
    studentCardExpiryDate?: string | undefined;
    isVehicleTheft?: boolean | undefined;
    isNotDuplicate?: boolean | undefined;
    isDriverHistoryShouldEndToday: boolean;
    disregardInEmailsWithListOfDebtors: boolean;
    statusDateCallForPayment: string;
    disregardInEmailReason?: string | undefined;
    subject?: DriverSubjectDto;
    driverVehicleShare: DriverVehicleShareDto;
    discoverySourceId?: DriverDiscoverySourceEnum;
    debtNotes?: string | undefined;
    isContactedForDebt?: boolean;
    invoiceIndex?: number | undefined;
    driverInsurances: DriverInsuranceDto[];
    driverDocumentVerifications: DriverDocumentVerificationDto[];
    driverStatusTags: DriverStatusTagDto[];
    isWithdrawBlocked: boolean;
    isSilenced: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    driverHaveAccessToDigitalDocuments: boolean;
    contractStartDate?: string | undefined;
    referralName?: string | undefined;
    referralId?: number | undefined;
    lastModificationDate?: string;
    drivingLicenseNumber?: string | undefined;
    isDrivingLicenseVerification: boolean;
    drivingLicenseVerificationTypeId?: OrganisationDrivingLicenseVerificationTypeEnum;
    siiEmploymentTypeId?: SiiEmploymentTypeEnum;
    siiEmploymentTypeChangeDate?: string | undefined;
    isSentToFlovi?: boolean;
    telegramNickname?: string | undefined;
    id?: number;
    mediaIds?: number[] | undefined;
    disableMobileApplicationRequestStatusId?: DisableMobileApplicationRequestStatusEnum;
}

export interface DriversUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface EndUploadPermissionCommand {
    ticketId?: number;
}

export interface EntityColumnsDto {
    entityName?: string | undefined;
    columns?: ColumnTypeNameDto[] | undefined;
    enumValues?: { [key: string]: EnumValueDto[]; } | undefined;
}

export interface EnumValueDto {
    name?: string | undefined;
    value?: number;
}

export interface ExportAllVehiclesToCsvCommand {
    organisationIds?: number[] | undefined;
    vehicleIds?: number[] | undefined;
}

export interface ExportDebtorsToCsvCommand {
    organisationIds?: number[] | undefined;
    dateFrom?: string;
    dateTo?: string;
}

export interface ExportDriversCommand {
    ids?: number[] | undefined;
    registrationDate?: string | undefined;
    exportType?: ExportTypeEnum;
}

export interface ExportMobileApplicationSettlementToPdfCommand {
    id?: number;
}

export interface ExportPayoffsCommand {
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    organisationIds?: number[] | undefined;
    ids?: number[] | undefined;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
    payoffFilterType?: PayoffFilterTypeEnum;
    payoffRepaymentType?: PayoffRepaymentTypeEnum;
}

export enum ExportSettlementFileTypeEnum {
    Csv = 1,
    Abo = 2,
}

export interface ExportSettlementToFileForPaymentCommandRequest {
    settlementIds?: number[] | undefined;
    targetFileType?: ExportSettlementFileTypeEnum;
    isB2B?: boolean;
}

export interface ExportSettlementsDetailedCommand {
    organisationIds?: number[] | undefined;
    dateFrom?: string;
    dateTo?: string;
}

export interface ExportTakenCashFromSettlementsCommand {
    organisationIds: number[];
    dateFrom: string;
    dateTo: string;
}

export interface ExportToPdfPaymentsSummaryForTaxCommand {
    paymentIds?: number[] | undefined;
    sentSummaryToDriver?: boolean;
    saveSummaryToDriverFiles?: boolean;
    taxValue?: number;
    isCustomTax?: boolean;
}

export enum ExportTypeEnum {
    Standard = 0,
    Full = 1,
}

export interface ExportUserWithdrawSummaryCommand {
    dateStart?: string;
    dateEnd?: string;
    organisationId?: number;
    employeeName?: string | undefined;
    periodFilter?: SettlementPeriodFilterEnum;
    externalService?: number;
    vehicleFees?: VehicleFeesDto;
    additionalCityFees?: AdditionalCityFeeDto[] | undefined;
    comments?: string | undefined;
    guaranteedRate?: number | undefined;
    cityResultPercentage?: number | undefined;
    otherCosts?: OtherCostDto[] | undefined;
}

export interface ExportVehiclePaidRentCommand {
    organisationIds?: number[] | undefined;
    dateFrom?: string;
    dateTo?: string;
}

export interface ExportWorkLogsCommand {
    organisationIds?: number[] | undefined;
    date?: string;
}

export interface ExtendedDateAndValue {
    organisationName?: string | undefined;
    items?: DateAndValue[] | undefined;
}

export enum ExternalWageEnum {
    HigherThanMinimal = 1,
    LessThanMinimal = 2,
}

export interface FileMimeDto {
    bytes?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface FileMimeDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: FileMimeDto;
}

export interface FileNameAndId {
    fileName: string;
    id: number;
}

export enum FileTypeEnum {
    LeaseAgreement = 1,
    LoanAgreement = 2,
    TransferProtocol = 3,
    ReceivingProtocol = 4,
    PromissoryNote = 5,
    DeclarationLackOfSII = 6,
    ContractOfMandateDriver = 7,
    ContractOfMandateCourier = 8,
    StudentStatusConfirmation = 9,
    BikeTransferProtocol = 10,
    BikeReceivingProtocol = 11,
    GeneralProtocol = 12,
    CashRegisterReceipt = 13,
    CashRegisterDisbursement = 14,
    FoodContainerLeaseAgreement = 15,
    B2BContract = 16,
    B2BFloviContract = 17,
    IdFront = 18,
    IdBack = 19,
    DriverLicenceFront = 20,
    DriverLicenceBack = 21,
    ProfilePhoto = 22,
    MedicalExamination = 23,
    PsychologicalExamination = 24,
    CertificateOfNoCriminalRecord = 25,
    ContractOfMandateFlovi = 26,
    ContractorStatement = 27,
    AuthorizationStatement = 28,
    VatStatement = 29,
    WhistleBlowerStatement = 30,
    BoltFoodContract = 31,
    CourierInstructions = 32,
    ContractOfMandateOtherEmployer = 33,
    WorkPermit = 34,
    AnnuitantCard = 35,
    PensionerCard = 36,
    DisabilityCertificate = 37,
    InsuranceFromDuty = 38,
    StudentCard = 39,
}

export interface FinancialHistoryCreditDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    restPayoff?: number;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
}

export interface FinancialHistoryDepositDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    customReason?: string | undefined;
}

export interface FinancialHistoryOverdueChargeDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    restPayoff?: number;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
    vehiclePlateNumber?: string | undefined;
}

export enum FinancialHistoryOverdueType {
    OverdueCharges = 0,
    UnusedCredits = 1,
}

export interface FinancialHistoryPaymentDto {
    settlementNumber?: string | undefined;
    paymentCreatedDate?: string;
    amount?: number;
    driverBankAccountNumber?: string | undefined;
    transferNumber?: string | undefined;
}

export interface FinancialHistoryPayoffItemDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    restPayoff?: number;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
}

export interface FinancialHistoryRentalChargeDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    restPayoff?: number;
}

export interface FinancialHistoryRentalGroupDto {
    vehicleId?: number;
    vehicleName?: string | undefined;
    vehiclePlateNumber?: string | undefined;
    periods?: FinancialHistoryRentalPeriodDto[] | undefined;
}

export interface FinancialHistoryRentalPeriodDto {
    dateFrom?: string;
    dateTo?: string;
    daysCount?: number;
    totalCharged?: number;
    totalRemaining?: number;
    charges?: FinancialHistoryRentalChargeDto[] | undefined;
}

export interface FinancialHistorySummaryDto {
    totalCharges?: number;
    totalCredits?: number;
    totalDeposits?: number;
    totalPayments?: number;
    totalOverdueRemaining?: number;
    totalUnusedRemaining?: number;
}

export interface FinancialHistoryUnusedCreditDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    restPayoff?: number;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
}

export interface FinishMobileApplicationFileUploadCommand {
    ticketId?: number;
}

export enum FuelCardTypeEnum {
    CircleK = 1,
    Orlen = 2,
    Amic = 3,
}

export interface GeneralSettlementSettingDto {
    id: SettlementSettingsTypeEnum;
    value: number;
}

export interface GenerateArticleMetadataQuery {
    articleId?: number | undefined;
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    content?: string | undefined;
    fields?: AiKnowledgeArticleFieldEnum[] | undefined;
}

export interface GenerateSmsCodeCommand {
    phoneNumber?: string | undefined;
}

export interface GetAllDriversCountForVerificationQuery {
    dto?: DriverVerificationFilterRequestDto;
}

export interface GetAuditEntriesQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    entity?: string | undefined;
    entityId?: number | undefined;
    entityGuid?: string | undefined;
    search?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    entryType?: AuditEntryType;
    userIds?: string[] | undefined;
}

export interface GetAuditEntriesQueryResult {
    success: boolean;
    errors: string[];
    result?: GetAuditEntriesQueryResultItemPagedResultBody;
}

export interface GetAuditEntriesQueryResultItem {
    id?: number;
    type?: AuditEntryType;
    date?: string;
    diff?: string | undefined;
    user?: string | undefined;
    entity?: string | undefined;
    entityId?: number | undefined;
    entityGuid?: string | undefined;
    driverId?: number | undefined;
    driver?: string | undefined;
    changedBy?: AuditEntryChangedByType;
}

export interface GetAuditEntriesQueryResultItemPagedResultBody {
    items: GetAuditEntriesQueryResultItem[];
    count: number;
}

export interface GetBasicDataForSettlementCreationQueryRequest {
    driverId?: number;
    dateStart?: string;
    dateEnd?: string;
    isJobRequest?: boolean;
    isSettleForFuturePayoffs?: boolean;
    isSettleCashWithDriver?: boolean;
}

export interface GetBasicDataForSettlementCreationQueryResult {
    success: boolean;
    errors: string[];
    result?: GetBasicDataForSettlementCreationQueryResultDetails;
}

export interface GetBasicDataForSettlementCreationQueryResultDetails {
    ravapiTransportCommission?: number;
    astekTransportCommission?: number;
    ravapiTransportCommissionToRewrite?: number;
    astekTransportCommissionToRewrite?: number;
    payoff: SettlementPayoffItem[];
    bankAccountNumber: string;
    phoneNumber: string;
    email: string;
    preferredPaymentMethod: PreferredPaymentMethodEnum;
    preferredPaymentType: PreferredPaymentTypeEnum;
    vehicleOwnershipId: VehicleOwnershipEnum;
    preferredPaymentMethodDetails: string;
    hasBeenSettled: boolean;
    settleDailyPayoutsOnceWeek: boolean;
    driverOrganisationId?: number | undefined;
    driverStatusTags: DriverStatusEnum[];
    isRentOnlyDeclared: boolean;
    noEarningApplicationSettlementCalculationMethodId: NoEarningApplicationSettlementCalculationMethodEnum;
}

export interface GetCampaignsForDigitalDocumentsQuery {
    driverIds?: number[] | undefined;
    vehicleId?: number;
}

export interface GetDigitalDocumentsForQueueRequestQuery {
    driverIds?: number[] | undefined;
    vehicleId?: number | undefined;
    vehicleDriverHistoryId?: number | undefined;
    types?: DigitalDocumentGroupTypeEnum[] | undefined;
}

export interface GetDriverMailsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: number;
    subject?: string | undefined;
    sendOnDate?: string | undefined;
    sentDate?: string | undefined;
    mailType?: number | undefined;
}

export interface GetDriverMailsQueryResult {
    success: boolean;
    errors: string[];
    result?: MailDtoPagedResultBody;
}

export interface GetDriverVehicleReservationListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    vehicleTypeId?: VehicleTypeEnum;
    vehicleNameId?: VehicleNameEnum;
    vehicleName?: string | undefined;
    statusId?: DriverVehicleReservationStatusEnum;
    cancelReasonId?: DriverVehicleReservationCancelReasonEnum;
    createdAtStart?: string | undefined;
    createdAtEnd?: string | undefined;
    changedAtStart?: string | undefined;
    changedAtEnd?: string | undefined;
    userName?: string | undefined;
}

export interface GetDriverVehicleReservationListQueryResult {
    success: boolean;
    errors: string[];
    result?: DriverVehicleReservationListItemDtoPagedResultBody;
}

export interface GetExportUserWithdrawSummaryListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface GetExportUserWithdrawSummaryListQueryResult {
    success: boolean;
    errors: string[];
    result?: GetExportUserWithdrawSummaryListQueryResultItemPagedResultBody;
}

export interface GetExportUserWithdrawSummaryListQueryResultItem {
    id: number;
    organisationName: string;
    employeeName: string;
    date: string;
    mediumId: number;
    fileName: string;
}

export interface GetExportUserWithdrawSummaryListQueryResultItemPagedResultBody {
    items: GetExportUserWithdrawSummaryListQueryResultItem[];
    count: number;
}

export interface GetExportsInfoQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: GetExportsInfoQueryResultDetails[] | undefined;
}

export interface GetExportsInfoQueryResultDetails {
    date: string;
    createdDate: string;
    creatorFullName: string;
    mediumId: number;
    fileName: string;
}

export interface GetForChargeExemptionAutocompleteQuery {
    searchPhrase?: string | undefined;
    excludedIds?: number[] | undefined;
}

export interface GetForSettlementAutocompleteQueryRequest {
    id?: number | undefined;
    searchPhrase?: string | undefined;
    organisationId?: number | undefined;
    showDisabled?: boolean;
}

export interface GetForSettlementAutocompleteQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: GetForSettlementAutocompleteQueryResultDetails[] | undefined;
}

export interface GetForSettlementAutocompleteQueryResultDetails {
    id: number;
    organisationId?: number | undefined;
    fullName: string;
    email: string;
    phoneNumber: string;
    disabled: boolean;
    isWithdrawBlocked: boolean;
    vehicle?: VehicleDetailsForDriverAutocompleteDto;
}

export interface GetKnowledgeObservationsQuery {
    statusId?: AiKnowledgeObservationStatusEnum;
    lastTicketDateFrom?: string | undefined;
    lastTicketDateTo?: string | undefined;
    ticketNumber?: string | undefined;
    text?: string | undefined;
    article?: string | undefined;
}

export interface GetMobileApplicationFinancialHistoryOverdueQuery {
    dateStart?: string;
    type?: FinancialHistoryOverdueType;
    skip?: number;
    take?: number;
}

export interface GetMobileApplicationFinancialHistoryQuery {
    dateStart?: string;
    dateEnd?: string;
}

export interface GetMobileApplicationInvoiceListQuery {
    dateStart?: string;
    dateEnd?: string;
}

export interface GetMobileApplicationOnlinePaymentsQuery {
    dateStart?: string;
    dateEnd?: string;
    status?: OnlinePaymentStatusEnum;
}

export interface GetMobileApplicationRentalHistoryQuery {
    dateStart?: string;
    dateEnd?: string;
}

export interface GetMobileApplicationSettlementsQuery {
    dateStart?: string;
    dateEnd?: string;
}

export interface GetMobileApplicationSupportTicketHistoryQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface GetMobileApplicationSupportTicketHistoryQueryResult {
    success: boolean;
    errors: string[];
    result?: SupportTicketDtoPagedResultBody;
}

export interface GetMobileApplicationVehicleReservationsQuery {
    dateStart?: string;
    dateEnd?: string;
}

export interface GetMyUserInfoQueryResult {
    success: boolean;
    errors: string[];
    result?: GetMyUserInfoQueryResultDetails;
}

export interface GetMyUserInfoQueryResultDetails {
    id: string;
    displayName: string;
    organisationsNames: string[];
    isMasterOrganisation: boolean;
    applicationAccountsAccess: boolean;
    canMarkPaymentAsExecuted: boolean;
    haveAccessToAuditArea: boolean;
    massDeleteSettlements: boolean;
    sendSettlementEmailsToDrivers: boolean;
    canDeleteDrivers: boolean;
    canImportSettlements: boolean;
    canExportSettlements: boolean;
    canModifySettlementApplication: boolean;
    canModifyRavapiBonus: boolean;
    canModifyPetrolGross: boolean;
    statisticBundleId: number;
    canApproveSettlements: boolean;
    canMoveSettlementBackToWaiting: boolean;
    canDeletePayoff: boolean;
    canCancelPayoff: boolean;
    sendReminderToTakeActionInSII: boolean;
    canExportRequestForPayment: boolean;
    haveAccessToReportArea: boolean;
    reportSchemaSetNameId?: number | undefined;
    canMassSetVehiclesCommission: boolean;
    canApproveCollidingSettlements: boolean;
    getsEmailsAboutUndefinedSettlementsRequireAttention: boolean;
    canMassAdjustSettlementCommissions: boolean;
    role: UserRoleEnum;
    canHoldOffSettlementPayoff: boolean;
    canExportEquipmentReturnRequest: boolean;
    canExportToPdfProofOfIncome: boolean;
    canRemoveDriverContactForm: boolean;
    canExportPaymentsSummaryForTax: boolean;
    canChangeStateExcludeFromExportSettlement: boolean;
    canCreateInvoice: boolean;
    canManualEditDriverSubject: boolean;
    canChangeVehicleIsIncludedInDayOff: boolean;
    isExcludedFromDriverDayOffReminderMailingList: boolean;
    canChangeVehicleCommissions: boolean;
    canChangeVehicleDiscountedCommissions: boolean;
    canImportPayoffs: boolean;
    canManageVehicleDocuments: boolean;
    canAssignDigitalPromissoryNoteInReceivingVehicle: boolean;
    haveAccessToDigitalDocumentsManageArea: boolean;
    canManageBonusCampaigns: boolean;
    canRemoveBlockingWithdrawDriverStatusTags: boolean;
    skipMissingVehicleRentDigitalDocumentsPopupReminder: boolean;
    canViewMissingDriversDigitalDocuments: boolean;
    canConfirmDriverDocumentsWithoutUploadingFile: boolean;
    canChangeStudentValidationStatus: boolean;
    canEditDriverContractStartDate: boolean;
    haveAccessToMailArea: boolean;
    canAddOrRemoveDriverDayoff: boolean;
    canManageMailRules: boolean;
    haveAccessToOnlinePayments: boolean;
    canSendOnlinePaymentRequestToDebtors: boolean;
    canRemovePayUPayoffs: boolean;
    haveAccessToInvitePrograms: boolean;
    canPublishInviteProgram: boolean;
    canDeleteInviteProgramDraft: boolean;
    canDeleteInviteProgram: boolean;
    canRemoveReferralPayoffs: boolean;
    canRemoveOnlinePayments: boolean;
    canSettleDriverViaOnlinePayments: boolean;
    canEditPayoffOnlinePayment: boolean;
    canDeleteReferral: boolean;
    canEditReferral: boolean;
    haveAccessToReferral: boolean;
    canAddOnlinePaymentInvoice: boolean;
    canExportDriversToCsv: boolean;
    haveAccessToMassCampaigns: boolean;
    canApproveMassCampaigns: boolean;
    haveFullAccessToEditMassCampaigns: boolean;
    canSendDriverDataToFlovi: boolean;
    haveAccessToExportDebtorsForPenaltySummary: boolean;
    haveAccessToExportsArea: boolean;
    canExportVehiclePaidRent: boolean;
    canExportSettlementsReport: boolean;
    canExportWorkLog: boolean;
    canExportTakenCashFromSettlements: boolean;
    canChangeDriverDisableRequestStatus: boolean;
    canExportUserWithdrawSummary: boolean;
    canMassDeletePayoffs: boolean;
    canMassRemoveDriversFromSII: boolean;
    canMassReportDriversToSII: boolean;
    canManageVehicleCashback: boolean;
    canExportPayoffs: boolean;
    canChangeMobileApplicationDriverFileVisibility: boolean;
    canSendInvoiceToKSeF: boolean;
    excludeFromKSeFNotifications: boolean;
    canClaimSupportTicket: boolean;
    canTakeOverSupportTicket: boolean;
    canCloseSupportTicket: boolean;
    canDeleteSupportTicket: boolean;
    canMassDeleteSupportTickets: boolean;
    haveAccessToAiKnowledgeBase: boolean;
    canManageAiKnowledgeBase: boolean;
    canMassCancelSiiPayoffs: boolean;
    canForceRavapiPaymentsTitle: boolean;
    canMassAddSiiPayoffs: boolean;
}

export interface GetOptimaExportPreviewQuery {
    driverIds?: number[] | undefined;
}

export interface GetPendingReservationsForDriverQuery {
    driverId?: number;
    date?: string;
}

export interface GetRemoveDriversFromSIIPreviewQuery {
    driverIds?: number[] | undefined;
}

export interface GetReportDriversToSIIPreviewQuery {
    driverIds?: number[] | undefined;
}

export interface GetSearchingResultsQueryRequest {
    take?: number;
    searchPhrase?: string | undefined;
    searchType?: DashboardSearchEngineRecordTypeEnum;
}

export interface GetTicketsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    statusId?: SupportTicketStatusEnum;
    driverLanguageId?: DriverLanguageEnum;
    workCountryId?: WorkCountryEnum;
    assignmentFilter?: SupportTicketAssignmentFilterEnum;
    closeReasonId?: SupportTicketCloseReasonEnum;
    assignedToFullName?: string | undefined;
    createdDateFrom?: string | undefined;
    createdDateTo?: string | undefined;
    modificationDateFrom?: string | undefined;
    modificationDateTo?: string | undefined;
    assignedDateFrom?: string | undefined;
    assignedDateTo?: string | undefined;
    closedDateFrom?: string | undefined;
    closedDateTo?: string | undefined;
    showDeleted?: boolean;
}

export interface GetTicketsQueryResult {
    success: boolean;
    errors: string[];
    result?: SupportTicketDtoPagedResultBody;
}

export interface GrantUploadPermissionCommand {
    ticketId?: number;
    maxFiles?: number;
}

export enum GroupTypeEnum {
    AND = 1,
    OR = 2,
}

export interface GusSubjectDto {
    name?: string | undefined;
    nip?: string | undefined;
    regon?: string | undefined;
    krs?: string | undefined;
    town?: string | undefined;
    street?: string | undefined;
    propertyNumber?: string | undefined;
    flatNumber?: string | undefined;
    postalCode?: string | undefined;
    postTown?: string | undefined;
    isVatPayer: boolean;
    isCompanyActive: boolean;
}

export interface GusSubjectDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: GusSubjectDto;
}

export interface HasBeenSettledQueryRequest {
    driverId: number;
    dateStart?: string;
    dateEnd?: string;
}

export enum HrStatusEnum {
    Reported = 1,
    Active = 2,
    HadPayout = 3,
    ToBeReported = 4,
    ToBeRemoved = 6,
    Removed = 7,
    MissingData = 8,
    Other = 9,
    StudentCardRequired = 10,
    StudentCardUploaded = 11,
    Bailiff = 12,
    B2B = 13,
    WithoutPayout = 14,
    ActivePayoutCurrentMonth = 15,
    ActivePayoutPreviousMonth = 16,
    MissingTaxOffice = 17,
    MissingCurrentInsurance = 18,
    MissingAnnuitantCard = 19,
    MissingDisabilityCertificate = 20,
    MissingInsuranceFromDuty = 21,
    MissingPensionerCard = 22,
    MissingPesel = 23,
    Resignation = 24,
    UnvalidatedContractOfMandate = 25,
    ValidatedContractOfMandate = 26,
    UnvalidatedStudentStatus = 27,
    ValidatedStudentStatus = 28,
    TaxSituation = 29,
    SiiRequest = 30,
    SiiResignationRequest = 31,
    MissingDriverLicenseNumber = 32,
    ToBeVerifiedInCepik = 33,
    VerifiedInCepik = 34,
    VerificationRejectedInCepik = 35,
    RentOnly = 36,
    WorkPermitRequired = 37,
    ContractOfMandateOtherEmployerToVerify = 38,
    InsuredByOtherPayer = 39,
}

export interface HrTagCreateCommand {
    name?: string | undefined;
    icon?: string | undefined;
}

export interface HrTagDto {
    id?: number;
    name?: string | undefined;
    icon?: string | undefined;
}

export interface HrTagListDto {
    id?: number;
    name?: string | undefined;
    icon?: string | undefined;
    isCustom?: boolean;
    hrStatusEnum?: HrStatusEnum;
}

export interface HrTagListDtoPagedResultBody {
    items: HrTagListDto[];
    count: number;
}

export interface HrTagListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface HrTagListQueryResult {
    success: boolean;
    errors: string[];
    result?: HrTagListDtoPagedResultBody;
}

export interface HrTagSelectListDto {
    id?: number;
    name?: string | undefined;
    hrStatusEnum?: HrStatusEnum;
    disabled?: boolean;
    icon?: string | undefined;
}

export interface HrTagSelectListDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: HrTagSelectListDto[] | undefined;
}

export interface IdAndNameResult {
    id: number;
    name: string;
}

export interface IdAndNameResultListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: IdAndNameResult[] | undefined;
}

export interface ImportFoodCommandRequest {
    dateStart?: string;
    dateEnd?: string;
    includeTakenCash?: boolean;
    fileMediumId?: number;
    application?: ApplicationEnum;
}

export interface ImportFoodCommandResult {
    success: boolean;
    errors: string[];
    result?: ImportFoodCommandResultDetails;
}

export interface ImportFoodCommandResultDetails {
    importLog?: string | undefined;
}

export interface ImportLogDto {
    importLog?: string | undefined;
}

export interface ImportLogDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: ImportLogDto;
}

export interface ImportLogExtendedDto {
    importLog?: string | undefined;
    isSuccess?: boolean;
}

export interface ImportLogExtendedDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: ImportLogExtendedDto;
}

export interface ImportPayoffCommand {
    fileMediumId?: number;
    isCreateSettlement?: boolean;
    settlementDateStart?: string | undefined;
    settlementDateEnd?: string | undefined;
}

export interface ImportPetrolCommand {
    mediumId?: number;
    dateStart?: string;
    dateEnd?: string;
    fuelCardType?: FuelCardTypeEnum;
}

export interface ImportTaxiCommandRequest {
    fileMediumId?: number;
    dateStart?: string;
    dateEnd?: string;
    application?: ApplicationEnum;
    settlementImportFileSchemaType?: SettlementImportFileSchemaTypeEnum;
}

export interface ImportTaxiCommandResult {
    success: boolean;
    errors: string[];
    result?: ImportTaxiCommandResultDetails;
}

export interface ImportTaxiCommandResultDetails {
    importLog?: string | undefined;
}

export interface InstallmentListDto {
    id?: number;
    driver?: string | undefined;
    startDate?: string;
    oneInstallmentValue?: number;
    interval?: number;
    maxInstallments?: number | undefined;
    totalValue?: number;
    toBePaid?: number | undefined;
    reason?: string | undefined;
    isDeleted?: boolean;
    canDelete?: boolean;
    comments?: string | undefined;
}

export interface InstallmentListDtoPagedResultBody {
    items: InstallmentListDto[];
    count: number;
}

export interface InstallmentListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    organisationId?: number | undefined;
    showDeleted?: boolean;
    driverFirstName?: string | undefined;
    driverLastName?: string | undefined;
    reason?: PayoffReasonEnum;
    customReason?: string | undefined;
    comments?: string | undefined;
}

export interface InstallmentListResult {
    success: boolean;
    errors: string[];
    result?: InstallmentListDtoPagedResultBody;
}

export interface InstallmentMediumDto {
    id?: number;
    name?: string | undefined;
}

export interface InstallmentPayoffDto {
    id?: number;
    date?: string | undefined;
    quota?: number;
    restPayoff?: number;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
}

export interface InstallmentSchemaDto {
    driverId: number;
    startDate?: string;
    oneInstallmentValue: number;
    interval: number;
    maxInstallments?: number | undefined;
    reasonId?: PayoffReasonEnum;
    customReason: string;
    isRavapiTransportCommission: boolean;
    isBezproblemTransportCommission: boolean;
    isBezproblemCommission: boolean;
    isRavapiCommission: boolean;
    media: InstallmentMediumDto[];
    payoffs?: InstallmentPayoffDto[] | undefined;
    isDeleted: boolean;
    isRefund: boolean;
    comments: string;
    blockDriverWithdraw?: boolean | undefined;
    paymentSuspensionReason?: string | undefined;
}

export interface InstallmentSchemaDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: InstallmentSchemaDto;
}

export interface InstallmentsGetPagedQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    driverId?: number;
}

export interface InstallmentsGetPagedQueryResult {
    success: boolean;
    errors: string[];
    result?: InstallmentListDtoPagedResultBody;
}

export interface Int32NullableOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: number | undefined;
}

export interface Int32OperationResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface InviteProgramConditionDto {
    id: number;
    conditionTypeId: InviteProgramConditionTypeEnum;
    requiredDays?: number | undefined;
    vehicles?: InviteProgramConditionVehicleDto[] | undefined;
}

export enum InviteProgramConditionTypeEnum {
    WorkedDays = 1,
    RentedVehicle = 2,
}

export interface InviteProgramConditionVehicleDto {
    id: number;
    vehicleBrand?: string | undefined;
    vehicleModel?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    rentDays?: number;
}

export interface InviteProgramDto {
    id: number;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    description: string;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    isDraft: boolean;
    isDeleted: boolean;
    statusId: InviteProgramStatusEnum;
    maxRewardAmount?: number;
    groups?: InviteProgramGroupDto[] | undefined;
}

export interface InviteProgramDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: InviteProgramDto;
}

export interface InviteProgramDtoPagedResultBody {
    items: InviteProgramDto[];
    count: number;
}

export interface InviteProgramGroupDto {
    id: number;
    rewardAmount: number;
    priority: number;
    conditions?: InviteProgramConditionDto[] | undefined;
}

export interface InviteProgramListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    status?: InviteProgramStatusEnum;
    organisationId?: number | undefined;
    isDraft?: boolean | undefined;
    amount?: number | undefined;
    description?: string | undefined;
    showDeleted?: boolean;
}

export interface InviteProgramListQueryResult {
    success: boolean;
    errors: string[];
    result?: InviteProgramDtoPagedResultBody;
}

export enum InviteProgramStatusEnum {
    Active = 1,
    Upcome = 2,
    Finished = 3,
}

export enum InvoiceGenerationMethodEnum {
    Standard = 1,
    KSeF = 2,
}

export interface InvoiceListItemAddressDto {
    town: string;
    street: string;
    propertyNumber: string;
    flatNumber?: string | undefined;
    postalCode: string;
    postTown: string;
}

export interface InvoiceListItemDto {
    id: number;
    fullName: string;
    invoiceRecipient: string;
    settlementId?: number | undefined;
    onlinePaymentPublicId?: string | undefined;
    invoiceTypeId: InvoiceTypeEnum;
    settlementNumber: string;
    createdDate: string;
    paymentDate?: string | undefined;
    subjectName: string;
    nip: string;
    regon?: string | undefined;
    krs?: string | undefined;
    invoiceNumber: string;
    netAmount: number;
    isVatIncluded: boolean;
    vatAmount: number;
    grossAmount: number;
    takenCash: number;
    mediumId: number;
    total: number;
    services: ServiceTypeEnum[];
    address: InvoiceListItemAddressDto;
    isPaid: boolean;
    generationMethod: InvoiceGenerationMethodEnum;
    kSeFStatus?: KSeFSendStatusEnum;
    kSeFNumber?: string | undefined;
    kSeFRetryCount?: number | undefined;
    kSeFErrorMessage?: string | undefined;
    kSeFSentAt?: string | undefined;
    kSeFConfirmedAt?: string | undefined;
    kSeFIsOffline?: boolean | undefined;
}

export interface InvoiceListItemDtoPagedResultBody {
    items: InvoiceListItemDto[];
    count: number;
}

export interface InvoiceListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    fullName?: string | undefined;
    nip?: string | undefined;
    invoiceNumber?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    filterType?: InvoiceServiceFilterType;
    invoiceType?: InvoiceTypeEnum;
    kSeFStatus?: KSeFSendStatusEnum;
    kSeFNumber?: string | undefined;
    isOffline?: boolean | undefined;
}

export interface InvoiceListQueryResult {
    success: boolean;
    errors: string[];
    result?: InvoiceListItemDtoPagedResultBody;
}

export enum InvoiceServiceFilterType {
    Taxi = 1,
    Food = 2,
    Other = 3,
}

export enum InvoiceTypeEnum {
    Individual = 1,
    Business = 2,
}

export interface KSeFConfigResult {
    enabled?: boolean;
}

export interface KSeFConfigResultOperationResult {
    success: boolean;
    errors: string[];
    result?: KSeFConfigResult;
}

export interface KSeFInvoiceSendResultItem {
    invoiceId: number;
    invoiceNumber: string;
    status: KSeFSendStatusEnum;
    kSeFNumber?: string | undefined;
    errorMessage?: string | undefined;
}

export interface KSeFSelfInvoicingGrantDto {
    nip?: string | undefined;
    grantedAt?: string;
}

export interface KSeFSendInvoicesCommand {
    invoiceIds?: number[] | undefined;
}

export interface KSeFSendInvoicesResult {
    items: KSeFInvoiceSendResultItem[];
    totalCount: number;
    sentCount: number;
    failedCount: number;
}

export interface KSeFSendInvoicesResultOperationResult {
    success: boolean;
    errors: string[];
    result?: KSeFSendInvoicesResult;
}

export enum KSeFSendStatusEnum {
    Queued = 1,
    Processing = 2,
    Sent = 3,
    Confirmed = 4,
    Rejected = 5,
    FailedUnavailable = 6,
}

export interface KSeFStatusResult {
    invoiceId: number;
    status: KSeFSendStatusEnum;
    kSeFNumber?: string | undefined;
    errorMessage?: string | undefined;
    sentAt?: string | undefined;
    confirmedAt?: string | undefined;
}

export interface KSeFStatusResultOperationResult {
    success: boolean;
    errors: string[];
    result?: KSeFStatusResult;
}

export interface LandingPageCountersDto {
    drivers?: number;
    fleetCars?: number;
    settlements?: number;
}

export interface LandingPageCountersDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: LandingPageCountersDto;
}

export enum LegalizationEmploymentTypeEnum {
    ContractOfEmployment = 1,
    ContractOfMandate = 2,
}

export enum LegalizationHistoryTypeEnum {
    ConversationWithClient = 1,
    DocumentsSubmission = 2,
    OfficeAnswer = 3,
    Appeal = 4,
    Repeal = 5,
    Refusal = 6,
    OfficeDecision = 7,
    Resignation = 8,
    Others = 9,
}

export enum LegalizationResidentCardTypeEnum {
    BasedOnJob = 1,
    InCaseOfStayWithFamily = 2,
    ResidentCardForStudent = 3,
    PermanentResidentCard = 4,
    PolesCard = 5,
}

export enum LegalizationServiceEnum {
    Employment = 1,
    ResidentCard = 2,
    Pesel = 3,
    CompanySetup = 4,
    PolishDrivingLicense = 5,
}

export enum LegalizationWorkingTimeTypeEnum {
    FullTime = 1,
    HalfPartTime = 2,
    QuarterPartTime = 3,
}

export interface ListDigitalDocumentsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    filterType?: DigitalDocumentListFilterTypeEnum;
    documentType?: DigitalDocumentTypeEnum;
    driverFullName?: string | undefined;
    vehicleName?: string | undefined;
    createdDateStart?: string | undefined;
    createdDateEnd?: string | undefined;
    updatedDateStart?: string | undefined;
    updatedDateEnd?: string | undefined;
}

export interface ListDigitalDocumentsQueryResult {
    success: boolean;
    errors: string[];
    result?: DigitalDocumentListItemDtoPagedResultBody;
}

export interface LoginDto {
    email: string;
    password: string;
}

export interface LostAssetsByOrganisation {
    organisationId?: number;
    organisationName?: string | undefined;
    assetsTotal?: number;
    assetsDiscountedTotal?: number;
    actualStandardResult?: number;
    actualDiscountedResult?: number;
    readonly actualResult?: number;
    lostAssetsWorkshop?: number;
    lostAssetsTheft?: number;
    readonly possibleStandardAssets?: number;
    readonly possibleDiscountedAssets?: number;
    readonly possibleAssets?: number;
}

export interface MailDto {
    id?: number;
    to?: string | undefined;
    subject?: string | undefined;
    sendOnDate?: string | undefined;
    sentDate?: string | undefined;
    mailStatusId?: MailStatusEnum;
    retry?: number;
    mailTypeDetail?: MailTypeDetailSelectListDto;
    createdBy?: string | undefined;
    createdDate?: string | undefined;
    logsQuantity?: number;
}

export interface MailDtoPagedResultBody {
    items: MailDto[];
    count: number;
}

export interface MailListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    subject?: string | undefined;
    sendOnDate?: string | undefined;
    sentDate?: string | undefined;
    mailType?: number | undefined;
    fullName?: string | undefined;
    to?: string | undefined;
    createdBy?: string | undefined;
}

export interface MailListQueryResult {
    success: boolean;
    errors: string[];
    result?: MailDtoPagedResultBody;
}

export interface MailRuleDto {
    id?: number;
    name?: string | undefined;
    mailTypeDetail?: MailTypeDetailSelectListDto;
    updatedBy?: string | undefined;
    updatedDate?: string | undefined;
    mainEntity?: string | undefined;
}

export interface MailRuleDtoPagedResultBody {
    items: MailRuleDto[];
    count: number;
}

export interface MailRulesListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    name?: string | undefined;
    mailType?: number | undefined;
}

export interface MailRulesListQueryResult {
    success: boolean;
    errors: string[];
    result?: MailRuleDtoPagedResultBody;
}

export enum MailStatusEnum {
    ToBeSend = 1,
    Sent = 2,
    UnableToSent = 3,
}

export interface MailTypeDetailSelectListDto {
    id?: number;
    mailTypeId?: MailTypeEnum;
}

export interface MailTypeDetailSelectListDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MailTypeDetailSelectListDto[] | undefined;
}

export interface MailTypeEntitiesDto {
    mailType?: MailTypeEnum;
    entityColumns?: EntityColumnsDto[] | undefined;
}

export interface MailTypeEntitiesDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MailTypeEntitiesDto;
}

export enum MailTypeEnum {
    NewUser = 1,
    PasswordReset = 2,
    ListOfDebtors = 3,
    RequestForPayment = 4,
    ReminderActionRequiredSII = 5,
    ReminderRepaymentOfOutstandingDebts = 6,
    AttachmentSend = 7,
    ReminderDayOffPromotion = 8,
    ProofOfIncome = 9,
    AutoSettlements = 10,
    Pit11 = 11,
    ReminderDuplicateDriverAccounts = 12,
    EarningStatement = 13,
    ReminderB2BDriversVerification = 14,
    ReminderDriversMissingData = 15,
    ReminderAdditionalInfoForInsuranceNeeded = 16,
    ReminderOutdatedStudentId = 17,
    BirthdayWishes = 18,
    PayoutStatementForTaxSettlement = 19,
    Pit11Logs = 20,
    PeriodicVehicleInspection = 21,
    ReminderDriversBirthdays = 22,
    ReminderNoBankAccountNumber = 23,
    LegalizationProgramNewPerson = 24,
    ReminderRentEndAtPromotionalPrice = 25,
    ReminderRentStartAtStandardPrice = 26,
    ListOfDriversWithReminderChangeRentalRate = 27,
    VatInvoice = 28,
    ReturnEquipmentRequest = 29,
    Report = 30,
    DriverSettlement = 31,
    ReminderScheduledWorkshop = 32,
    ReminderMissingDocumentsToSign = 33,
    ImportFood = 34,
    ImportTaxi = 35,
    RegistrationMail = 36,
    OrganisationReport = 37,
    VehicalRentalStart = 38,
    VehicalRentalEnd = 39,
    UndefinedSettlementsMatchingMultipleDrivers = 40,
    ConfirmationDayOffForDay = 41,
    AutoAssignTaxOfficeDrivers = 42,
    NotIdentifyTaxOfficeDrivers = 43,
}

export interface MailgunLogDto {
    id: number;
    logType: MailgunLogTypeEnum;
    createdDate?: string;
    retryAttempts: number;
    rawLog: string;
}

export interface MailgunLogDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MailgunLogDto[] | undefined;
}

export enum MailgunLogTypeEnum {
    Accepted = 1,
    Delivered = 2,
    Failed = 3,
    Rejected = 4,
    Clicked = 5,
    Opened = 6,
    Stored = 7,
    Complained = 8,
}

export interface MailgunWebhookDto {
    signature?: MailgunWebhookSignature;
    "event-data"?: any;
}

export interface MailgunWebhookSignature {
    timestamp?: string | undefined;
    token?: string | undefined;
    signature?: string | undefined;
}

export interface MassAddSiiPayoffsResultDto {
    charged?: MassAddSiiPayoffsResultItemDto[] | undefined;
    skipped?: MassAddSiiPayoffsResultItemDto[] | undefined;
}

export interface MassAddSiiPayoffsResultDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MassAddSiiPayoffsResultDto;
}

export interface MassAddSiiPayoffsResultItemDto {
    settlementId?: number;
    settlementNumber?: string | undefined;
    driverFullName?: string | undefined;
    quota?: number;
    skipReason?: MassAddSiiPayoffsSkipReasonEnum;
}

export enum MassAddSiiPayoffsSkipReasonEnum {
    DriverNotEligible = 1,
    LimitReached = 2,
    NothingToCharge = 3,
}

export enum MassCampaignChannelEnum {
    Sms = 1,
    Push = 2,
}

export interface MassCampaignCopyDto {
    id?: number;
    includeIsSend?: boolean;
}

export interface MassCampaignListItemDto {
    id: number;
    estimatedCost: number;
    actualCost: number;
    messages: MassCampaignMessageDto[];
    statusId: MassCampaignStatusEnum;
    isDeleted: boolean;
    createdById: string;
    createdBy: string;
    createdDate: string;
    approvedById?: string | undefined;
    approvedBy?: string | undefined;
    approvedDate?: string | undefined;
    executionDate: string;
    notSended: number;
    sended: number;
}

export interface MassCampaignListItemDtoPagedResultBody {
    items: MassCampaignListItemDto[];
    count: number;
}

export interface MassCampaignListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    executionDateStart?: string | undefined;
    executionDateEnd?: string | undefined;
    createdBy?: string | undefined;
    createdDateStart?: string | undefined;
    createdDateEnd?: string | undefined;
    approvedBy?: string | undefined;
    approvedDateStart?: string | undefined;
    approvedDateEnd?: string | undefined;
    showDeleted?: boolean;
    statusId?: MassCampaignStatusEnum;
}

export interface MassCampaignListQueryResult {
    success: boolean;
    errors: string[];
    result?: MassCampaignListItemDtoPagedResultBody;
}

export interface MassCampaignMessageDto {
    channelId?: MassCampaignChannelEnum;
    messagePl?: string | undefined;
    messageEn?: string | undefined;
    messageUa?: string | undefined;
}

export interface MassCampaignRecipientDto {
    id: number;
    phoneNumber: string;
    language: DriverLanguageEnum;
    isSend: boolean;
    channels: MassCampaignChannelEnum[];
}

export interface MassCampaignRecipientDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MassCampaignRecipientDto[] | undefined;
}

export enum MassCampaignStatusEnum {
    Waiting = 1,
    Approved = 2,
    Pending = 3,
    Executed = 4,
}

export enum MassChangeDriverHrTagDateModeEnum {
    CommonDate = 1,
    KeepExisting = 2,
}

export interface MassChangeDriverHrTagPreviewDto {
    eligible?: MassChangeDriverHrTagPreviewItemDto[] | undefined;
    skipped?: MassChangeDriverHrTagPreviewItemDto[] | undefined;
}

export interface MassChangeDriverHrTagPreviewDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MassChangeDriverHrTagPreviewDto;
}

export interface MassChangeDriverHrTagPreviewItemDto {
    driverId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dayOfRemoveFromSSI?: string | undefined;
    dayOfReportToSSI?: string | undefined;
    hrStatuses?: HrStatusEnum[] | undefined;
    skipReason?: MassChangeDriverHrTagSkipReasonEnum;
}

export enum MassChangeDriverHrTagSkipReasonEnum {
    MissingSourceTag = 1,
    MissingDate = 2,
}

export interface MassDeletePayoffCommand {
    ids?: number[] | undefined;
}

export interface MassForceRavapiPaymentsTitleCommand {
    ids?: number[] | undefined;
    isForced?: boolean;
}

export interface MediaCreateCommandResult {
    success: boolean;
    errors: string[];
    result?: MediaCreateCommandResultDetails;
}

export interface MediaCreateCommandResultDetails {
    id?: number;
    publicId?: string | undefined;
}

export interface MessageNotificationDto {
    id: number;
    priority: MessageNotificationPriorityEnum;
    type: MessageNotificationTypeEnum;
    model: string;
    date: string;
    isReaded: boolean;
}

export interface MessageNotificationDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MessageNotificationDto[] | undefined;
}

export enum MessageNotificationPriorityEnum {
    Low = 1,
    Normal = 2,
    High = 3,
    Highest = 4,
}

export enum MessageNotificationTypeEnum {
    VehicleRentMissingDigitalDocuments = 1,
    VehicleReservationCreated = 2,
    VehicleReservationCancelledByDriver = 3,
    SupportTicketCreated = 4,
    SupportTicketDriverMessage = 5,
    SupportTicketClosedByDriver = 6,
}

export interface MissingFileTypeDto {
    fileTypeId?: FileTypeEnum;
    displayName?: string | undefined;
}

export interface MissingVehicleRentDigitalDocumentListItemDto {
    id: number;
    driverId: number;
    driverFullName: string;
    isDriverDebtor: boolean;
    digitalDocumentGroupType: DigitalDocumentGroupTypeEnum;
    vehicleType?: VehicleTypeEnum;
    vehicleId: number;
    vehicleName: string;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    isForcedReceive: boolean;
    notSendedDocuments: DigitalDocumentTypeEnum[];
    documentsWaitingInQueue: DigitalDocumentTypeEnum[];
    signedDocuments: DigitalDocumentTypeEnum[];
    cancelledDocuments: DigitalDocumentTypeEnum[];
    excludeTypeFromRequiredDigitalSignature?: VehicleDriverHistoryExcludeDigitalSignatureTypeEnum;
}

export interface MissingVehicleRentDigitalDocumentListItemDtoPagedResultBody {
    items: MissingVehicleRentDigitalDocumentListItemDto[];
    count: number;
}

export interface MissingVehicleRentDigitalDocumentsListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    driverFullName?: string | undefined;
    vehicleName?: string | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
}

export interface MissingVehicleRentDigitalDocumentsListQueryResult {
    success: boolean;
    errors: string[];
    result?: MissingVehicleRentDigitalDocumentListItemDtoPagedResultBody;
}

export interface MobileApplicationDriverBalanceDto {
    balance?: number;
    advance?: number;
    forFuturePayment?: number;
    forFuturePaymentForTransport?: number;
}

export interface MobileApplicationDriverBalanceDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationDriverBalanceDto;
}

export interface MobileApplicationFinancialHistoryDto {
    overdueCharges?: FinancialHistoryOverdueChargeDto[] | undefined;
    overdueChargesTotal?: number;
    unusedCredits?: FinancialHistoryUnusedCreditDto[] | undefined;
    unusedCreditsTotal?: number;
    rentals?: FinancialHistoryRentalGroupDto[] | undefined;
    otherCharges?: FinancialHistoryPayoffItemDto[] | undefined;
    credits?: FinancialHistoryCreditDto[] | undefined;
    deposits?: FinancialHistoryDepositDto[] | undefined;
    payments?: FinancialHistoryPaymentDto[] | undefined;
    summary?: FinancialHistorySummaryDto;
}

export interface MobileApplicationFinancialHistoryDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationFinancialHistoryDto;
}

export interface MobileApplicationFinancialHistoryOverdueDto {
    overdueCharges?: FinancialHistoryOverdueChargeDto[] | undefined;
    unusedCredits?: FinancialHistoryUnusedCreditDto[] | undefined;
}

export interface MobileApplicationFinancialHistoryOverdueDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationFinancialHistoryOverdueDto;
}

export interface MobileApplicationInviteProgramCardDto {
    hasProgram?: boolean;
    inviteCode?: string | undefined;
    totalEarned?: number;
    groups?: MobileApplicationInviteProgramGroupDto[] | undefined;
    referredDrivers?: MobileApplicationReferredDriverDto[] | undefined;
    rewards?: MobileApplicationInviteProgramRewardDto[] | undefined;
}

export interface MobileApplicationInviteProgramCardDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationInviteProgramCardDto;
}

export interface MobileApplicationInviteProgramConditionDto {
    conditionTypeId?: InviteProgramConditionTypeEnum;
    requiredDays?: number | undefined;
    vehicles?: InviteProgramConditionVehicleDto[] | undefined;
}

export interface MobileApplicationInviteProgramGroupDto {
    rewardAmount?: number;
    priority?: number;
    conditions?: MobileApplicationInviteProgramConditionDto[] | undefined;
}

export interface MobileApplicationInviteProgramRewardDto {
    displayName?: string | undefined;
    rewardAmount?: number;
    grantedDate?: string;
    conditions?: MobileApplicationInviteProgramConditionDto[] | undefined;
}

export interface MobileApplicationInvoiceDto {
    id?: number;
    invoiceNumber?: string | undefined;
    grossAmount?: number;
    serviceName?: string | undefined;
    createdDate?: string;
}

export interface MobileApplicationInvoiceDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MobileApplicationInvoiceDto[] | undefined;
}

export interface MobileApplicationOnlinePaymentItemDto {
    id?: number;
    publicId?: string | undefined;
    amount?: number;
    status?: OnlinePaymentStatusEnum;
    createdDate?: string;
    payoffReason?: PayoffReasonEnum;
    paymentUrl?: string | undefined;
    paymentExpirationDate?: string;
}

export interface MobileApplicationOnlinePaymentItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MobileApplicationOnlinePaymentItemDto[] | undefined;
}

export interface MobileApplicationOnlinePaymentUrlDto {
    url?: string | undefined;
    publicId?: string | undefined;
    continueUrl?: string | undefined;
}

export interface MobileApplicationOnlinePaymentUrlDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationOnlinePaymentUrlDto;
}

export interface MobileApplicationPayoutRequestStateDto {
    isVisible?: boolean;
    blockReason?: PayoutRequestBlockReasonEnum;
}

export interface MobileApplicationPayoutRequestStateDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationPayoutRequestStateDto;
}

export interface MobileApplicationReferredDriverConditionDto {
    conditionTypeId?: InviteProgramConditionTypeEnum;
    accumulatedDays?: number;
    requiredDays?: number;
    progress?: number;
    vehicles?: InviteProgramConditionVehicleDto[] | undefined;
}

export interface MobileApplicationReferredDriverDto {
    displayName?: string | undefined;
    conditions?: MobileApplicationReferredDriverConditionDto[] | undefined;
}

export interface MobileApplicationRentedVehicleDto {
    vehicleId?: number;
    brand?: string | undefined;
    model?: string | undefined;
    vin?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
}

export interface MobileApplicationRentedVehicleDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MobileApplicationRentedVehicleDto[] | undefined;
}

export interface MobileApplicationRentedVehicleDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationRentedVehicleDto;
}

export interface MobileApplicationSettlementApplicationItemDto {
    type?: ApplicationEnum;
    sum?: number;
}

export interface MobileApplicationSettlementItemDto {
    id?: number;
    dateStart?: string;
    dateEnd?: string;
    settlementNumber?: string | undefined;
    toWithdraw?: number;
    isWithdrawBlocked?: boolean;
    applicationsResultSum?: number;
    applicationsTakenCashSum?: number;
    applicationsBonusTaxSum?: number;
    applicationsRemainingTaxSum?: number;
    partnerFee?: number;
    sii?: number;
    minus?: number;
    bonus?: number;
    petrolGrossNotIncludedInSettlementCalculation?: number;
    petrolGrossIncludedInSettlementCalculation?: number;
    petrolRefund?: number;
    serviceFee?: number;
    externalDebt?: number;
    comments?: string | undefined;
    applications?: MobileApplicationSettlementApplicationItemDto[] | undefined;
    payoffs?: MobileApplicationSettlementPayoffItemDto[] | undefined;
}

export interface MobileApplicationSettlementItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MobileApplicationSettlementItemDto[] | undefined;
}

export interface MobileApplicationSettlementPayoffItemDto {
    paidAmount?: number;
    remainingAmount?: number;
    reason?: PayoffReasonEnum;
    customReason?: string | undefined;
    date?: string | undefined;
    isRefund?: boolean;
    paymentType?: CashFlowPaymentTypeEnum;
    isPaidByDriver?: boolean;
}

export interface MobileApplicationVehicleReservationDto {
    id?: number;
    date?: string;
    vehicleTypeId?: VehicleTypeEnum;
    vehicleNameId?: VehicleNameEnum;
    vehicleId?: number | undefined;
    vehicleName?: string | undefined;
    statusId?: DriverVehicleReservationStatusEnum;
    cancelReasonId?: DriverVehicleReservationCancelReasonEnum;
}

export interface MobileApplicationVehicleReservationDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: MobileApplicationVehicleReservationDto[] | undefined;
}

export interface MobileApplicationVehicleReservationDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationVehicleReservationDto;
}

export interface MobileApplicationWeeklyEarningsDto {
    currentWeekEarnings?: number;
    previousWeekEarnings?: number;
}

export interface MobileApplicationWeeklyEarningsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: MobileApplicationWeeklyEarningsDto;
}

export enum NfzOrganizationEnum {
    Dolnoslaskie = 1,
    KujawskoPomorskie = 2,
    Lubelskie = 3,
    Lubuskie = 4,
    Lodzkie = 5,
    Malopolskie = 6,
    Mazowieckie = 7,
    Opolskie = 8,
    Podkarpackie = 9,
    Podlaskie = 10,
    Pomorskie = 11,
    Slaskie = 12,
    Swietokrzyskie = 13,
    WarminskoMazurskie = 14,
    Wielkopolskie = 15,
    Zachodniopomorskie = 16,
}

export enum NoEarningApplicationSettlementCalculationMethodEnum {
    Old = 1,
    New = 2,
    Ignore = 3,
}

export interface OnlinePaymentListItemDto {
    id: number;
    payoffId?: number | undefined;
    driverId: number;
    fullName: string;
    amount: number;
    createdDate: string;
    createdBy?: string | undefined;
    modificationDate?: string | undefined;
    modificationUserName?: string | undefined;
    onlinePaymentStatusId: OnlinePaymentStatusEnum;
    payoffReason?: PayoffReasonEnum;
    payoffCustomReason?: string | undefined;
    isAdvancePayment: boolean;
    onlinePaymentType: OnlinePaymentTypeEnum;
    isDeleted: boolean;
    hasSettlementPayoffs: boolean;
    publicId: string;
    willIssueAnInvoice: boolean;
    issuingInvoiceType?: InvoiceTypeEnum;
    invoiceMediumId?: number | undefined;
    isCreatedByDriver?: boolean;
}

export interface OnlinePaymentListItemDtoPagedResultBody {
    items: OnlinePaymentListItemDto[];
    count: number;
}

export interface OnlinePaymentListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    fullName?: string | undefined;
    createdDateStart?: string | undefined;
    createdDateEnd?: string | undefined;
    modificationDateStart?: string | undefined;
    modificationDateEnd?: string | undefined;
    createdUserName?: string | undefined;
    modifiedUserName?: string | undefined;
    statusId?: OnlinePaymentStatusEnum;
    payoffReasonId?: PayoffReasonEnum;
    isAdvancePayment?: boolean | undefined;
    type?: OnlinePaymentTypeEnum;
    showDeleted?: boolean;
    publicId?: string | undefined;
}

export interface OnlinePaymentListQueryResult {
    success: boolean;
    errors: string[];
    result?: OnlinePaymentListItemDtoPagedResultBody;
}

export interface OnlinePaymentPreviewDto {
    id?: string | undefined;
    status?: OnlinePaymentStatusEnum;
    redirectUrl?: string | undefined;
}

export interface OnlinePaymentPreviewDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: OnlinePaymentPreviewDto;
}

export enum OnlinePaymentStatusEnum {
    Waiting = 1,
    Approved = 2,
}

export enum OnlinePaymentTypeEnum {
    PayU = 1,
}

export interface OperationResult {
    success: boolean;
    errors: string[];
}

export interface OptimaExportPreviewDriverDto {
    driverId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    issues?: OptimaExportPreviewIssueDto[] | undefined;
}

export interface OptimaExportPreviewDto {
    personalData?: OptimaExportPreviewDriverDto[] | undefined;
    payments?: OptimaExportPreviewDriverDto[] | undefined;
    contracts?: OptimaExportPreviewDriverDto[] | undefined;
    selectedCount?: number;
    exportedCount?: number;
    skippedCzechDriversCount?: number;
}

export interface OptimaExportPreviewDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: OptimaExportPreviewDto;
}

export interface OptimaExportPreviewIssueDto {
    column?: string | undefined;
    level?: OptimaExportPreviewIssueLevelEnum;
    reason?: OptimaExportPreviewReasonEnum;
}

export enum OptimaExportPreviewIssueLevelEnum {
    Missing = 1,
    Warning = 2,
}

export enum OptimaExportPreviewReasonEnum {
    Missing = 1,
    PeselMissingOrInvalid = 2,
    CommuneCodeMissing = 3,
    TaxOfficeNotInDictionary = 4,
    CitizenshipNotInDictionary = 5,
    BankAccountTooShort = 6,
    NoActiveContractOfMandate = 7,
    FlatNumberEmpty = 8,
    NotApplicableStudent = 9,
    NotApplicableB2B = 10,
    NotApplicableRentOnly = 11,
    NotApplicableSiiResignation = 12,
    DuplicateCode = 13,
    NotApplicableInsuredByOtherPayer = 14,
    BothPensionRights = 15,
    DisabilityLevelMissing = 16,
}

export interface OrganisationBalanceDto {
    cash?: number;
    transfer?: number;
    cashDeposits?: number;
    transferDeposits?: number;
}

export interface OrganisationBalanceDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: OrganisationBalanceDto;
}

export interface OrganisationCashBalance {
    id?: number;
    name?: string | undefined;
    cash?: number;
    cashDeposits?: number;
    transfer?: number;
    transferDeposits?: number;
    resource?: number;
}

export interface OrganisationCreateCommandRequest {
    name?: string | undefined;
    importName?: string | undefined;
    applicationAccountsAccess?: boolean;
    isNotIncludeCompanyBikeCommission?: boolean;
    registrationCode?: string | undefined;
    initialCashBalance?: number;
    parentOrganisationId?: number | undefined;
    settleDailyPayoutsOnceWeek?: boolean;
    dailySettlementsCustomCommission?: number;
    dailyPayoutsAccess?: boolean;
    onDemandPayoutsAccess?: boolean;
    reportSchemaSetNameId?: number | undefined;
    reportToUserIds?: string[] | undefined;
    debtLimit?: number;
    address?: string | undefined;
    createCashFlowReport?: boolean;
    driverDayOffPromotionAccess?: boolean;
    isAnyVehicleInDayOffPromotion?: boolean;
    excludeFromDigitalDocumentsQueueCleanup?: boolean;
    haveAccessToVehicleRentDigitalDocuments?: boolean;
    disableTaxQualificationMechanism?: boolean;
    allowFullSocialInsurance?: boolean;
    allowMinimalSocialInsurance?: boolean;
    allowOtherSocialInsurance?: boolean;
    excludeApplicationsFromCommissions?: boolean;
    workshopAddresses?: OrganisationWorkshopAddressDto[] | undefined;
    haveAccessToPayUPayments?: boolean;
    onlinePaymentInvoicingMethod?: OrganisationOnlinePaymentInvoicingMethodEnum;
    onlinePaymentInvoiceVatPercent?: number;
    onlinePaymentInvoiceServiceName?: string | undefined;
    isSendForcedIndividualOnlinePaymentInvoice?: boolean;
    isDrivingLicenseVerification?: boolean;
    drivingLicenseVerificationTypeId?: OrganisationDrivingLicenseVerificationTypeEnum;
    chargeForRentalWithoutAppSettlement?: boolean;
    chargeForRentalWithoutAppSettlementAmount?: number;
}

export interface OrganisationCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export enum OrganisationDrivingLicenseVerificationTypeEnum {
    Car = 1,
    Scooter = 2,
    CarAndScooter = 3,
}

export interface OrganisationGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: OrganisationGetDetailsQueryResultDetails;
}

export interface OrganisationGetDetailsQueryResultDetails {
    name?: string | undefined;
    importName?: string | undefined;
    applicationAccountsAccess?: boolean;
    isNotIncludeCompanyBikeCommission?: boolean;
    registrationCode?: string | undefined;
    initialCashBalance?: number;
    parentOrganisationId?: number | undefined;
    settleDailyPayoutsOnceWeek?: boolean;
    dailySettlementsCustomCommission?: number;
    dailyPayoutsAccess?: boolean;
    onDemandPayoutsAccess?: boolean;
    reportSchemaSetNameId?: number | undefined;
    reportToUserIds?: string[] | undefined;
    debtLimit?: number;
    address?: string | undefined;
    createCashFlowReport?: boolean;
    driverDayOffPromotionAccess?: boolean;
    isAnyVehicleInDayOffPromotion?: boolean;
    excludeFromDigitalDocumentsQueueCleanup?: boolean;
    haveAccessToVehicleRentDigitalDocuments?: boolean;
    disableTaxQualificationMechanism?: boolean;
    allowFullSocialInsurance?: boolean;
    allowMinimalSocialInsurance?: boolean;
    allowOtherSocialInsurance?: boolean;
    excludeApplicationsFromCommissions?: boolean;
    workshopAddresses?: OrganisationWorkshopAddressDto[] | undefined;
    haveAccessToPayUPayments?: boolean;
    onlinePaymentInvoicingMethod?: OrganisationOnlinePaymentInvoicingMethodEnum;
    onlinePaymentInvoiceVatPercent?: number;
    onlinePaymentInvoiceServiceName?: string | undefined;
    isSendForcedIndividualOnlinePaymentInvoice?: boolean;
    isDrivingLicenseVerification?: boolean;
    drivingLicenseVerificationTypeId?: OrganisationDrivingLicenseVerificationTypeEnum;
    chargeForRentalWithoutAppSettlement?: boolean;
    chargeForRentalWithoutAppSettlementAmount?: number;
    id?: number;
}

export enum OrganisationOnlinePaymentInvoicingMethodEnum {
    ForceAlwaysIndividualInvoice = 1,
    Selectable = 2,
}

export interface OrganisationOnlinePaymentInvoicingMethodEnumNullableOperationResult {
    success: boolean;
    errors: string[];
    result?: OrganisationOnlinePaymentInvoicingMethodEnum;
}

export interface OrganisationSelectItemDto {
    id: number;
    name: string;
    parentOrganisationId?: number | undefined;
}

export interface OrganisationSelectItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: OrganisationSelectItemDto[] | undefined;
}

export interface OrganisationUpdateCommandRequest {
    name?: string | undefined;
    importName?: string | undefined;
    applicationAccountsAccess?: boolean;
    isNotIncludeCompanyBikeCommission?: boolean;
    registrationCode?: string | undefined;
    initialCashBalance?: number;
    parentOrganisationId?: number | undefined;
    settleDailyPayoutsOnceWeek?: boolean;
    dailySettlementsCustomCommission?: number;
    dailyPayoutsAccess?: boolean;
    onDemandPayoutsAccess?: boolean;
    reportSchemaSetNameId?: number | undefined;
    reportToUserIds?: string[] | undefined;
    debtLimit?: number;
    address?: string | undefined;
    createCashFlowReport?: boolean;
    driverDayOffPromotionAccess?: boolean;
    isAnyVehicleInDayOffPromotion?: boolean;
    excludeFromDigitalDocumentsQueueCleanup?: boolean;
    haveAccessToVehicleRentDigitalDocuments?: boolean;
    disableTaxQualificationMechanism?: boolean;
    allowFullSocialInsurance?: boolean;
    allowMinimalSocialInsurance?: boolean;
    allowOtherSocialInsurance?: boolean;
    excludeApplicationsFromCommissions?: boolean;
    workshopAddresses?: OrganisationWorkshopAddressDto[] | undefined;
    haveAccessToPayUPayments?: boolean;
    onlinePaymentInvoicingMethod?: OrganisationOnlinePaymentInvoicingMethodEnum;
    onlinePaymentInvoiceVatPercent?: number;
    onlinePaymentInvoiceServiceName?: string | undefined;
    isSendForcedIndividualOnlinePaymentInvoice?: boolean;
    isDrivingLicenseVerification?: boolean;
    drivingLicenseVerificationTypeId?: OrganisationDrivingLicenseVerificationTypeEnum;
    chargeForRentalWithoutAppSettlement?: boolean;
    chargeForRentalWithoutAppSettlementAmount?: number;
    id?: number;
}

export interface OrganisationUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface OrganisationWorkshopAddressDto {
    id?: number;
    name: string;
    address: string;
}

export interface OrganisationsGetIdsAndNamesQueryRequest {
    search?: string | undefined;
    onlyAssignedToMe?: boolean;
}

export interface OrganisationsGetIdsAndNamesQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: IdAndNameResult[] | undefined;
}

export interface OrganisationsListQuery {
    sortItems?: SortRequestItem[] | undefined;
}

export interface OrganisationsListQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: OrganisationsListQueryResultItem[] | undefined;
}

export interface OrganisationsListQueryResultItem {
    id?: number;
    name?: string | undefined;
    parentOrganisation?: string | undefined;
    parentOrganisationId?: number | undefined;
    cashBalance?: number;
}

export interface OtherCostDto {
    name?: string | undefined;
    value?: number;
}

export enum PaymentEntityTypeEnum {
    Common = 1,
    Advance = 2,
    B2B = 3,
}

export interface PaymentGetAllByQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: PaymentGetAllByQueryResultItem[] | undefined;
}

export interface PaymentGetAllByQueryResultItem {
    id?: number;
    settlementId?: number | undefined;
    driverId?: number | undefined;
    settlementNumber?: string | undefined;
    transferNumber?: string | undefined;
    driverFullName?: string | undefined;
    paymentCreatedDate?: string;
    amount?: number;
    driverBankAccountNumber?: string | undefined;
    isActive?: boolean;
    paymentEntityType?: PaymentEntityTypeEnum;
}

export interface PaymentGetSettingsQueryResult {
    success: boolean;
    errors: string[];
    result?: PaymentGetSettingsQueryResultItem;
}

export interface PaymentGetSettingsQueryResultItem {
    companyBankAccountNumber?: string | undefined;
    czechiaCompanyBankName?: string | undefined;
    czechiaCompanyBankCode?: string | undefined;
    czechiaCompanyBankAccountNumber?: string | undefined;
    companyBankAccountNumberForB2B?: string | undefined;
    dailyPayout?: number;
    weeklyPayout?: number;
    paymentsAccountNumber?: string | undefined;
    additionalWaitingTimeForStudentCard?: number;
    rentalExtensionDays?: number;
    rentalExtensionQuotaType?: RentalExtensionQuotaTypeEnum;
    cashbackMaxDebtLimit?: number;
    cashbackEvaluationWindowDays?: number;
    toBeRemovedFromSiiDays?: number;
    toBeRemovedFromSiiDaysModificationDate?: string | undefined;
    siiSettings: SiiSettingDto[];
    vehicleReturnSettings: VehicleReturnSettingDto[];
}

export enum PaymentStatusEnum {
    Waiting = 1,
    Approved = 2,
    Executed = 3,
}

export enum PaymentTypeEnum {
    Cash = 1,
    Transfer = 2,
    Blik = 3,
    IngCard = 4,
}

export interface PaymentUpdateSettingsCommandRequest {
    companyBankAccountNumber?: string | undefined;
    czechiaCompanyBankName?: string | undefined;
    czechiaCompanyBankCode?: string | undefined;
    czechiaCompanyBankAccountNumber?: string | undefined;
    companyBankAccountNumberForB2B?: string | undefined;
    dailyPayout?: number;
    weeklyPayout?: number;
    paymentsAccountNumber?: string | undefined;
    additionalWaitingTimeForStudentCard?: number;
    rentalExtensionDays?: number;
    rentalExtensionQuotaType?: RentalExtensionQuotaTypeEnum;
    cashbackMaxDebtLimit?: number;
    cashbackEvaluationWindowDays?: number;
    toBeRemovedFromSiiDays?: number;
    siiSettings: SiiSettingDto[];
    vehicleReturnSettings: VehicleReturnSettingDto[];
}

export interface PayoffCreateCommandRequest {
    date?: string | undefined;
    driverId?: number | undefined;
    organisationId?: number | undefined;
    vehicleId?: number | undefined;
    installmentSchemaId?: number | undefined;
    quota: number;
    reasonId?: PayoffReasonEnum;
    customReason: string;
    isRavapiTransportCommission: boolean;
    isBezproblemTransportCommission: boolean;
    isAdvancePayment: boolean;
    isRavapiCommission: boolean;
    isBezproblemCommission: boolean;
    isAccountCommission: boolean;
    isMovedFromAnotherSettlement: boolean;
    isCommissionForDailySettlement: boolean;
    isRefund: boolean;
    comments: string;
    settlementId?: number | undefined;
    resourceId?: number | undefined;
    cashFlowPaymentTypeId?: CashFlowPaymentTypeEnum;
    payoffPaymentTypeId?: PayoffPaymentTypeEnum;
    isAbleToCreateForFuturePayoffWithoutPermissions?: boolean;
    blockDriverWithdraw?: boolean | undefined;
    paymentSuspensionReason?: string | undefined;
    isDriverWithdrawBlocked: boolean;
    hasDriverWithdrawBlockingStatuses: boolean;
}

export interface PayoffCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface PayoffDeleteCommandResult {
    success: boolean;
    errors: string[];
}

export enum PayoffFilterTypeEnum {
    Bonus = 1,
    Minus = 2,
}

export interface PayoffGetPagedQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    driverId?: number | undefined;
    organisationId?: number | undefined;
    driverFirstName?: string | undefined;
    driverLastName?: string | undefined;
    reason?: PayoffReasonEnum;
    customReason?: string | undefined;
    isFullyPaidUp?: boolean;
    showDeleted?: boolean;
    isCanceled?: boolean;
    comments?: string | undefined;
    payoffType?: PayoffTypeEnum;
    onlinePaymentPublicId?: string | undefined;
}

export interface PayoffGetPagedQueryResult {
    success: boolean;
    errors: string[];
    result?: PayoffGetPagedQueryResultBody;
}

export interface PayoffGetPagedQueryResultBody {
    items: PayoffGetPagedQueryResultItem[];
    count: number;
    total?: number;
}

export interface PayoffGetPagedQueryResultItem {
    id?: number;
    driverFullName?: string | undefined;
    vehicleName?: string | undefined;
    organisation?: string | undefined;
    quota?: number;
    date?: string | undefined;
    isRavapiTransportCommission?: boolean;
    isBezproblemTransportCommission?: boolean;
    isAdvancePayment?: boolean;
    reason?: string | undefined;
    isDeleted?: boolean;
    remainingPayoff?: number;
    isCommissionForDailySettlement?: boolean;
    comments?: string | undefined;
    payoffTypeId?: PayoffTypeEnum;
    onlinePaymentPublicId?: string | undefined;
}

export interface PayoffGetVehiclesForAutocompleteQueryRequest {
    id?: number | undefined;
    searchPhrase?: string | undefined;
    organisationId?: number | undefined;
    showDisabled?: boolean;
}

export interface PayoffGetVehiclesForAutocompleteQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: PayoffGetVehiclesForAutocompleteQueryResultItem[] | undefined;
}

export interface PayoffGetVehiclesForAutocompleteQueryResultDriver {
    id: number;
    fullName: string;
}

export interface PayoffGetVehiclesForAutocompleteQueryResultItem {
    id: number;
    isVehicleShared: boolean;
    name?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    disabled: boolean;
    driver?: PayoffGetVehiclesForAutocompleteQueryResultDriver;
}

export enum PayoffPaymentTypeEnum {
    Cash = 1,
    Card = 2,
    Transfer = 3,
}

export enum PayoffReasonEnum {
    VehicleRent = 1,
    Bonus = 2,
    Charge = 3,
    ResidentCard = 4,
    Bag = 5,
    ContractualPenalties = 6,
    Bailiff = 7,
    Sii = 8,
    VehicleDamage = 9,
    WorkingOnFleetCar = 10,
    WorkLegalizationProcess = 11,
    ResourceConsumption = 12,
    ForFuturePayment = 13,
    DayOff = 14,
    ForFuturePaymentForTransport = 15,
    RentalOnlyCharge = 16,
    Cashback = 17,
    Referral = 18,
}

export interface PayoffReasonQuota {
    reason?: PayoffReasonEnum;
    baseQuota?: number;
    repaidAmount?: number;
}

export enum PayoffRepaymentTypeEnum {
    Paid = 1,
    Unpaid = 2,
}

export interface PayoffRestoreDeletedCommandRequest {
    id?: number;
    blockDriverWithdraw?: boolean | undefined;
    paymentSuspensionReason?: string | undefined;
}

export interface PayoffRestoreDeletedCommandResult {
    success: boolean;
    errors: string[];
}

export enum PayoffTypeEnum {
    Default = 1,
    PayU = 2,
}

export interface PayoffUpdateCommandRequest {
    date?: string | undefined;
    driverId: number;
    organisationId: number;
    vehicleId?: number | undefined;
    quota: number;
    reasonId?: PayoffReasonEnum;
    customReason: string;
    isRavapiTransportCommission: boolean;
    isBezproblemTransportCommission: boolean;
    isRavapiCommission: boolean;
    isBezproblemCommission: boolean;
    isAccountCommission: boolean;
    isAdvancePayment: boolean;
    isDeleted: boolean;
    remainingPayoff: number;
    installmentSchemaId: number;
    settlementPayoffList: SettlementPayoffListItem[];
    isCommissionForDailySettlement: boolean;
    isRefund: boolean;
    comments: string;
    resourceId?: number | undefined;
    cashFlowPaymentTypeId?: CashFlowPaymentTypeEnum;
    payoffPaymentTypeId?: PayoffPaymentTypeEnum;
    vehicleName?: string | undefined;
    isVehicleOrganisationSameAsDriver?: boolean;
    driverName?: string | undefined;
    isDriverOrganisationSameAsUser?: boolean;
    isCanceled?: boolean;
    canceledQuota?: number | undefined;
    blockDriverWithdraw?: boolean | undefined;
    paymentSuspensionReason?: string | undefined;
    isDriverWithdrawBlocked: boolean;
    hasDriverWithdrawBlockingStatuses: boolean;
    payoffTypeId: PayoffTypeEnum;
    onlinePaymentPublicId?: string | undefined;
    id?: number;
}

export interface PayoffUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface PayoffsGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: PayoffsGetDetailsQueryResultDetails;
}

export interface PayoffsGetDetailsQueryResultDetails {
    date?: string | undefined;
    driverId: number;
    organisationId: number;
    vehicleId?: number | undefined;
    quota: number;
    reasonId?: PayoffReasonEnum;
    customReason: string;
    isRavapiTransportCommission: boolean;
    isBezproblemTransportCommission: boolean;
    isRavapiCommission: boolean;
    isBezproblemCommission: boolean;
    isAccountCommission: boolean;
    isAdvancePayment: boolean;
    isDeleted: boolean;
    remainingPayoff: number;
    installmentSchemaId: number;
    settlementPayoffList: SettlementPayoffListItem[];
    isCommissionForDailySettlement: boolean;
    isRefund: boolean;
    comments: string;
    resourceId?: number | undefined;
    cashFlowPaymentTypeId?: CashFlowPaymentTypeEnum;
    payoffPaymentTypeId?: PayoffPaymentTypeEnum;
    vehicleName?: string | undefined;
    isVehicleOrganisationSameAsDriver?: boolean;
    driverName?: string | undefined;
    isDriverOrganisationSameAsUser?: boolean;
    isCanceled?: boolean;
    canceledQuota?: number | undefined;
    blockDriverWithdraw?: boolean | undefined;
    paymentSuspensionReason?: string | undefined;
    isDriverWithdrawBlocked: boolean;
    hasDriverWithdrawBlockingStatuses: boolean;
    payoffTypeId: PayoffTypeEnum;
    onlinePaymentPublicId?: string | undefined;
}

export interface PayoutMethodEntryDto {
    beginDate?: string | undefined;
    preferredPaymentTypeId?: PreferredPaymentTypeEnum;
}

export interface PayoutMethodSummaryDto {
    current?: PayoutMethodEntryDto;
    lastPrevious?: PayoutMethodEntryDto;
    firstUpcoming?: PayoutMethodEntryDto;
    isDailyPayoutAvailable?: boolean;
    isOnDemandPayoutAvailable?: boolean;
}

export interface PayoutMethodSummaryDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: PayoutMethodSummaryDto;
}

export enum PayoutRequestBlockReasonEnum {
    PendingRequest = 1,
    NonPositiveBalance = 2,
    NothingToPay = 3,
}

export interface PendingDriverVehicleReservationDto {
    id?: number;
    date?: string;
    vehicleTypeId?: VehicleTypeEnum;
    vehicleNameId?: VehicleNameEnum;
    vehicleId?: number | undefined;
    statusId?: DriverVehicleReservationStatusEnum;
    createdAt?: string;
}

export interface PendingDriverVehicleReservationDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: PendingDriverVehicleReservationDto[] | undefined;
}

export enum PeriodFilter {
    DailyOnly = 0,
    WithoutDaily = 1,
}

export enum PetrolVatRateEnum {
    Vat23 = 1,
    Vat8 = 2,
}

export interface Pit11ProgressDto {
    step?: Pit11ProgressStepEnum;
    totalRecords?: number;
    processedRecords?: number;
    isCompleted?: boolean;
}

export enum Pit11ProgressStepEnum {
    FetchingFiles = 1,
    CsvValidation = 2,
    AssigningPdfToDrivers = 3,
    SendingEmailsToDrivers = 4,
    SendingLogs = 5,
    Completed = 6,
}

export interface PostponedPayoffsStatistics {
    quantity?: number;
    quota?: number;
    userFullName?: string | undefined;
}

export enum PreferredPaymentMethodEnum {
    Cash = 1,
    Transfer = 2,
    Blik = 3,
    IngCard = 4,
    Revolut = 5,
}

export enum PreferredPaymentTypeEnum {
    Daily = 1,
    Weekly = 2,
    OnDemand = 3,
}

export interface ReferralDetailsDto {
    id: number;
    name?: string | undefined;
    code?: string | undefined;
    url?: string | undefined;
    expirationDays?: number;
    isDeleted?: boolean;
    registrationNumber?: number;
    activeAccountsNumber?: number;
    averageAmountToPaid?: number;
    rentalDaysNumber?: number;
    rentPaidPercentage?: number;
}

export interface ReferralDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: ReferralDetailsDto;
}

export interface ReferralDto {
    id: number;
    name?: string | undefined;
    code?: string | undefined;
    url?: string | undefined;
    expirationDays?: number;
    isDeleted?: boolean;
}

export interface ReferralDtoPagedResultBody {
    items: ReferralDto[];
    count: number;
}

export interface ReferralsDecimalValuesStatistics {
    referralName?: string | undefined;
    value?: number;
}

export interface ReferralsListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: number;
    name?: string | undefined;
    code?: string | undefined;
    expirationDays?: number | undefined;
    showDeleted?: boolean;
}

export interface ReferralsListQueryResult {
    success: boolean;
    errors: string[];
    result?: ReferralDtoPagedResultBody;
}

export interface ReferralsTotalValuesStatistics {
    referralName?: string | undefined;
    value?: number;
}

export interface RefreshDriverUploadTokenCommand {
    id?: number;
}

export interface RejectKnowledgeProposalCommand {
    proposalId?: number;
    reason?: string | undefined;
}

export interface RemoveDriversFromSIICommand {
    driverIds?: number[] | undefined;
    dateMode?: MassChangeDriverHrTagDateModeEnum;
    commonDate?: string | undefined;
    overrideExistingDate?: boolean;
}

export interface RentPaidPercentageReferralDto {
    id?: number;
    driverId?: number;
    driverFullName?: string | undefined;
    payoffReason?: string | undefined;
    payoffId?: number;
    paidPayoff?: number;
    basePayoff?: number;
    readonly percentage?: number;
}

export interface RentPaidPercentageReferralDtoPagedResultBody {
    items: RentPaidPercentageReferralDto[];
    count: number;
}

export interface RentPaidPercentageReferralsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: number;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface RentPaidPercentageReferralsQueryResult {
    success: boolean;
    errors: string[];
    result?: RentPaidPercentageReferralDtoPagedResultBody;
}

export enum RentalExtensionQuotaTypeEnum {
    Standard = 1,
    Discounted = 2,
}

export interface ReportCashDto {
    balance: number;
    deposits: number;
    payoffResourceSum: number;
}

export interface ReportDriversToSIICommand {
    driverIds?: number[] | undefined;
    dateMode?: MassChangeDriverHrTagDateModeEnum;
    commonDate?: string | undefined;
    overrideExistingDate?: boolean;
}

export interface ReportDto {
    id: number;
    organisationId: number;
    driversInOffice: number;
    comment?: string | undefined;
    hasBeenSent: boolean;
    date: string;
    town: string;
    schemaFields: ReportSchemaEnum[];
    remainCorrections: number;
    reportStatistics?: ReportStatisticsDto;
    previousCorrectionReportStatistics?: ReportStatisticsDto;
    increase?: ReportIncreaseDto;
    previousCorrectionIncrease?: ReportIncreaseDto;
    incidents?: ReportIncidentDto[] | undefined;
    previousCorrectionIncidents?: ReportIncidentDto[] | undefined;
    organsationCashBefore: ReportCashDto;
    organsationCashActual: ReportCashDto;
    organsationCashAfter: ReportCashDto;
}

export interface ReportDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: ReportDto;
}

export interface ReportIncidentDto {
    id: number;
    organisationReportId?: number;
    vehicleIncidentId?: number;
    drivers: IdAndNameResult[];
    vehicleId: number;
    vehicleIncidentTypeId: VehicleIncidentTypeEnum;
    date: string;
    description?: string | undefined;
    serviceName?: string | undefined;
    serviceShortName?: string | undefined;
    mileage?: number | undefined;
    vehicleName: string;
    vehicleTypeId: VehicleTypeEnum;
    media?: FileNameAndId[] | undefined;
}

export interface ReportIncreaseDto {
    previousDriversInOffice: number;
    reportStatistics?: ReportStatisticsDto;
}

export interface ReportListItemDto {
    id: number;
    organisationId: number;
    organisation: string;
    date: string;
    hasBeenSent: boolean;
    remainCorrections: number;
}

export interface ReportListItemDtoPagedResultBody {
    items: ReportListItemDto[];
    count: number;
}

export interface ReportListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    hasBeenSent: boolean;
    organisationId?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
}

export interface ReportListQueryResult {
    success: boolean;
    errors: string[];
    result?: ReportListItemDtoPagedResultBody;
}

export interface ReportSchemaDto {
    id: number;
    name: string;
    isDeleted: boolean;
    isUsedOnReport: boolean;
    reportSchemaIds: ReportSchemaEnum[];
}

export interface ReportSchemaDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: ReportSchemaDto[] | undefined;
}

export enum ReportSchemaEnum {
    DriversInOffice = 1,
    DriversPartnership = 2,
    Comment = 3,
    DailyDrivers = 4,
    NewDriversContact = 5,
    NewDriversNotContact = 6,
    IsActiveApplicationAccountQuantity = 7,
    ApplicationAccountsRented = 8,
    ApplicationAccountsReturned = 9,
    Increase = 10,
    BikesRented = 11,
    BikesWorking = 12,
    BikesNotUsed = 13,
    BikesInUse = 14,
    BikesReturned = 15,
    BikesInWorkshop = 16,
    EBikesRented = 17,
    EBikesWorking = 18,
    EBikesNotUsed = 19,
    EBikesInUse = 20,
    EBikesReturned = 21,
    EBikesInWorkshop = 22,
    MotorsRented = 23,
    MotorsWorking = 24,
    MotorsNotUsed = 25,
    MotorsInUse = 26,
    MotorsReturned = 27,
    MotorsInWorkshop = 28,
    CarsRented = 29,
    CarsWorking = 30,
    CarsNotUsed = 31,
    CarsInUse = 32,
    CarsReturned = 33,
    CarsInWorkshop = 34,
    BikesInMaintain = 35,
    EBikesInMaintain = 36,
    MotorsInMaintain = 37,
    CarsInMaintain = 38,
    Incidents = 39,
    Balance = 40,
    Deposits = 41,
    PayoffResourceSum = 42,
}

export interface ReportStatisticsDto {
    driversPartnership: number;
    dailyDrivers: number;
    newDriversContact: number;
    newDriversNotContact: number;
    isActiveApplicationAccountQuantity: number;
    applicationAccountsRented: number;
    applicationAccountsReturned: number;
    bikesRented: number;
    bikesWorking: number;
    bikesNotUsed: number;
    bikesInUse: number;
    bikesReturned: number;
    bikesInWorkshop: number;
    bikesInMaintain: number;
    eBikesRented: number;
    eBikesWorking: number;
    eBikesNotUsed: number;
    eBikesInUse: number;
    eBikesReturned: number;
    eBikesInWorkshop: number;
    eBikesInMaintain: number;
    motorsRented: number;
    motorsWorking: number;
    motorsNotUsed: number;
    motorsInUse: number;
    motorsReturned: number;
    motorsInWorkshop: number;
    motorsInMaintain: number;
    carsRented: number;
    carsWorking: number;
    carsNotUsed: number;
    carsInUse: number;
    carsReturned: number;
    carsInWorkshop: number;
    carsInMaintain: number;
}

export interface RequestMobileApplicationPayoutCommand {
    comments?: string | undefined;
}

export interface ResetUserPasswordCommandRequest {
    id?: string;
}

export interface ResourceConsumptionTableStatistics {
    name?: string | undefined;
    givenResource?: number;
    paidByDrivers?: number;
    paidByOrganisation?: number;
    readonly remaining?: number;
}

export interface ResourceDto {
    id: number;
    name: string;
    createdTime: string;
    isDeleted: boolean;
}

export interface ResourceDtoPagedResultBody {
    items: ResourceDto[];
    count: number;
}

export interface ResourceListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    showDeleted?: boolean;
}

export interface ResourceListQueryResult {
    success: boolean;
    errors: string[];
    result?: ResourceDtoPagedResultBody;
}

export interface RestoreTicketCommand {
    ticketId?: number;
}

export interface ReuploadTokenDto {
    id?: string;
    fullName?: string | undefined;
    isTaxi?: boolean;
    expirationDate?: string;
}

export interface ReuploadTokenDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: ReuploadTokenDto;
}

export interface RuleDetailsDto {
    id?: number;
    name?: string | undefined;
    mainConditionGroupId?: number | undefined;
    mailTypeDetail?: MailTypeDetailSelectListDto;
    conditionGroups?: ConditionGroupDto[] | undefined;
}

export interface RuleDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: RuleDetailsDto;
}

export interface SaveTicketFileToDriverFilesCommand {
    messageId?: number;
    fileTypeId?: FileTypeEnum;
    fileName?: string | undefined;
}

export interface SearchTerytCitiesQuery {
    query?: string | undefined;
    voivodeshipCode?: string | undefined;
}

export interface SearchTerytStreetsQuery {
    cityName?: string | undefined;
    query?: string | undefined;
}

export interface SelectMobileApplicationTaxOfficeCommand {
    taxOffice?: string | undefined;
}

export interface SendDigitalDocumentToQueueCommand {
    documents?: DigitalDocumentQueueDto[] | undefined;
    driverIds?: number[] | undefined;
    vehicleId?: number | undefined;
}

export interface SendEmailToDriverCommandRequest {
    ids?: number[] | undefined;
    isJobRequest?: boolean;
}

export interface SendEmailsToDriversCommandRequest {
    ids?: number[] | undefined;
    isJobRequest?: boolean;
}

export interface SendEmployeeMessageCommand {
    ticketId?: number;
    content?: string | undefined;
}

export interface SendMobileApplicationAiMessageCommand {
    history?: AiChatMessageDto[] | undefined;
    userMessage?: string | undefined;
    language?: DriverLanguageEnum;
    clarificationStreak?: number;
    supportHours?: AiSupportHoursContextDto;
}

export interface SendMobileApplicationAiMessageCommandDetails {
    assistantMessage?: string | undefined;
    assistantMessageKind?: AiMessageKindEnum;
    consultantNeeded?: boolean;
    newClarificationStreak?: number;
}

export interface SendMobileApplicationAiMessageCommandDetailsOperationResult {
    success: boolean;
    errors: string[];
    result?: SendMobileApplicationAiMessageCommandDetails;
}

export interface SendMobileApplicationDriverMessageCommand {
    ticketId?: number;
    content?: string | undefined;
}

export enum ServiceTypeEnum {
    Taxi = 1,
    Food = 2,
}

export interface SetDriverDisableRequestStatusCommand {
    driverId?: number;
    newStatus?: DisableMobileApplicationRequestStatusEnum;
}

export interface SetDriverFilesVisibilityCommand {
    mediumIds?: number[] | undefined;
    isMobileAppVisible?: boolean;
}

export interface SetInviteProgramDraftStateCommand {
    id?: number;
    isDraft?: boolean;
}

export interface SetMobileApplicationSupportTicketHelpfulnessCommand {
    ticketId?: number;
    wasHelpful?: boolean;
}

export interface SetVehiclesCashbackCommand {
    vehicleIds?: number[] | undefined;
    operation?: VehicleCashbackMassOperationEnum;
    amount?: number | undefined;
    requiredDays?: number | undefined;
}

export interface SetVehiclesCashbackResultItemDto {
    vehicleId?: number;
    success?: boolean;
    errorMessage?: string | undefined;
}

export interface SetVehiclesCashbackResultItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: SetVehiclesCashbackResultItemDto[] | undefined;
}

export interface SettlementAdjustCommissionDto {
    settlementIds: number[];
    expectedRavapiCommission: number;
    expectedAstekCommission: number;
    commissionCalculationTypeId?: CommissionCalculationTypeEnum;
    isDefault: boolean;
    isPercentCommission: boolean;
    commissionBaseField?: CommissionBaseFieldEnum;
}

export interface SettlementApplicationUpdateCommandRequest {
    settlementId: number;
    applicationId: ApplicationEnum;
    applicationAccountId?: number | undefined;
    applicationQuota: number;
    promotion: number;
    tips: number;
    netBonus: number;
    minus: number;
    commission: number;
    remainingTax: number;
    grossBonus: number;
    isExcludedFromCommissions: boolean;
    owner: ApplicationAccountOwnerEnum;
    id?: number | undefined;
}

export interface SettlementChangeManualEditFlagCommandRequest {
    ids?: number[] | undefined;
}

export interface SettlementChangePaymentStatusRequest {
    ids?: number[] | undefined;
    massUpdate?: boolean;
    paymentStatus?: PaymentStatusEnum;
    toAudit?: boolean;
    isCashSettle?: boolean;
    isJobRequest?: boolean;
}

export interface SettlementChangePaymentStatusResult {
    success: boolean;
    errors: string[];
}

export interface SettlementCreateCashSettleCommand {
    driverId?: number;
    cashAmount?: number;
    isCreateForFuturePayoffFromDriverRestCash?: boolean;
    isCreateForFuturePayoffForTransportFromDriverRestCash?: boolean;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface SettlementCreateCommandRequest {
    driverId?: number | undefined;
    dateStart: string;
    dateEnd: string;
    astekCommission: number;
    astekAccountCommission: number;
    ravapiCommission: number;
    comments?: string | undefined;
    paymentTypeId?: PaymentTypeEnum;
    paymentStatusId: PaymentStatusEnum;
    isDeleted?: boolean;
    isAttentionRequired: boolean;
    isMailWasSentToDriver: boolean;
    isMailOrderedToBeSent: boolean;
    settlementNumber?: string | undefined;
    uknownApplicationAccountPhoneNumber?: string | undefined;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    payoff: SettlementPayoffItem[];
    isManualEditPayoff: boolean;
    areAdvancesIncluded: boolean;
    previousPaymentStatusId?: PaymentStatusEnum;
    previousPaymentStatusModifyDate?: string | undefined;
    modifyUserFullName?: string | undefined;
    userId?: string | undefined;
    settleDailyPayoutsOnceWeek: boolean;
    email: string;
    firstName: string;
    lastName: string;
    commissionCalculationTypeId?: CommissionCalculationTypeEnum;
    expectedRavapiCommission: number;
    expectedAstekCommission: number;
    isManualEditCommissions: boolean;
    isCorrection: boolean;
    isBoltFoodWeeklyTipsImport: boolean;
    excludeFromExport: boolean;
    forceRavapiPaymentsTitle: boolean;
    serviceFee: number;
    toWithdrawQuota: number;
    status: SettlementStatusEnum;
    isDriverWithdrawBlocked: boolean;
    noEarningApplicationSettlementCalculationMethodId: NoEarningApplicationSettlementCalculationMethodEnum;
    lastModificationDate?: string;
    fuelCards: SettlementFuelCardDto[];
    applicationSettlements: SettlementDetailsApplicationBase[];
    mediaIds?: number[] | undefined;
    isImportRequest?: boolean;
    isSettleCashWithDriver?: boolean;
    driverCash?: number;
    isCreateForFuturePayoffFromDriverRestCash?: boolean;
    isJobRequest?: boolean;
    isAbleToUpdateServiceFee?: boolean;
    isSettleForFuturePayoffs?: boolean;
    skipDriverTagCalculation?: boolean;
    isCreateForFuturePayoffForTransportFromDriverRestCash?: boolean;
    recalculateSii?: boolean;
    isCreatedByDriver?: boolean;
}

export interface SettlementCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface SettlementDeleteCommandResult {
    success: boolean;
    errors: string[];
}

export interface SettlementDetailsApplicationBase {
    settlementId: number;
    applicationId: ApplicationEnum;
    applicationAccountId?: number | undefined;
    applicationQuota: number;
    promotion: number;
    tips: number;
    netBonus: number;
    minus: number;
    commission: number;
    remainingTax: number;
    grossBonus: number;
    isExcludedFromCommissions: boolean;
    owner: ApplicationAccountOwnerEnum;
}

export interface SettlementFile {
    id?: number;
    fileName?: string | undefined;
    isRelatedWithInvoice?: boolean;
}

export interface SettlementFuelCardDto {
    id: number;
    settlementId: number;
    fuelCardTypeId?: FuelCardTypeEnum;
    cardNumber?: string | undefined;
    quota: number;
    refund: number;
    includeInSettlementCalculation: boolean;
}

export enum SettlementImportFileSchemaTypeEnum {
    Old = 1,
    New = 2,
    NewSince01062025 = 3,
}

export interface SettlementItemVehicleDto {
    id?: number;
    registrationNumber?: string | undefined;
    vehicleName?: string | undefined;
}

export interface SettlementMassAddSiiPayoffsDto {
    settlementIds: number[];
    isPercent: boolean;
    value: number;
}

export interface SettlementMassDeleteCommandRequest {
    ids?: number[] | undefined;
}

export interface SettlementMassUpdateServiceFeeDto {
    settlementIds: number[];
    serviceFeePercent: number;
}

export interface SettlementPayoffItem {
    id: number;
    basePayoff: number;
    remainingPayoff: number;
    payoffAmount: number;
    reasonId?: PayoffReasonEnum;
    customReason?: string | undefined;
    date?: string | undefined;
    vehicleName: string;
    payoffId: number;
    isRavapiTransportCommission: boolean;
    isBezproblemTransportCommission: boolean;
    isAdvancePayment: boolean;
    isPaidByDriver: boolean;
    isMovedFromAnotherSettlement: boolean;
    isCanceledSettlementPayoff: boolean;
    isHoldOffSettlementPayoff: boolean;
    isCommissionForDailySettlement: boolean;
    isRefund: boolean;
    comments: string;
    resourceId?: number | undefined;
    resourceName?: string | undefined;
    cashFlowPaymentTypeId?: CashFlowPaymentTypeEnum;
    cashFlowReportId?: number | undefined;
    payoffTypeId?: PayoffTypeEnum;
}

export interface SettlementPayoffListItem {
    settlementNumber?: string | undefined;
    settlementId?: number;
    amount?: number;
}

export enum SettlementPeriodFilterEnum {
    Daily = 1,
    Weekly = 2,
}

export interface SettlementQuickUpdateCommandRequest {
    id: number;
    comments: string;
    astecAccountCommision: number;
    astekCommission: number;
    ravapiCommission: number;
}

export interface SettlementQuickUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface SettlementReferralDto {
    id?: number;
    settlementId?: number;
    settlementNumber?: string | undefined;
    paymentStatus?: PaymentStatusEnum;
    dateStart?: string;
    dateEnd?: string;
    quota?: number;
}

export interface SettlementReferralDtoPagedResultBody {
    items: SettlementReferralDto[];
    count: number;
}

export interface SettlementSettingsDto {
    generalSettings: GeneralSettlementSettingDto[];
    debtSettings: DebtSettingDto[];
    applicationSettlementBonusSettings: ApplicationSettlementBonusSettingDto[];
    rentalChargeExemptDrivers: ChargeExemptDriverDto[];
    siiChargeExemptDrivers: ChargeExemptDriverDto[];
}

export interface SettlementSettingsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: SettlementSettingsDto;
}

export enum SettlementSettingsTypeEnum {
    ServiceFee = 1,
    ResetIsContactedForDebt = 2,
    PetrolVatRate = 3,
}

export enum SettlementStatusEnum {
    Ok = 1,
    Minus = 2,
    PayoutTooSmall = 3,
    AttentionRequired = 4,
    PayoutTooBig = 5,
}

export interface SettlementUpdateCommandRequest {
    driverId?: number | undefined;
    dateStart: string;
    dateEnd: string;
    astekCommission: number;
    astekAccountCommission: number;
    ravapiCommission: number;
    comments?: string | undefined;
    paymentTypeId?: PaymentTypeEnum;
    paymentStatusId: PaymentStatusEnum;
    isDeleted?: boolean;
    isAttentionRequired: boolean;
    isMailWasSentToDriver: boolean;
    isMailOrderedToBeSent: boolean;
    settlementNumber?: string | undefined;
    uknownApplicationAccountPhoneNumber?: string | undefined;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    payoff: SettlementPayoffItem[];
    isManualEditPayoff: boolean;
    areAdvancesIncluded: boolean;
    previousPaymentStatusId?: PaymentStatusEnum;
    previousPaymentStatusModifyDate?: string | undefined;
    modifyUserFullName?: string | undefined;
    userId?: string | undefined;
    settleDailyPayoutsOnceWeek: boolean;
    email: string;
    firstName: string;
    lastName: string;
    commissionCalculationTypeId?: CommissionCalculationTypeEnum;
    expectedRavapiCommission: number;
    expectedAstekCommission: number;
    isManualEditCommissions: boolean;
    isCorrection: boolean;
    isBoltFoodWeeklyTipsImport: boolean;
    excludeFromExport: boolean;
    forceRavapiPaymentsTitle: boolean;
    serviceFee: number;
    toWithdrawQuota: number;
    status: SettlementStatusEnum;
    isDriverWithdrawBlocked: boolean;
    noEarningApplicationSettlementCalculationMethodId: NoEarningApplicationSettlementCalculationMethodEnum;
    lastModificationDate?: string;
    fuelCards: SettlementFuelCardDto[];
    applicationSettlements: SettlementApplicationUpdateCommandRequest[];
    id: number;
    mediaIds?: number[] | undefined;
    isAbleToUpdateServiceFee?: boolean;
    skipDriverTagCalculation?: boolean;
    skipCacheValidation?: boolean;
    recalculateSii?: boolean;
}

export interface SettlementUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface SettlementsExportDailyCommandRequest {
    date?: string;
    bankAccountNumber?: string | undefined;
}

export interface SettlementsExportDailyCommandResult {
    success: boolean;
    errors: string[];
    result?: SettlementsExportDailyCommandResultDetails;
}

export interface SettlementsExportDailyCommandResultDetails {
    mediumId: number;
    fileName: string;
}

export interface SettlementsExportHistoryQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface SettlementsExportHistoryQueryResult {
    success: boolean;
    errors: string[];
    result?: SettlementsExportHistoryQueryResultItemPagedResultBody;
}

export interface SettlementsExportHistoryQueryResultItem {
    id?: number;
    userFullName?: string | undefined;
    exportDate?: string;
    mediumId?: number;
    fileName?: string | undefined;
}

export interface SettlementsExportHistoryQueryResultItemPagedResultBody {
    items: SettlementsExportHistoryQueryResultItem[];
    count: number;
}

export interface SettlementsGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: SettlementsGetDetailsQueryResultDetails;
}

export interface SettlementsGetDetailsQueryResultDetails {
    driverId?: number | undefined;
    dateStart: string;
    dateEnd: string;
    astekCommission: number;
    astekAccountCommission: number;
    ravapiCommission: number;
    comments?: string | undefined;
    paymentTypeId?: PaymentTypeEnum;
    paymentStatusId: PaymentStatusEnum;
    isDeleted?: boolean;
    isAttentionRequired: boolean;
    isMailWasSentToDriver: boolean;
    isMailOrderedToBeSent: boolean;
    settlementNumber?: string | undefined;
    uknownApplicationAccountPhoneNumber?: string | undefined;
    organisationId?: number | undefined;
    organisationName?: string | undefined;
    payoff: SettlementPayoffItem[];
    isManualEditPayoff: boolean;
    areAdvancesIncluded: boolean;
    previousPaymentStatusId?: PaymentStatusEnum;
    previousPaymentStatusModifyDate?: string | undefined;
    modifyUserFullName?: string | undefined;
    userId?: string | undefined;
    settleDailyPayoutsOnceWeek: boolean;
    firstName: string;
    lastName: string;
    commissionCalculationTypeId?: CommissionCalculationTypeEnum;
    expectedRavapiCommission: number;
    expectedAstekCommission: number;
    isManualEditCommissions: boolean;
    isBoltFoodWeeklyTipsImport: boolean;
    excludeFromExport: boolean;
    forceRavapiPaymentsTitle: boolean;
    serviceFee: number;
    toWithdrawQuota: number;
    status: SettlementStatusEnum;
    isDriverWithdrawBlocked: boolean;
    noEarningApplicationSettlementCalculationMethodId: NoEarningApplicationSettlementCalculationMethodEnum;
    lastModificationDate?: string;
    fuelCards: SettlementFuelCardDto[];
    applicationSettlements: ApplicationSettlementGetDetailsQueryResultDetails[];
    id: number;
    bankAccountNumber: string;
    phoneNumber: string;
    email: string;
    hasBeenSettled: boolean;
    isCorrection: boolean;
    preferredPaymentMethod: PreferredPaymentMethodEnum;
    preferredPaymentType: PreferredPaymentTypeEnum;
    driverStatusTags: DriverStatusEnum[];
    preferredPaymentMethodDetails: string;
    media: SettlementFile[];
    vehicleOwnershipId: VehicleOwnershipEnum;
    isCollidingWithAnySettlement: boolean;
    driverOrganisationId: number;
    petrolVatRateId: PetrolVatRateEnum;
    currentVehicle?: IdAndNameResult;
    vehicleFromSettlement?: IdAndNameResult;
}

export interface SettlementsGetPagedQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    phoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    bankAccountNumber?: string | undefined;
    driverId?: number | undefined;
    driverFirstName?: string | undefined;
    driverLastName?: string | undefined;
    organisationId?: number | undefined;
    showDeleted?: boolean;
    paymentStatusId?: PaymentStatusEnum;
    selectedVehicleType?: DriverSelectedVehicleTypeEnum;
    applicationAccountNameOrPhoneNumber?: string | undefined;
    searchStartDate?: string | undefined;
    searchEndDate?: string | undefined;
    settlementNumber?: string | undefined;
    showDrivers?: boolean | undefined;
    periodFilter?: PeriodFilter;
    paymentType?: PaymentTypeEnum;
    toWithdrawFilter?: ToWithdrawFilter;
    b2BFilter?: B2BFilter;
    isCorrection?: boolean | undefined;
    isCreatedByDriver?: boolean | undefined;
    driverCurrentVehicle?: string | undefined;
    vehicleOwnership?: VehicleOwnershipEnum;
    isDriverWithdrawBlocked?: boolean | undefined;
    comments?: string | undefined;
    applications?: ApplicationEnum[] | undefined;
    hrTags?: number[] | undefined;
    petrolVatRateId?: PetrolVatRateEnum;
}

export interface SettlementsGetPagedQueryResult {
    success: boolean;
    errors: string[];
    result?: SettlementsGetPagedQueryResultItemPagedResultBody;
}

export interface SettlementsGetPagedQueryResultItem {
    id?: number;
    driverId?: number | undefined;
    driverFullName?: string | undefined;
    bankAccountNumber?: string | undefined;
    dateStart?: string;
    dateEnd?: string;
    astekCommission?: number;
    astekAccountCommission?: number;
    astekTransportCommission?: number;
    ravapiCommission?: number;
    ravapiTransportCommission?: number;
    minus?: number;
    bonus?: number;
    paymentTypeId?: PaymentTypeEnum;
    paymentStatusId?: PaymentStatusEnum;
    status?: SettlementStatusEnum;
    petrolGross?: number;
    sii?: number;
    includePetrolInSettlementCalculation?: boolean;
    petrolRefund?: number;
    toWithdraw?: number;
    isDeleted?: boolean;
    isMailWasSentToDriver?: boolean;
    comments?: string | undefined;
    applicationSettlement?: ApplicationSettlementItem[] | undefined;
    settlementNumber?: string | undefined;
    organisationName?: string | undefined;
    isManualEditPayoff?: boolean;
    businessToBusiness?: boolean;
    czechiaBankAccountNumber?: string | undefined;
    isCorrection?: boolean;
    isCreatedByDriver?: boolean;
    isBoltFoodWeeklyTipsImport?: boolean;
    excludeFromExport?: boolean;
    forceRavapiPaymentsTitle?: boolean;
    isCollidingWithAnySettlement?: boolean;
    hasBeenSettled?: boolean;
    vehicles: SettlementItemVehicleDto[];
    currentAssignedDriverVehicleName?: string | undefined;
    vehicleNameFromSettlement?: string | undefined;
    vehicleFromSettlementRentingDays: number;
    isCurrentAssignedDriverVehicleOwnedByDriver?: boolean | undefined;
    currentAssignedDriverVehicleOwnership?: VehicleOwnershipEnum;
    serviceFee?: number;
    hasDayOffPayoff?: boolean;
    isDriverWithdrawBlocked?: boolean;
    areAdvancesIncluded?: boolean;
    isMailOrderedToBeSent?: boolean;
    driverPhoneNumbers?: string | undefined;
    driverAge?: number | undefined;
    driverHrTags?: DriverListHrTagDto[] | undefined;
    petrolVatRateId?: PetrolVatRateEnum;
}

export interface SettlementsGetPagedQueryResultItemPagedResultBody {
    items: SettlementsGetPagedQueryResultItem[];
    count: number;
}

export interface SettlementsReferralsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: number;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface SettlementsReferralsQueryResult {
    success: boolean;
    errors: string[];
    result?: SettlementReferralDtoPagedResultBody;
}

export interface SignDigitalDocumentCommand {
    id?: number;
    signatures?: DigitalDocumentSignatureFieldDto[] | undefined;
}

export enum SiiEmploymentTypeEnum {
    OneEighth = 1,
    FullTime = 2,
    HalfTime = 3,
    QuarterTime = 4,
}

export interface SiiQuotaDto {
    underOrEqualTwentySix: number;
    aboveTwentySix: number;
}

export interface SiiSettingDto {
    id: SiiEmploymentTypeEnum;
    advancePaymentLimit: SiiQuotaDto;
    siiQuota: SiiQuotaDto;
    siiLimitQuota: SiiQuotaDto;
    insuredSiiQuota: SiiQuotaDto;
    insuredSiiLimitQuota: SiiQuotaDto;
}

export enum SocialInsuranceOptionEnum {
    Full = 1,
    Minimal = 2,
    Other = 3,
}

export enum SortDirection {
    Asc = 0,
    Desc = 1,
}

export interface SortRequestItem {
    propertyName?: string | undefined;
    sortDirection?: SortDirection;
}

export interface StatisticsBundleBase {
    id?: number;
    bundleName?: string | undefined;
    cards?: StatisticsCardEnum[] | undefined;
}

export enum StatisticsCardEnum {
    VehicleIncidentStatistics = 1,
    DriverPaymentTypeStatusStatistics = 2,
    DriversRegistered = 3,
    DriverPreferredPaymentTypeStatistics = 4,
    VehicleRentStatistics = 5,
    ApplicationSum = 6,
    AccountCommission = 7,
    BezproblemCommission = 8,
    RavapiCommission = 9,
    BezproblemTransportCommission = 10,
    RavapiTransportCommission = 11,
    ToWithdrawSettlementExecuted = 12,
    ApprovedDriversDebtCount = 13,
    ApprovedSettlementsDebtSum = 14,
    SettlementPayoffSums = 15,
    ChartRegisteredDrivers = 16,
    ChartRavapiCommissions = 17,
    ChartBezproblemCommissions = 18,
    ChartBezproblemTransportCommissions = 19,
    ChartRavapiTransportCommissions = 20,
    ChartAccountCommissions = 21,
    ChartApplicationSums = 22,
    ChartApprovedDriversDebtCounts = 23,
    ChartApprovedSettlementsDebtSums = 24,
    ChartSettlementsDailyDriverPaymentTypes = 25,
    ChartSettlementsWeeklyDriverPaymentTypes = 26,
    ChartSettlementPayoffSums = 27,
    ChartToWithdrawSettlementExecuted = 28,
    ResidentCardCommissions = 29,
    ChartResidentCardCommissions = 30,
    LostAssets = 31,
    ApplicationAccounts = 32,
    LostAssetsTable = 33,
    VehiclesCommissionsCountTable = 34,
    ResourceConsumptionTable = 35,
    ResourcesPaidByOrganisation = 36,
    PieChartApplicationAccounts = 37,
    AverageDriversScore = 38,
    DriverRegisterDiscoverySource = 39,
    PayoffReasonsQuota = 40,
    AdditionsNumberAndAmount = 41,
    AdditionsList = 42,
    PostponedCharges = 43,
    CanceledCharges = 44,
    DriversExternalDebtSum = 45,
    ReferralDriverQuantityTable = 46,
    ReferralDriverActiveQuantityTable = 47,
    ReferralDriverRentDaysQuantityTable = 48,
    ReferralDriverPercentagePaidTable = 49,
    ReferralDriverAverageToWithdrawTable = 50,
    ServiceFee = 51,
}

export interface StatisticsCreateBundleCommandRequest {
    id?: number;
    bundleName?: string | undefined;
    cards?: StatisticsCardEnum[] | undefined;
}

export interface StatisticsCreateCardCommandResult {
    success: boolean;
    errors: string[];
}

export interface StatisticsGetBundleDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: StatisticsGetBundleDetailsQueryResultItem;
}

export interface StatisticsGetBundleDetailsQueryResultItem {
    id?: number;
    bundleName?: string | undefined;
    cards?: StatisticsCardEnum[] | undefined;
}

export interface StatisticsGetBundlesQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: StatisticsGetBundlesQueryResultItem[] | undefined;
}

export interface StatisticsGetBundlesQueryResultItem {
    id?: number;
    bundleName?: string | undefined;
    cards?: StatisticsCardEnum[] | undefined;
}

export interface StatisticsGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: StatisticsGetDetailsQueryResultItem;
}

export interface StatisticsGetDetailsQueryResultItem {
    vehicleIncidentStatistics?: VehicleIncidentStatistics[] | undefined;
    driverPaymentTypeStatusStatistics?: DriverPaymentTypeStatusStatistics[] | undefined;
    vehicleRentStatistics?: VehicleRentStatistics[] | undefined;
    driverPreferredPaymentTypeStatistics?: DriverPreferredPaymentTypeStatistics;
    applicationSettlementStatistics?: ApplicationSettlementStatistics[] | undefined;
    lostAssetsByOrganisationStatistics?: LostAssetsByOrganisation[] | undefined;
    vehicleCommissionsTableStatistics?: VehicleCommissionsTableStatistics[] | undefined;
    resourceConsumptionTableStatistics?: ResourceConsumptionTableStatistics[] | undefined;
    additionsNumberAndAmountStatistics?: AdditionsNumberAndAmountStatistics[] | undefined;
    additionsListStatistics?: AdditionsListStatistics[] | undefined;
    canceledPayoffsStatistics?: CanceledPayoffsStatistics[] | undefined;
    postponedPayoffsStatistics?: PostponedPayoffsStatistics[] | undefined;
    referralDriverQuantityStatistics?: ReferralsTotalValuesStatistics[] | undefined;
    referralDriverActiveQuantityStatistics?: ReferralsTotalValuesStatistics[] | undefined;
    referralDriverRentDaysQuantityStatistics?: ReferralsTotalValuesStatistics[] | undefined;
    referralDriverPercentagePaidStatistics?: ReferralsDecimalValuesStatistics[] | undefined;
    referralDriverAverageToWithdrawStatistics?: ReferralsDecimalValuesStatistics[] | undefined;
    averageDriversScore?: AverageDriversScore;
    driversRegistered?: number;
    ravapiCommission?: number;
    serviceFee?: number;
    bezproblemCommission?: number;
    bezproblemAccountCommission?: number;
    ravapiTransportCommission?: number;
    bezproblemTransportCommission?: number;
    applicationSum?: number;
    settlementPayoffSums?: number;
    toWithdrawSettlementExecuted?: number;
    approvedSettlementsDebtSum?: number;
    driversExternalDebtSum?: number;
    approvedDriversDebtCount?: number;
    accountCommission?: number;
    residentCardCommissions?: number;
    lostCommissions?: number;
    resourcesPaidByOrganisation?: number;
    chartRegisteredDrivers?: DateAndValue[] | undefined;
    chartRavapiCommissions?: DateAndValue[] | undefined;
    chartBezproblemCommissions?: DateAndValue[] | undefined;
    chartRavapiTransportCommissions?: DateAndValue[] | undefined;
    chartBezproblemTransportCommissions?: DateAndValue[] | undefined;
    chartAccountCommissions?: DateAndValue[] | undefined;
    chartApplicationSums?: DateAndValue[] | undefined;
    chartApprovedSettlementsDebtSums?: DateAndValue[] | undefined;
    chartApprovedDriversDebtCounts?: DateAndValue[] | undefined;
    chartGrossIncome?: DateAndValue[] | undefined;
    chartToWithdrawSettlementExecuted?: DateAndValue[] | undefined;
    chartResidentCardCommissions?: DateAndValue[] | undefined;
    chartSettlementsWeeklyDriverPaymentTypes?: ExtendedDateAndValue[] | undefined;
    chartSettlementsDailyDriverPaymentTypes?: ExtendedDateAndValue[] | undefined;
    pieChartApplicationSettlements?: ApplicationTypeAndValue[] | undefined;
    driverDiscoverySources: DriverDiscoverySourceEnumInt32IdAndValueData[];
    payoffReasonsQuota: PayoffReasonQuota[];
}

export enum StickerEnum {
    FreeNow = 1,
    Bolt = 2,
    Uber = 3,
}

export interface StringListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: string[] | undefined;
}

export interface StringOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: string | undefined;
}

export enum SupportTicketAssignmentFilterEnum {
    Me = 1,
    Unassigned = 2,
    All = 3,
}

export enum SupportTicketCloseReasonEnum {
    ResolvedByEmployee = 1,
    ResolvedByDriver = 2,
    InvalidRequest = 3,
    Duplicate = 4,
    NoResponse = 5,
}

export interface SupportTicketDetailsDto {
    id?: number;
    organisationId?: number | undefined;
    driverId?: number;
    driverFullName?: string | undefined;
    workCountryId?: WorkCountryEnum;
    driverLanguageId?: DriverLanguageEnum;
    title?: string | undefined;
    aiSummary?: string | undefined;
    statusId?: SupportTicketStatusEnum;
    assignedToUserId?: string | undefined;
    assignedToFullName?: string | undefined;
    assignedAt?: string | undefined;
    closeReasonId?: SupportTicketCloseReasonEnum;
    closeComment?: string | undefined;
    wasHelpful?: boolean | undefined;
    createdAt?: string;
    closedAt?: string | undefined;
    modificationDate?: string;
    isDeleted?: boolean;
    lastMessageContent?: string | undefined;
    lastMessageAuthorName?: string | undefined;
    lastMessageIsFromEmployee?: boolean;
    lastMessageSystemMessageId?: SupportTicketSystemMessageEnum;
    lastMessageCreatedAt?: string | undefined;
    activeUploadPermission?: SupportTicketUploadPermissionDto;
    aiChatHistory?: AiChatMessageDto[] | undefined;
    messages?: SupportTicketMessageDto[] | undefined;
}

export interface SupportTicketDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: SupportTicketDetailsDto;
}

export interface SupportTicketDto {
    id?: number;
    organisationId?: number | undefined;
    driverId?: number;
    driverFullName?: string | undefined;
    workCountryId?: WorkCountryEnum;
    driverLanguageId?: DriverLanguageEnum;
    title?: string | undefined;
    aiSummary?: string | undefined;
    statusId?: SupportTicketStatusEnum;
    assignedToUserId?: string | undefined;
    assignedToFullName?: string | undefined;
    assignedAt?: string | undefined;
    closeReasonId?: SupportTicketCloseReasonEnum;
    closeComment?: string | undefined;
    wasHelpful?: boolean | undefined;
    createdAt?: string;
    closedAt?: string | undefined;
    modificationDate?: string;
    isDeleted?: boolean;
    lastMessageContent?: string | undefined;
    lastMessageAuthorName?: string | undefined;
    lastMessageIsFromEmployee?: boolean;
    lastMessageSystemMessageId?: SupportTicketSystemMessageEnum;
    lastMessageCreatedAt?: string | undefined;
    activeUploadPermission?: SupportTicketUploadPermissionDto;
}

export interface SupportTicketDtoPagedResultBody {
    items: SupportTicketDto[];
    count: number;
}

export interface SupportTicketMessageDto {
    id?: number;
    supportTicketId?: number;
    driverId?: number | undefined;
    userId?: string | undefined;
    authorFullName?: string | undefined;
    content?: string | undefined;
    systemMessageId?: SupportTicketSystemMessageEnum;
    createdAt?: string;
    mediumId?: number | undefined;
    attachmentFileName?: string | undefined;
    attachmentContentType?: string | undefined;
    isAttachmentInDriverFiles?: boolean;
    uploadPermission?: SupportTicketUploadPermissionDto;
}

export interface SupportTicketMessageDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: SupportTicketMessageDto[] | undefined;
}

export enum SupportTicketStatusEnum {
    Open = 1,
    InProgress = 2,
    Closed = 3,
}

export enum SupportTicketSystemMessageEnum {
    EmployeeClaimed = 1,
    EmployeeTakenOver = 2,
    EmployeeClosed = 3,
    DriverClosed = 4,
    AutoClosed = 5,
    EmployeeRestored = 6,
    ActivityCheck = 7,
    UploadPermissionGranted = 8,
    UploadPermissionDriverFinished = 9,
    UploadPermissionLimitReached = 10,
    UploadPermissionEmployeeEnded = 11,
    FileSavedToDriverFiles = 12,
}

export interface SupportTicketUploadPermissionDto {
    id?: number;
    maxFiles?: number;
    sentFiles?: number;
    isActive?: boolean;
}

export enum SupportedLanguage {
    Polish = 0,
    English = 1,
    Ukrainian = 2,
}

export interface SyncDriverToFloviCommand {
    id?: number;
}

export interface TakeOverTicketCommand {
    ticketId?: number;
}

export interface TaxOfficeDictionaryItemDto {
    name?: string | undefined;
    names?: string[] | undefined;
    akronim?: string | undefined;
}

export interface TaxOfficeDictionaryItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: TaxOfficeDictionaryItemDto[] | undefined;
}

export interface TaxQualificationDeclarationResultDto {
    state?: TaxQualificationFlowStateEnum;
    taxOfficeCandidates?: string[] | undefined;
    isAddressCorrectionAvailable?: boolean;
}

export interface TaxQualificationDeclarationResultDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: TaxQualificationDeclarationResultDto;
}

export interface TaxQualificationFlowDto {
    canDeclare?: boolean;
    path?: TaxQualificationPathEnum;
    pesel?: string | undefined;
    isPeselEditable?: boolean;
    town?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    voivodeship?: string | undefined;
    allowFullSocialInsurance?: boolean;
    allowMinimalSocialInsurance?: boolean;
    allowOtherSocialInsurance?: boolean;
    requiresWorkPermit?: boolean;
    siiEmploymentTypeId?: SiiEmploymentTypeEnum;
    canChangeSiiEmploymentType?: boolean;
    contractStartDate?: string | undefined;
    lastModificationDate?: string | undefined;
}

export interface TaxQualificationFlowDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: TaxQualificationFlowDto;
}

export enum TaxQualificationFlowStateEnum {
    NotDeclared = 1,
    Submitted = 2,
    Finished = 3,
    RentOnly = 4,
    StudentCardRequired = 5,
    OfficeVerificationRequired = 6,
    SiiResignation = 7,
    SiiRemoval = 8,
    StudentCardRejected = 9,
    SiiRemovalInProgress = 10,
}

export enum TaxQualificationPathEnum {
    B2B = 1,
    SiiRequest = 2,
    StudentRequest = 3,
    RentOnly = 4,
    SiiResign = 5,
}

export interface TaxQualificationStateDto {
    isApplicable?: boolean;
    state?: TaxQualificationFlowStateEnum;
    path?: TaxQualificationPathEnum;
    siiEmploymentTypeId?: SiiEmploymentTypeEnum;
    contractStartDate?: string | undefined;
    dayOfReportToSSI?: string | undefined;
    isWithdrawBlocked?: boolean;
    canDeclare?: boolean;
    taxOfficeCandidates?: string[] | undefined;
    isAddressCorrectionAvailable?: boolean;
}

export interface TaxQualificationStateDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: TaxQualificationStateDto;
}

export interface TerytCitySuggestionDto {
    name?: string | undefined;
    code?: string | undefined;
    communeName?: string | undefined;
    communeCode?: string | undefined;
    countyName?: string | undefined;
    voivodeshipName?: string | undefined;
    voivodeshipCode?: string | undefined;
}

export interface TerytCitySuggestionDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: TerytCitySuggestionDto[] | undefined;
}

export interface TerytStreetSuggestionDto {
    name?: string | undefined;
    fullName?: string | undefined;
    code?: string | undefined;
    cityName?: string | undefined;
    cityCode?: string | undefined;
    communeCode?: string | undefined;
    countyCode?: string | undefined;
    voivodeshipCode?: string | undefined;
}

export interface TerytStreetSuggestionDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: TerytStreetSuggestionDto[] | undefined;
}

export enum ToWithdrawFilter {
    LessThanZero = 0,
    GreaterOtEqualToZero = 1,
}

export interface TokenDto {
    accessToken: string;
    refreshToken: string;
    expirationDate: string;
}

export interface TokenDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: TokenDto;
}

export interface UpdateArticleCommand {
    articleId?: number;
    title?: string | undefined;
    description?: string | undefined;
    keywords?: string | undefined;
    category?: string | undefined;
    content?: string | undefined;
    modificationDate?: string;
}

export interface UpdateConfigurationCommand {
    isEnabled?: boolean;
    isDriverDataAccessEnabled?: boolean;
    model?: string | undefined;
    maxOutputTokens?: number;
    monthlyBudget?: number;
    dialogsPerDriverPerDay?: number;
    dialogsPerDriverPerHour?: number;
    classificationConfidenceThreshold?: number;
    supportHoursFrom?: string;
    supportHoursTo?: string;
    supportWorksOnMonday?: boolean;
    supportWorksOnTuesday?: boolean;
    supportWorksOnWednesday?: boolean;
    supportWorksOnThursday?: boolean;
    supportWorksOnFriday?: boolean;
    supportWorksOnSaturday?: boolean;
    supportWorksOnSunday?: boolean;
    chatAttachmentRetentionDays?: number;
    isKnowledgeLearningEnabled?: boolean;
    knowledgeLearningIntervalDays?: number;
    knowledgeLearningTicketLimit?: number;
    knowledgeLearningProposalThreshold?: number;
    knowledgeLearningObservationExpiryDays?: number;
    assistantBudgetReservePercent?: number;
}

export interface UpdateDigitalDocumentInQueueCommand {
    document?: DigitalDocumentSignatureDto;
    driverId?: number;
    vehicleId?: number | undefined;
}

export interface UpdateDriverContactFormEmailCommand {
    phoneNumber?: string | undefined;
    email?: string | undefined;
}

export interface UpdateDriverDebtNoteCommand {
    id?: number;
    note?: string | undefined;
    isReplaced?: boolean;
}

export interface UpdateMobileApplicationDriverPersonalInformationCommand {
    bankAccountNumber?: string | undefined;
    preferredLanguage?: DriverLanguageEnum;
}

export interface UpdateMobileApplicationMissingDataCommand {
    pesel?: string | undefined;
    drivingLicenseNumber?: string | undefined;
}

export interface UpdateMyPayoutMethodCommand {
    preferredPaymentTypeId?: PreferredPaymentTypeEnum;
    beginDate?: string;
}

export interface UserAutocompleteDto {
    id?: string;
    fullName?: string | undefined;
}

export interface UserAutocompleteDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: UserAutocompleteDto[] | undefined;
}

export interface UserCreateCommandRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    canMarkPaymentAsExecuted?: boolean;
    haveAccessToAuditArea?: boolean;
    massDeleteSettlements?: boolean;
    sendSettlementEmailsToDrivers?: boolean;
    canDeleteDrivers?: boolean;
    canImportSettlements?: boolean;
    canExportSettlements?: boolean;
    canModifySettlementApplication?: boolean;
    canModifyRavapiBonus?: boolean;
    canModifyPetrolGross?: boolean;
    statisticBundleId?: number | undefined;
    includeInLegalizationMailingList?: boolean;
    canApproveSettlements?: boolean;
    canMoveSettlementBackToWaiting?: boolean;
    canDeletePayoff?: boolean;
    canCancelPayoff?: boolean;
    sendReminderToTakeActionInSII?: boolean;
    canExportRequestForPayment?: boolean;
    haveAccessToReportArea?: boolean;
    canMassSetVehiclesCommission?: boolean;
    canApproveCollidingSettlements?: boolean;
    canApproveDriverCreatedSettlements?: boolean;
    getsEmailsAboutUndefinedSettlementsRequireAttention?: boolean;
    canMassAdjustSettlementCommissions?: boolean;
    canHoldOffSettlementPayoff?: boolean;
    canExportEquipmentReturnRequest?: boolean;
    canExportToPdfProofOfIncome?: boolean;
    canRemoveDriverContactForm?: boolean;
    canChangeStateExcludeFromExportSettlement?: boolean;
    canExportPaymentsSummaryForTax?: boolean;
    canCreateInvoice?: boolean;
    canManualEditDriverSubject?: boolean;
    canChangeVehicleIsIncludedInDayOff?: boolean;
    isExcludedFromDriverDayOffReminderMailingList?: boolean;
    canChangeVehicleCommissions?: boolean;
    canChangeVehicleDiscountedCommissions?: boolean;
    isExcludedFromVehicleCommissionsReminder?: boolean;
    isExcludedFromDuplicatedDriverReminder?: boolean;
    isExcludedFromHrMissingDataReminder?: boolean;
    isExcludedFromAutomaticSettlementReminder?: boolean;
    isExcludedFromB2BVerificationReminder?: boolean;
    isExcludedFromDebtorsListReminder?: boolean;
    isExcludedFromDriversBirthdaysReminder?: boolean;
    canImportPayoffs?: boolean;
    canAssignDigitalPromissoryNoteInReceivingVehicle?: boolean;
    haveAccessToDigitalDocumentsManageArea?: boolean;
    role?: UserRoleEnum;
    organisationIds?: number[] | undefined;
    canManageVehicleDocuments?: boolean;
    canConfirmDriverDocumentsWithoutUploadingFile?: boolean;
    canManageBonusCampaigns?: boolean;
    canRemoveBlockingWithdrawDriverStatusTags?: boolean;
    skipMissingVehicleRentDigitalDocumentsPopupReminder?: boolean;
    isExcludedFromMissingVehicleRentDigitalDocumentsMailReminder?: boolean;
    isExcludedFromMissingVehicleRentDigitalDocumentsMessageNotification?: boolean;
    canChangeStudentValidationStatus?: boolean;
    canEditDriverContractStartDate?: boolean;
    isIncludedInTaxOfficeMultipleResultForDriverEmail?: boolean;
    haveAccessToMailArea?: boolean;
    canAddOrRemoveDriverDayoff?: boolean;
    canManageMailRules?: boolean;
    haveAccessToOnlinePayments?: boolean;
    canSendOnlinePaymentRequestToDebtors?: boolean;
    canRemovePayUPayoffs?: boolean;
    haveAccessToInvitePrograms?: boolean;
    canPublishInviteProgram?: boolean;
    canDeleteInviteProgramDraft?: boolean;
    canDeleteInviteProgram?: boolean;
    canRemoveReferralPayoffs?: boolean;
    canRemoveOnlinePayments?: boolean;
    canSettleDriverViaOnlinePayments?: boolean;
    canEditPayoffOnlinePayment?: boolean;
    canDeleteReferral?: boolean;
    canEditReferral?: boolean;
    haveAccessToReferral?: boolean;
    canAddOnlinePaymentInvoice?: boolean;
    excludeFromCepikLicenseValidationNotification?: boolean;
    canExportDriversToCsv?: boolean;
    excludeFromMissingDriverFilesAfterRegistrationNotification?: boolean;
    haveAccessToMassCampaigns?: boolean;
    canApproveMassCampaigns?: boolean;
    haveFullAccessToEditMassCampaigns?: boolean;
    canSendDriverDataToFlovi?: boolean;
    haveAccessToExportDebtorsForPenaltySummary?: boolean;
    haveAccessToExportsArea?: boolean;
    canExportVehiclePaidRent?: boolean;
    canExportSettlementsReport?: boolean;
    canExportWorkLog?: boolean;
    canExportTakenCashFromSettlements?: boolean;
    canChangeDriverDisableRequestStatus?: boolean;
    canExportUserWithdrawSummary?: boolean;
    canMassDeletePayoffs?: boolean;
    canMassRemoveDriversFromSII?: boolean;
    canMassReportDriversToSII?: boolean;
    canManageVehicleCashback?: boolean;
    canExportPayoffs?: boolean;
    canChangeMobileApplicationDriverFileVisibility?: boolean;
    canSendInvoiceToKSeF?: boolean;
    excludeFromKSeFNotifications?: boolean;
    canClaimSupportTicket?: boolean;
    canTakeOverSupportTicket?: boolean;
    canCloseSupportTicket?: boolean;
    canDeleteSupportTicket?: boolean;
    canMassDeleteSupportTickets?: boolean;
    haveAccessToAiKnowledgeBase?: boolean;
    canManageAiKnowledgeBase?: boolean;
    canMassCancelSiiPayoffs?: boolean;
    canForceRavapiPaymentsTitle?: boolean;
    canMassAddSiiPayoffs?: boolean;
}

export interface UserCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: string;
}

export interface UserGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: UserGetDetailsQueryResultDetails;
}

export interface UserGetDetailsQueryResultDetails {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    canMarkPaymentAsExecuted?: boolean;
    haveAccessToAuditArea?: boolean;
    massDeleteSettlements?: boolean;
    sendSettlementEmailsToDrivers?: boolean;
    canDeleteDrivers?: boolean;
    canImportSettlements?: boolean;
    canExportSettlements?: boolean;
    canModifySettlementApplication?: boolean;
    canModifyRavapiBonus?: boolean;
    canModifyPetrolGross?: boolean;
    statisticBundleId?: number | undefined;
    includeInLegalizationMailingList?: boolean;
    canApproveSettlements?: boolean;
    canMoveSettlementBackToWaiting?: boolean;
    canDeletePayoff?: boolean;
    canCancelPayoff?: boolean;
    sendReminderToTakeActionInSII?: boolean;
    canExportRequestForPayment?: boolean;
    haveAccessToReportArea?: boolean;
    canMassSetVehiclesCommission?: boolean;
    canApproveCollidingSettlements?: boolean;
    canApproveDriverCreatedSettlements?: boolean;
    getsEmailsAboutUndefinedSettlementsRequireAttention?: boolean;
    canMassAdjustSettlementCommissions?: boolean;
    canHoldOffSettlementPayoff?: boolean;
    canExportEquipmentReturnRequest?: boolean;
    canExportToPdfProofOfIncome?: boolean;
    canRemoveDriverContactForm?: boolean;
    canChangeStateExcludeFromExportSettlement?: boolean;
    canExportPaymentsSummaryForTax?: boolean;
    canCreateInvoice?: boolean;
    canManualEditDriverSubject?: boolean;
    canChangeVehicleIsIncludedInDayOff?: boolean;
    isExcludedFromDriverDayOffReminderMailingList?: boolean;
    canChangeVehicleCommissions?: boolean;
    canChangeVehicleDiscountedCommissions?: boolean;
    isExcludedFromVehicleCommissionsReminder?: boolean;
    isExcludedFromDuplicatedDriverReminder?: boolean;
    isExcludedFromHrMissingDataReminder?: boolean;
    isExcludedFromAutomaticSettlementReminder?: boolean;
    isExcludedFromB2BVerificationReminder?: boolean;
    isExcludedFromDebtorsListReminder?: boolean;
    isExcludedFromDriversBirthdaysReminder?: boolean;
    canImportPayoffs?: boolean;
    canAssignDigitalPromissoryNoteInReceivingVehicle?: boolean;
    haveAccessToDigitalDocumentsManageArea?: boolean;
    role?: UserRoleEnum;
    organisationIds?: number[] | undefined;
    canManageVehicleDocuments?: boolean;
    canConfirmDriverDocumentsWithoutUploadingFile?: boolean;
    canManageBonusCampaigns?: boolean;
    canRemoveBlockingWithdrawDriverStatusTags?: boolean;
    skipMissingVehicleRentDigitalDocumentsPopupReminder?: boolean;
    isExcludedFromMissingVehicleRentDigitalDocumentsMailReminder?: boolean;
    isExcludedFromMissingVehicleRentDigitalDocumentsMessageNotification?: boolean;
    canChangeStudentValidationStatus?: boolean;
    canEditDriverContractStartDate?: boolean;
    isIncludedInTaxOfficeMultipleResultForDriverEmail?: boolean;
    haveAccessToMailArea?: boolean;
    canAddOrRemoveDriverDayoff?: boolean;
    canManageMailRules?: boolean;
    haveAccessToOnlinePayments?: boolean;
    canSendOnlinePaymentRequestToDebtors?: boolean;
    canRemovePayUPayoffs?: boolean;
    haveAccessToInvitePrograms?: boolean;
    canPublishInviteProgram?: boolean;
    canDeleteInviteProgramDraft?: boolean;
    canDeleteInviteProgram?: boolean;
    canRemoveReferralPayoffs?: boolean;
    canRemoveOnlinePayments?: boolean;
    canSettleDriverViaOnlinePayments?: boolean;
    canEditPayoffOnlinePayment?: boolean;
    canDeleteReferral?: boolean;
    canEditReferral?: boolean;
    haveAccessToReferral?: boolean;
    canAddOnlinePaymentInvoice?: boolean;
    excludeFromCepikLicenseValidationNotification?: boolean;
    canExportDriversToCsv?: boolean;
    excludeFromMissingDriverFilesAfterRegistrationNotification?: boolean;
    haveAccessToMassCampaigns?: boolean;
    canApproveMassCampaigns?: boolean;
    haveFullAccessToEditMassCampaigns?: boolean;
    canSendDriverDataToFlovi?: boolean;
    haveAccessToExportDebtorsForPenaltySummary?: boolean;
    haveAccessToExportsArea?: boolean;
    canExportVehiclePaidRent?: boolean;
    canExportSettlementsReport?: boolean;
    canExportWorkLog?: boolean;
    canExportTakenCashFromSettlements?: boolean;
    canChangeDriverDisableRequestStatus?: boolean;
    canExportUserWithdrawSummary?: boolean;
    canMassDeletePayoffs?: boolean;
    canMassRemoveDriversFromSII?: boolean;
    canMassReportDriversToSII?: boolean;
    canManageVehicleCashback?: boolean;
    canExportPayoffs?: boolean;
    canChangeMobileApplicationDriverFileVisibility?: boolean;
    canSendInvoiceToKSeF?: boolean;
    excludeFromKSeFNotifications?: boolean;
    canClaimSupportTicket?: boolean;
    canTakeOverSupportTicket?: boolean;
    canCloseSupportTicket?: boolean;
    canDeleteSupportTicket?: boolean;
    canMassDeleteSupportTickets?: boolean;
    haveAccessToAiKnowledgeBase?: boolean;
    canManageAiKnowledgeBase?: boolean;
    canMassCancelSiiPayoffs?: boolean;
    canForceRavapiPaymentsTitle?: boolean;
    canMassAddSiiPayoffs?: boolean;
    id?: string;
}

export enum UserRoleEnum {
    SystemAdmin = 1,
    Admin = 2,
    Specialist = 3,
    DigitalSignatureDevice = 4,
}

export interface UserUpdateCommandRequest {
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    canMarkPaymentAsExecuted?: boolean;
    haveAccessToAuditArea?: boolean;
    massDeleteSettlements?: boolean;
    sendSettlementEmailsToDrivers?: boolean;
    canDeleteDrivers?: boolean;
    canImportSettlements?: boolean;
    canExportSettlements?: boolean;
    canModifySettlementApplication?: boolean;
    canModifyRavapiBonus?: boolean;
    canModifyPetrolGross?: boolean;
    statisticBundleId?: number | undefined;
    includeInLegalizationMailingList?: boolean;
    canApproveSettlements?: boolean;
    canMoveSettlementBackToWaiting?: boolean;
    canDeletePayoff?: boolean;
    canCancelPayoff?: boolean;
    sendReminderToTakeActionInSII?: boolean;
    canExportRequestForPayment?: boolean;
    haveAccessToReportArea?: boolean;
    canMassSetVehiclesCommission?: boolean;
    canApproveCollidingSettlements?: boolean;
    canApproveDriverCreatedSettlements?: boolean;
    getsEmailsAboutUndefinedSettlementsRequireAttention?: boolean;
    canMassAdjustSettlementCommissions?: boolean;
    canHoldOffSettlementPayoff?: boolean;
    canExportEquipmentReturnRequest?: boolean;
    canExportToPdfProofOfIncome?: boolean;
    canRemoveDriverContactForm?: boolean;
    canChangeStateExcludeFromExportSettlement?: boolean;
    canExportPaymentsSummaryForTax?: boolean;
    canCreateInvoice?: boolean;
    canManualEditDriverSubject?: boolean;
    canChangeVehicleIsIncludedInDayOff?: boolean;
    isExcludedFromDriverDayOffReminderMailingList?: boolean;
    canChangeVehicleCommissions?: boolean;
    canChangeVehicleDiscountedCommissions?: boolean;
    isExcludedFromVehicleCommissionsReminder?: boolean;
    isExcludedFromDuplicatedDriverReminder?: boolean;
    isExcludedFromHrMissingDataReminder?: boolean;
    isExcludedFromAutomaticSettlementReminder?: boolean;
    isExcludedFromB2BVerificationReminder?: boolean;
    isExcludedFromDebtorsListReminder?: boolean;
    isExcludedFromDriversBirthdaysReminder?: boolean;
    canImportPayoffs?: boolean;
    canAssignDigitalPromissoryNoteInReceivingVehicle?: boolean;
    haveAccessToDigitalDocumentsManageArea?: boolean;
    role?: UserRoleEnum;
    organisationIds?: number[] | undefined;
    canManageVehicleDocuments?: boolean;
    canConfirmDriverDocumentsWithoutUploadingFile?: boolean;
    canManageBonusCampaigns?: boolean;
    canRemoveBlockingWithdrawDriverStatusTags?: boolean;
    skipMissingVehicleRentDigitalDocumentsPopupReminder?: boolean;
    isExcludedFromMissingVehicleRentDigitalDocumentsMailReminder?: boolean;
    isExcludedFromMissingVehicleRentDigitalDocumentsMessageNotification?: boolean;
    canChangeStudentValidationStatus?: boolean;
    canEditDriverContractStartDate?: boolean;
    isIncludedInTaxOfficeMultipleResultForDriverEmail?: boolean;
    haveAccessToMailArea?: boolean;
    canAddOrRemoveDriverDayoff?: boolean;
    canManageMailRules?: boolean;
    haveAccessToOnlinePayments?: boolean;
    canSendOnlinePaymentRequestToDebtors?: boolean;
    canRemovePayUPayoffs?: boolean;
    haveAccessToInvitePrograms?: boolean;
    canPublishInviteProgram?: boolean;
    canDeleteInviteProgramDraft?: boolean;
    canDeleteInviteProgram?: boolean;
    canRemoveReferralPayoffs?: boolean;
    canRemoveOnlinePayments?: boolean;
    canSettleDriverViaOnlinePayments?: boolean;
    canEditPayoffOnlinePayment?: boolean;
    canDeleteReferral?: boolean;
    canEditReferral?: boolean;
    haveAccessToReferral?: boolean;
    canAddOnlinePaymentInvoice?: boolean;
    excludeFromCepikLicenseValidationNotification?: boolean;
    canExportDriversToCsv?: boolean;
    excludeFromMissingDriverFilesAfterRegistrationNotification?: boolean;
    haveAccessToMassCampaigns?: boolean;
    canApproveMassCampaigns?: boolean;
    haveFullAccessToEditMassCampaigns?: boolean;
    canSendDriverDataToFlovi?: boolean;
    haveAccessToExportDebtorsForPenaltySummary?: boolean;
    haveAccessToExportsArea?: boolean;
    canExportVehiclePaidRent?: boolean;
    canExportSettlementsReport?: boolean;
    canExportWorkLog?: boolean;
    canExportTakenCashFromSettlements?: boolean;
    canChangeDriverDisableRequestStatus?: boolean;
    canExportUserWithdrawSummary?: boolean;
    canMassDeletePayoffs?: boolean;
    canMassRemoveDriversFromSII?: boolean;
    canMassReportDriversToSII?: boolean;
    canManageVehicleCashback?: boolean;
    canExportPayoffs?: boolean;
    canChangeMobileApplicationDriverFileVisibility?: boolean;
    canSendInvoiceToKSeF?: boolean;
    excludeFromKSeFNotifications?: boolean;
    canClaimSupportTicket?: boolean;
    canTakeOverSupportTicket?: boolean;
    canCloseSupportTicket?: boolean;
    canDeleteSupportTicket?: boolean;
    canMassDeleteSupportTickets?: boolean;
    haveAccessToAiKnowledgeBase?: boolean;
    canManageAiKnowledgeBase?: boolean;
    canMassCancelSiiPayoffs?: boolean;
    canForceRavapiPaymentsTitle?: boolean;
    canMassAddSiiPayoffs?: boolean;
    id?: string;
}

export interface UserUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: string;
}

export interface UsersGetPagedQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
}

export interface UsersGetPagedQueryResult {
    success: boolean;
    errors: string[];
    result?: UsersGetPagedQueryResultItemPagedResultBody;
}

export interface UsersGetPagedQueryResultItem {
    id?: string;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    role?: UserRoleEnum;
    includeInLegalizationMailingList?: boolean;
}

export interface UsersGetPagedQueryResultItemPagedResultBody {
    items: UsersGetPagedQueryResultItem[];
    count: number;
}

export enum VehicleCashbackMassOperationEnum {
    Enable = 1,
    Disable = 2,
    Update = 3,
}

export interface VehicleCommissionsTableStatistics {
    organisationId?: number;
    organisationName?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    brand?: string | undefined;
    ravapiCommission?: number;
    astekCommission?: number;
    quantity?: number;
}

export interface VehicleDeleteCommandResult {
    success: boolean;
    errors: string[];
}

export interface VehicleDetailsForDriverAutocompleteDto {
    vehicleId?: number;
    vin?: string | undefined;
    model?: string | undefined;
    brand?: string | undefined;
    vehicleType?: VehicleTypeEnum;
    isVehicleShared?: boolean;
    currentDrivers?: IdAndNameResult[] | undefined;
    vehicleStatus?: VehicleStatusEnum;
}

export interface VehicleDocumentDto {
    place?: string | undefined;
    organisationId?: number;
    documentId?: number;
    vehicleId?: number;
}

export interface VehicleDocumentListDto {
    id?: number;
    vehicleId?: number;
    place?: string | undefined;
    documentId?: number;
    documentName?: string | undefined;
    organisationId?: number;
    organisationName?: string | undefined;
}

export interface VehicleDocumentListDtoPagedResultBody {
    items: VehicleDocumentListDto[];
    count: number;
}

export interface VehicleDocumentListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    vehicleId?: number | undefined;
}

export interface VehicleDocumentListQueryResult {
    success: boolean;
    errors: string[];
    result?: VehicleDocumentListDtoPagedResultBody;
}

export interface VehicleDocumentUpdateCommand {
    id?: number;
    vehicleDocumentDto?: VehicleDocumentDto;
}

export enum VehicleDriverHistoryExcludeDigitalSignatureTypeEnum {
    Transfer = 1,
    Receive = 2,
    All = 3,
}

export interface VehicleDriverShareDto {
    id: number;
    fullName: string;
    value: number;
    isVehicleHistoryShouldEndToday: boolean;
    previousVehicleDetails?: VehicleDetailsForDriverAutocompleteDto;
    documentsQueue: DigitalDocumentQueueDto[];
}

export interface VehicleDriversDigitalDocumentsDto {
    id: number;
    itemUniqueId: string;
    name: string;
    type: VehicleTypeEnum;
    documentGroupType: DigitalDocumentGroupTypeEnum;
    drivers: DigitalDocumentQueueDriverDto[];
    documents: DigitalDocumentQueueDto[];
    driverSignatureStatuses: DigitalDocumentQueueStatusDto[];
    bonusCampaigns: BonusCampaignDto[];
}

export interface VehicleDriversDigitalDocumentsDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleDriversDigitalDocumentsDto[] | undefined;
}

export interface VehicleEntryListItemDto {
    vehicleLogId?: number | undefined;
    hasWorklog: boolean;
    drivers: IdAndNameResult[];
    date?: string;
    driverEarnings?: number;
    restPayoffSum?: number;
    commissions?: number;
    hasBeenSettled: boolean;
    hasPayoffs: boolean;
    hasWeeklyPayoff: boolean;
    targetNotAccomplished?: boolean;
    vehicleLogEventId?: VehicleLogEventEnum;
    vehicleOwnershipId?: VehicleOwnershipEnum;
    percentageEarning: number;
    serviceShortName: string;
    serviceName: string;
    icons?: VehicleLogIconDto[] | undefined;
    incidents?: VehicleLogIncidentListItemDto[] | undefined;
    comment?: string | undefined;
    wasScheduled: boolean;
    hasDayOffPayoff: boolean;
    hasPrePaymentCommissions: boolean;
}

export interface VehicleFeesDto {
    scooters?: number;
    bikes?: number;
    cars?: number;
    eBikes?: number;
    readonly total?: number;
}

export enum VehicleFormStatusEnum {
    NotLodged = 1,
    Lodged = 2,
    Issued = 3,
}

export enum VehicleFundingTypeEnum {
    Cash = 1,
    Leasing = 2,
    Loan = 3,
    Rent = 4,
}

export interface VehicleGetAllDriversHistoryQueryRequest {
    driverId?: number | undefined;
    vehicleId?: number | undefined;
}

export interface VehicleGetAllDriversHistoryQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleGetAllDriversHistoryQueryResultDetails[] | undefined;
}

export interface VehicleGetAllDriversHistoryQueryResultDetails {
    vehicleId?: number | undefined;
    driverId?: number | undefined;
    driverFullName?: string | undefined;
    vehicleReqistrationPlate?: string | undefined;
    from?: string | undefined;
    to?: string | undefined;
    commission?: number | undefined;
    digitalDocuments?: DigitalDocumentDriverHistoryDto[] | undefined;
    excludeTypeFromRequiredDigitalSignature?: VehicleDriverHistoryExcludeDigitalSignatureTypeEnum;
    showExcludeTypeFromRequiredDigitalSignature?: boolean;
}

export interface VehicleIdAndNameResult {
    id: number;
    name: string;
    organisationId?: number | undefined;
}

export interface VehicleIncidentBase {
    id?: number;
    date?: string;
    description?: string | undefined;
    serviceName?: string | undefined;
    serviceShortName?: string | undefined;
    mileage?: number | undefined;
    type?: VehicleIncidentTypeEnum;
    driverId?: number | undefined;
    drivers: DriverNameDto[];
    driverFullName?: string | undefined;
    media?: FileNameAndId[] | undefined;
    relatedVehicleIncidentId?: number | undefined;
    lostCommissionRavapi: number;
    lostCommissionBezproblem: number;
    vehicleLogs: VehicleLogSimple[];
    sendWorkshopReminder: boolean;
    time: string;
}

export interface VehicleIncidentDto {
    id?: number;
    date?: string;
    vehicleIncidentType?: VehicleIncidentTypeEnum;
    description?: string | undefined;
}

export interface VehicleIncidentDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleIncidentDto[] | undefined;
}

export interface VehicleIncidentSimpleBase {
    vehicleId?: number;
    date?: string;
    description?: string | undefined;
    vehicleIncidentTypeId?: VehicleIncidentTypeEnum;
}

export interface VehicleIncidentStatistics {
    vehicleIncidentTypeEnum?: VehicleIncidentTypeEnum;
    readonly incident?: string | undefined;
    cars?: number;
    eBikes?: number;
    bikes?: number;
    readonly sum?: number;
}

export enum VehicleIncidentTypeEnum {
    Crash = 1,
    Fee = 2,
    Workshop = 3,
    Failure = 4,
    Other = 5,
    Convey = 6,
    Return = 7,
    TownTransfer = 8,
    Theft = 9,
    BackToFleet = 10,
    Maintain = 11,
    ReceiveFromWorkshop = 12,
    PeriodicVehicleInspection = 13,
}

export interface VehicleListDocumentDto {
    name?: string | undefined;
    place?: string | undefined;
    organisation?: string | undefined;
}

export interface VehicleLogAddEventDto {
    id?: number;
    vehicleId?: number;
    drivers: DriverNameDto[];
    vehicleIncidentId?: number | undefined;
    date?: string;
    vehicleLogEventId?: VehicleLogEventEnum;
}

export interface VehicleLogDetailsDriverListItemDto {
    id: number;
    balance: number;
    earnings: number;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    settlements: VehicleLogDetailsSettlementListItemDto[];
    payoffs: VehicleLogDetailsPayoffListItemDto[];
}

export interface VehicleLogDetailsDto {
    date?: string;
    vehicleName?: string | undefined;
    vehicleTypeId: VehicleTypeEnum;
    registrationNumber?: string | undefined;
    vinNumber?: string | undefined;
    organizationName?: string | undefined;
    ravapiCommission: number;
    bezproblemCommission: number;
    comment?: string | undefined;
    vehicleLogCommentId?: number | undefined;
    hasBeenSettled: boolean;
    isVehicleInUse: boolean;
    vehicleOwnershipId?: VehicleOwnershipEnum;
    drivers: VehicleLogDetailsDriverListItemDto[];
    incidents: VehicleIncidentBase[];
}

export interface VehicleLogDetailsDtoOperationResult {
    success: boolean;
    errors: string[];
    result?: VehicleLogDetailsDto;
}

export interface VehicleLogDetailsPayoffListItemDto {
    id?: number;
    driverId?: number | undefined;
    quota: number;
    restPayoff: number;
    reason: string;
    payoffReasonId: PayoffReasonEnum;
    date?: string | undefined;
}

export interface VehicleLogDetailsSettlementListItemDto {
    id?: number;
    driverId?: number | undefined;
    settlementNumber?: string | undefined;
    payoffAmount: number;
    paymentStatusId: PaymentStatusEnum;
}

export enum VehicleLogEventEnum {
    SentToService = 1,
    ReceiveFromService = 2,
    Stolen = 3,
    Reserved = 4,
}

export interface VehicleLogEventListItemDto {
    vehicleLogId?: number;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    vehicleLogEventId?: VehicleLogEventEnum;
    serviceShortName?: string | undefined;
    serviceName?: string | undefined;
    drivers?: IdAndNameResult[] | undefined;
}

export interface VehicleLogIconDto {
    id?: number;
    driverId?: number | undefined;
    vehicleId?: number | undefined;
    date?: string | undefined;
    iconSchema: VehicleLogIconSchemaDto;
}

export interface VehicleLogIconSchemaDto {
    id?: number;
    iconName?: string | undefined;
    iconText?: string | undefined;
    iconColor?: string | undefined;
}

export interface VehicleLogIconSchemaDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleLogIconSchemaDto[] | undefined;
}

export interface VehicleLogIncidentListItemDto {
    id: number;
    vehicleIncidentTypeId: VehicleIncidentTypeEnum;
    description: string;
    date: string;
}

export interface VehicleLogListItemDto {
    vehicleId?: number;
    vehicleName?: string | undefined;
    vehicleTypeId?: VehicleTypeEnum;
    ravapiCommission?: number;
    bezproblemCommission?: number;
    driversVehicleOwnership?: VehicleOwnershipEnum;
    isCommissionEqualDistributed: boolean;
    currentDrivers: VehicleDriverShareDto[];
    isVehicleShared: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    vehicleCurrentStatus?: VehicleStatusEnum;
    returnDateEnd?: string | undefined;
    vehicleLogEventList?: VehicleLogEventListItemDto[] | undefined;
    vehicleLogIncidentList?: VehicleLogIncidentListItemDto[] | undefined;
    vehicleLogEntryList?: VehicleEntryListItemDto[] | undefined;
    prePaymentVehicleRent?: VehicleLogPrePaymentVehicleRentListItemDto;
}

export interface VehicleLogListItemDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleLogListItemDto[] | undefined;
}

export interface VehicleLogPrePaymentVehicleRentListItemDto {
    vehicleId: number;
    dateStart: string;
    dateEnd: string;
    driver: IdAndNameResult;
}

export interface VehicleLogSimple {
    id?: number;
    vehicleLogEventType?: VehicleLogEventEnum;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface VehicleMassChangeIncludedInPromotionDayOffCommand {
    ids?: number[] | undefined;
    state?: boolean;
}

export interface VehicleMassSetCommissionCommand {
    ids: number[];
    ravapiCommission?: number | undefined;
    bezproblemCommission?: number | undefined;
    ravapiSharedCommission?: number | undefined;
    bezproblemSharedCommission?: number | undefined;
    ravapiDiscountedCommission?: number | undefined;
    bezproblemDiscountedCommission?: number | undefined;
}

export enum VehicleNameEnum {
    ToyotaYaris = 1,
    ToyotaAygo = 2,
    ToyotaCorolla = 3,
    ToyotaYarisCross = 4,
    ToyotaCHR = 5,
    Duotts = 6,
    FunBike = 7,
    RavapiBike = 8,
    Indiana = 9,
    Kross = 10,
    MultiCycle = 11,
    OneSport = 12,
    Overfly = 13,
    HusarE = 14,
    Husar = 15,
    Hogan = 16,
    RockRider = 17,
    HondaPCX = 18,
    HondaVision = 19,
    HopCity = 20,
    Amperi = 21,
}

export enum VehicleOwnershipEnum {
    OwnedOrRented = 1,
    RentedFromCarrier = 2,
    OwnedByCarrier = 3,
}

export interface VehicleRentOverdueDigitalDocumentsDto {
    id: number;
    vehicleId: number;
    vehicleOrganisationId: number;
    vehicleOrganisationName: string;
    vehicleName: string;
    vehicleType?: VehicleTypeEnum;
    driverId: number;
    driverFullName: string;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    item: string;
    documents: DigitalDocumentTypeEnum[];
}

export interface VehicleRentOverdueDigitalDocumentsDtoListOperationResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleRentOverdueDigitalDocumentsDto[] | undefined;
}

export interface VehicleRentReferralDto {
    id?: number;
    driverId?: number;
    driverFullName?: string | undefined;
    vehicleId?: number;
    vehicle?: string | undefined;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
    readonly rentDays?: number;
}

export interface VehicleRentReferralDtoPagedResultBody {
    items: VehicleRentReferralDto[];
    count: number;
}

export interface VehicleRentReferralsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    id?: number;
    dateStart?: string | undefined;
    dateEnd?: string | undefined;
}

export interface VehicleRentReferralsQueryResult {
    success: boolean;
    errors: string[];
    result?: VehicleRentReferralDtoPagedResultBody;
}

export interface VehicleRentStatistics {
    typeId?: number;
    readonly type?: string | undefined;
    cars?: number;
    carsAtLeastOne?: number;
    eBikes?: number;
    eBikesAtLeastOne?: number;
    bikes?: number;
    bikesAtLeastOne?: number;
    motors?: number;
    motorsAtLeastOne?: number;
    readonly sum?: number;
    readonly sumAtLeastOne?: number;
}

export interface VehicleReturnSettingDto {
    id: VehicleTypeEnum;
    value: number;
}

export interface VehicleSharingInformationDto {
    vehicleOwnershipEnum?: VehicleOwnershipEnum;
    isCommissionEqualDistributed: boolean;
    newDrivers: VehicleDriverShareDto[];
    oldDrivers: VehicleDriverShareDto[];
}

export enum VehicleStatusEnum {
    Available = 1,
    Busy = 2,
    InWorkshop = 3,
    ReceivingFromWorkshop = 4,
    Theft = 5,
}

export enum VehicleTypeEnum {
    Car = 1,
    ElectricBike = 2,
    Bike = 3,
    Motor = 4,
}

export interface VehicleUpdateIncidentsCommand {
    vehicleIncidents?: VehicleIncidentBase[] | undefined;
    vehicleId?: number;
    driverIds?: number[] | undefined;
    date?: string | undefined;
}

export interface VehicleUpdateReturnDateCommand {
    id?: number;
    returnDate?: string | undefined;
}

export interface VehiclesCreateCommandRequest {
    organisationId?: number | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    registrationNumber?: string | undefined;
    vin?: string | undefined;
    productionDate?: string | undefined;
    isOwnedByDriver?: boolean;
    taxiLamp?: string | undefined;
    taxiExcerpt?: string | undefined;
    taxiExcerptLodgedDate?: string | undefined;
    visInspectionDate?: string | undefined;
    endDateOfLiabilityInsurance?: string | undefined;
    ravapiCommission?: number;
    astekCommission?: number;
    ravapiSharedCommission: number;
    bezproblemSharedCommission: number;
    ravapiDiscountedCommission: number;
    bezproblemDiscountedCommission: number;
    formStatus?: VehicleFormStatusEnum;
    type?: VehicleTypeEnum;
    isInsured?: boolean;
    insuranceDetails?: string | undefined;
    founder?: string | undefined;
    sharingInformation: VehicleSharingInformationDto;
    isVehicleShared: boolean;
    driverName?: string | undefined;
    vehicleFundingType?: VehicleFundingTypeEnum;
    incidents?: VehicleIncidentBase[] | undefined;
    isDeleted?: boolean;
    comments?: string | undefined;
    isTheft: boolean;
    reservedDriverFullName?: string | undefined;
    reservationFrom?: string;
    reservationTo?: string | undefined;
    isVehicleHistoryShouldEndToday: boolean;
    vehicleStatus: VehicleStatusEnum;
    isIncludedInPromotionDayOff: boolean;
    haveDayOffPromotionAccess: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    stickerId?: StickerEnum;
    customSticker?: string | undefined;
    lastModificationDate?: string;
    returnDateStart?: string | undefined;
    returnDateEnd?: string | undefined;
    cashbackAmount?: number | undefined;
    cashbackRequiredDays?: number | undefined;
    readonly isCashbackEnabled?: boolean;
    mediaIds?: number[] | undefined;
}

export interface VehiclesCreateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export interface VehiclesDocumentListDto {
    id?: number;
    vehicleId?: number;
    place?: string | undefined;
    documentId?: number;
    documentName?: string | undefined;
    organisationId?: number;
    organisationName?: string | undefined;
    vehicleName?: string | undefined;
    vehicleOrganisationName?: string | undefined;
}

export interface VehiclesDocumentListDtoPagedResultBody {
    items: VehiclesDocumentListDto[];
    count: number;
}

export interface VehiclesDocumentListQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    vehicleId?: number;
    vehicleName?: string | undefined;
    organisationId?: number | undefined;
    documentName?: string | undefined;
    checkDifferentOrganisation?: boolean;
    place?: string | undefined;
}

export interface VehiclesDocumentListQueryResult {
    success: boolean;
    errors: string[];
    result?: VehiclesDocumentListDtoPagedResultBody;
}

export interface VehiclesGetAllQueryRequest {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    registrationNumber?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    type?: VehicleTypeEnum;
    formStatus?: VehicleFormStatusEnum;
    organisationId?: number | undefined;
    showDeleted?: boolean;
    driverFullName?: string | undefined;
    isOwnedByDriver?: boolean;
    vehicleStatus?: VehicleStatusEnum;
    sticker?: StickerEnum;
    customSticker?: string | undefined;
    comments?: string | undefined;
}

export interface VehiclesGetAllQueryResult {
    success: boolean;
    errors: string[];
    result?: VehiclesGetAllQueryResultItemPagedResultBody;
}

export interface VehiclesGetAllQueryResultItem {
    id?: number;
    organisation?: string | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    registrationNumber?: string | undefined;
    vin?: string | undefined;
    productionDate?: string | undefined;
    isOwnedByDriver?: boolean;
    taxiLamp?: string | undefined;
    taxiExcerpt?: string | undefined;
    taxiExcerptLodgedDate?: string | undefined;
    visInspectionDate?: string | undefined;
    endDateOfLiabilityInsurance?: string | undefined;
    ravapiCommission?: number;
    astekCommission?: number;
    ravapiDiscountedCommission?: number;
    bezproblemDiscountedCommission?: number;
    formStatus?: VehicleFormStatusEnum;
    type?: VehicleTypeEnum;
    isInsured?: boolean;
    driver?: string | undefined;
    drivers?: string[] | undefined;
    vehicleFundingType?: VehicleFundingTypeEnum;
    isDeleted?: boolean;
    incident?: VehicleIncidentSimpleBase;
    comments?: string | undefined;
    incidentLastDate?: string | undefined;
    vehicleStatus?: VehicleStatusEnum;
    vehicleIncidents?: VehicleIncidentDto[] | undefined;
    vehicleDocuments?: VehicleListDocumentDto[] | undefined;
    sticker?: string | undefined;
    isCashbackEnabled?: boolean;
    cashbackRequiredDays?: number | undefined;
    cashbackAmount?: number | undefined;
}

export interface VehiclesGetAllQueryResultItemPagedResultBody {
    items: VehiclesGetAllQueryResultItem[];
    count: number;
}

export interface VehiclesGetDetailsQueryResult {
    success: boolean;
    errors: string[];
    result?: VehiclesGetDetailsQueryResultDetails;
}

export interface VehiclesGetDetailsQueryResultDetails {
    organisationId?: number | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    registrationNumber?: string | undefined;
    vin?: string | undefined;
    productionDate?: string | undefined;
    isOwnedByDriver?: boolean;
    taxiLamp?: string | undefined;
    taxiExcerpt?: string | undefined;
    taxiExcerptLodgedDate?: string | undefined;
    visInspectionDate?: string | undefined;
    endDateOfLiabilityInsurance?: string | undefined;
    ravapiCommission?: number;
    astekCommission?: number;
    ravapiSharedCommission: number;
    bezproblemSharedCommission: number;
    ravapiDiscountedCommission: number;
    bezproblemDiscountedCommission: number;
    formStatus?: VehicleFormStatusEnum;
    type?: VehicleTypeEnum;
    isInsured?: boolean;
    insuranceDetails?: string | undefined;
    founder?: string | undefined;
    sharingInformation: VehicleSharingInformationDto;
    isVehicleShared: boolean;
    driverName?: string | undefined;
    vehicleFundingType?: VehicleFundingTypeEnum;
    incidents?: VehicleIncidentBase[] | undefined;
    isDeleted?: boolean;
    comments?: string | undefined;
    isTheft: boolean;
    reservedDriverFullName?: string | undefined;
    reservationFrom?: string;
    reservationTo?: string | undefined;
    isVehicleHistoryShouldEndToday: boolean;
    vehicleStatus: VehicleStatusEnum;
    isIncludedInPromotionDayOff: boolean;
    haveDayOffPromotionAccess: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    stickerId?: StickerEnum;
    customSticker?: string | undefined;
    lastModificationDate?: string;
    returnDateStart?: string | undefined;
    returnDateEnd?: string | undefined;
    cashbackAmount?: number | undefined;
    cashbackRequiredDays?: number | undefined;
    readonly isCashbackEnabled?: boolean;
    id: number;
    media: FileNameAndId[];
}

export interface VehiclesGetForDriverAutocompleteQueryRequest {
    searchPhrase?: string | undefined;
    driverId?: number | undefined;
}

export interface VehiclesGetForDriverAutocompleteQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: VehiclesGetForDriverAutocompleteQueryResultDetails[] | undefined;
}

export interface VehiclesGetForDriverAutocompleteQueryResultDetails {
    id: number;
    name: string;
    assignedTo: number;
    isOwnedByDriver: boolean;
    vehicleOrganisationId: number;
    vehicleOrganisationCode: string;
    vehicleStatus: VehicleStatusEnum;
    vehicleDrivers: DriverNameDto[];
    readonly disabled: boolean;
}

export interface VehiclesGetIdsAndNamesQueryResult {
    success: boolean;
    errors: string[];
    readonly result?: VehicleIdAndNameResult[] | undefined;
}

export interface VehiclesUpdateCommandRequest {
    organisationId?: number | undefined;
    brand?: string | undefined;
    model?: string | undefined;
    registrationNumber?: string | undefined;
    vin?: string | undefined;
    productionDate?: string | undefined;
    isOwnedByDriver?: boolean;
    taxiLamp?: string | undefined;
    taxiExcerpt?: string | undefined;
    taxiExcerptLodgedDate?: string | undefined;
    visInspectionDate?: string | undefined;
    endDateOfLiabilityInsurance?: string | undefined;
    ravapiCommission?: number;
    astekCommission?: number;
    ravapiSharedCommission: number;
    bezproblemSharedCommission: number;
    ravapiDiscountedCommission: number;
    bezproblemDiscountedCommission: number;
    formStatus?: VehicleFormStatusEnum;
    type?: VehicleTypeEnum;
    isInsured?: boolean;
    insuranceDetails?: string | undefined;
    founder?: string | undefined;
    sharingInformation: VehicleSharingInformationDto;
    isVehicleShared: boolean;
    driverName?: string | undefined;
    vehicleFundingType?: VehicleFundingTypeEnum;
    incidents?: VehicleIncidentBase[] | undefined;
    isDeleted?: boolean;
    comments?: string | undefined;
    isTheft: boolean;
    reservedDriverFullName?: string | undefined;
    reservationFrom?: string;
    reservationTo?: string | undefined;
    isVehicleHistoryShouldEndToday: boolean;
    vehicleStatus: VehicleStatusEnum;
    isIncludedInPromotionDayOff: boolean;
    haveDayOffPromotionAccess: boolean;
    haveAccessToVehicleRentDigitalDocuments: boolean;
    stickerId?: StickerEnum;
    customSticker?: string | undefined;
    lastModificationDate?: string;
    returnDateStart?: string | undefined;
    returnDateEnd?: string | undefined;
    cashbackAmount?: number | undefined;
    cashbackRequiredDays?: number | undefined;
    readonly isCashbackEnabled?: boolean;
    id?: number;
    mediaIds?: number[] | undefined;
}

export interface VehiclesUpdateCommandResult {
    success: boolean;
    errors: string[];
    readonly result?: number;
}

export enum WithdrawBlockReasonEnum {
    Bailiff = 1,
    MissingTaxQualification = 2,
    MissingFilesAfterRegistration = 3,
    ExpiredStudentCard = 4,
    MissingSelfInvoicingPermission = 5,
    Inactive = 6,
    OfficeDecision = 7,
}

export enum WorkCountryEnum {
    Poland = 1,
    Czechia = 2,
}

export interface WorkLogListItemDto {
    id?: number;
    date?: string;
    applicationQuota?: number;
    promotion?: number;
    tips?: number;
    netBonus?: number;
    minus?: number;
    commission?: number;
    remainingTax?: number;
    grossBonus?: number;
    application?: ApplicationEnum;
    driverId?: number | undefined;
    driver?: string | undefined;
    vehicleId?: number | undefined;
    vehicle?: string | undefined;
    applicationAccountId?: number | undefined;
    applicationAccount?: string | undefined;
}

export interface WorkLogListItemDtoPagedResultBody {
    items: WorkLogListItemDto[];
    count: number;
}

export interface WorkLogsQuery {
    propertiesNames?: string[] | undefined;
    skip?: number;
    take?: number;
    sortItems?: SortRequestItem[] | undefined;
    driverId?: number | undefined;
    applicationAccountId?: number | undefined;
    vehicleId?: number | undefined;
}

export interface WorkLogsQueryResult {
    success: boolean;
    errors: string[];
    result?: WorkLogListItemDtoPagedResultBody;
}

export interface Body {
    File?: string;
    FileTypeId?: FileTypeEnum;

    [key: string]: any;
}

export interface Body2 {
    TicketId?: number;
    File?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}